(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './supabase-kt-supabase-kt.js', './kotlinx-coroutines-core.js', './ktor-ktor-http.js', './ktor-ktor-utils.js', './ktor-ktor-client-core.js', './kotlinx-serialization-kotlinx-serialization-json.js', './kotlinx-serialization-kotlinx-serialization-core.js', './cryptography-kotlin-cryptography-random.js', './okio-parent-okio.js', './MultiplatformSettings-multiplatform-settings-coroutines.js', './MultiplatformSettings-multiplatform-settings-no-arg.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./supabase-kt-supabase-kt.js'), require('./kotlinx-coroutines-core.js'), require('./ktor-ktor-http.js'), require('./ktor-ktor-utils.js'), require('./ktor-ktor-client-core.js'), require('./kotlinx-serialization-kotlinx-serialization-json.js'), require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./cryptography-kotlin-cryptography-random.js'), require('./okio-parent-okio.js'), require('./MultiplatformSettings-multiplatform-settings-coroutines.js'), require('./MultiplatformSettings-multiplatform-settings-no-arg.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-auth-kt'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'supabase-kt-auth-kt'.");
    }
    if (typeof globalThis['supabase-kt-supabase-kt'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-auth-kt'. Its dependency 'supabase-kt-supabase-kt' was not found. Please, check whether 'supabase-kt-supabase-kt' is loaded prior to 'supabase-kt-auth-kt'.");
    }
    if (typeof globalThis['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-auth-kt'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'supabase-kt-auth-kt'.");
    }
    if (typeof globalThis['ktor-ktor-http'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-auth-kt'. Its dependency 'ktor-ktor-http' was not found. Please, check whether 'ktor-ktor-http' is loaded prior to 'supabase-kt-auth-kt'.");
    }
    if (typeof globalThis['ktor-ktor-utils'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-auth-kt'. Its dependency 'ktor-ktor-utils' was not found. Please, check whether 'ktor-ktor-utils' is loaded prior to 'supabase-kt-auth-kt'.");
    }
    if (typeof globalThis['ktor-ktor-client-core'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-auth-kt'. Its dependency 'ktor-ktor-client-core' was not found. Please, check whether 'ktor-ktor-client-core' is loaded prior to 'supabase-kt-auth-kt'.");
    }
    if (typeof globalThis['kotlinx-serialization-kotlinx-serialization-json'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-auth-kt'. Its dependency 'kotlinx-serialization-kotlinx-serialization-json' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-json' is loaded prior to 'supabase-kt-auth-kt'.");
    }
    if (typeof globalThis['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-auth-kt'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'supabase-kt-auth-kt'.");
    }
    if (typeof globalThis['cryptography-kotlin-cryptography-random'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-auth-kt'. Its dependency 'cryptography-kotlin-cryptography-random' was not found. Please, check whether 'cryptography-kotlin-cryptography-random' is loaded prior to 'supabase-kt-auth-kt'.");
    }
    if (typeof globalThis['okio-parent-okio'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-auth-kt'. Its dependency 'okio-parent-okio' was not found. Please, check whether 'okio-parent-okio' is loaded prior to 'supabase-kt-auth-kt'.");
    }
    if (typeof globalThis['MultiplatformSettings-multiplatform-settings-coroutines'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-auth-kt'. Its dependency 'MultiplatformSettings-multiplatform-settings-coroutines' was not found. Please, check whether 'MultiplatformSettings-multiplatform-settings-coroutines' is loaded prior to 'supabase-kt-auth-kt'.");
    }
    if (typeof globalThis['MultiplatformSettings-multiplatform-settings-no-arg'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-auth-kt'. Its dependency 'MultiplatformSettings-multiplatform-settings-no-arg' was not found. Please, check whether 'MultiplatformSettings-multiplatform-settings-no-arg' is loaded prior to 'supabase-kt-auth-kt'.");
    }
    globalThis['supabase-kt-auth-kt'] = factory(typeof globalThis['supabase-kt-auth-kt'] === 'undefined' ? {} : globalThis['supabase-kt-auth-kt'], globalThis['kotlin-kotlin-stdlib'], globalThis['supabase-kt-supabase-kt'], globalThis['kotlinx-coroutines-core'], globalThis['ktor-ktor-http'], globalThis['ktor-ktor-utils'], globalThis['ktor-ktor-client-core'], globalThis['kotlinx-serialization-kotlinx-serialization-json'], globalThis['kotlinx-serialization-kotlinx-serialization-core'], globalThis['cryptography-kotlin-cryptography-random'], globalThis['okio-parent-okio'], globalThis['MultiplatformSettings-multiplatform-settings-coroutines'], globalThis['MultiplatformSettings-multiplatform-settings-no-arg']);
  }
}(function (_, kotlin_kotlin, kotlin_io_github_jan_tennert_supabase_supabase_kt, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core, kotlin_io_ktor_ktor_http, kotlin_io_ktor_ktor_utils, kotlin_io_ktor_ktor_client_core, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_dev_whyoleg_cryptography_cryptography_random, kotlin_com_squareup_okio_okio, kotlin_com_russhwolf_multiplatform_settings_coroutines, kotlin_com_russhwolf_multiplatform_settings_no_arg) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var VOID = kotlin_kotlin.$_$.d;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var CoroutineImpl = kotlin_kotlin.$_$.xd;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.gd;
  var isInterface = kotlin_kotlin.$_$.rg;
  var protoOf = kotlin_kotlin.$_$.eh;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.eg;
  var System_instance = kotlin_kotlin.$_$.c3;
  var LogLevel_ERROR_getInstance = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.e;
  var toString = kotlin_kotlin.$_$.hp;
  var Companion_getInstance = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.a;
  var StringMasking_getInstance = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.b;
  var trimIndent = kotlin_kotlin.$_$.km;
  var Companion_getInstance_0 = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.c;
  var LogLevel_DEBUG_getInstance = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.d;
  var Exception = kotlin_kotlin.$_$.gn;
  var equals = kotlin_kotlin.$_$.sf;
  var FunctionAdapter = kotlin_kotlin.$_$.cf;
  var hashCode = kotlin_kotlin.$_$.bg;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var initMetadataForLambda = kotlin_kotlin.$_$.hg;
  var constructCallableReference = kotlin_kotlin.$_$.of;
  var listOf = kotlin_kotlin.$_$.ta;
  var setup = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.u;
  var SupabasePluginProvider = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.v;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var MainPlugin = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.s;
  var initMetadataForInterface = kotlin_kotlin.$_$.gg;
  var getKClass = kotlin_kotlin.$_$.si;
  var toString_0 = kotlin_kotlin.$_$.hh;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.w5;
  var MainConfig = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.q;
  var Companion_getInstance_1 = kotlin_kotlin.$_$.d3;
  var DurationUnit_SECONDS_getInstance = kotlin_kotlin.$_$.t3;
  var toDuration = kotlin_kotlin.$_$.tm;
  var Enum = kotlin_kotlin.$_$.en;
  var substringAfter = kotlin_kotlin.$_$.jl;
  var toLong = kotlin_kotlin.$_$.bm;
  var toDuration_0 = kotlin_kotlin.$_$.sm;
  var Duration__times_impl_sfuzvp = kotlin_kotlin.$_$.m;
  var Duration__toString_impl_8d916b = kotlin_kotlin.$_$.o;
  var delay = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.y;
  var emptyList = kotlin_kotlin.$_$.c9;
  var launch = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.q3;
  var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.y2;
  var LogLevel_INFO_getInstance = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.f;
  var Companion_getInstance_2 = kotlin_io_ktor_ktor_http.$_$.h;
  var contentType = kotlin_io_ktor_ktor_http.$_$.o1;
  var PrimitiveClasses_getInstance = kotlin_kotlin.$_$.b3;
  var arrayOf = kotlin_kotlin.$_$.fo;
  var createKType = kotlin_kotlin.$_$.qi;
  var TypeInfo = kotlin_io_ktor_ktor_utils.$_$.l;
  var OutgoingContent = kotlin_io_ktor_ktor_http.$_$.t;
  var NullBody_instance = kotlin_io_ktor_ktor_http.$_$.a;
  var parameter = kotlin_io_ktor_ktor_client_core.$_$.v;
  var JsonObject = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.j;
  var JsonObjectBuilder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.i;
  var get_supabaseJson = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.a1;
  var serializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.f3;
  var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t2;
  var get_jsonObject = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.q;
  var putJsonObject = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.z;
  var Application_getInstance = kotlin_io_ktor_ktor_http.$_$.b;
  var bodyAsText = kotlin_io_ktor_ktor_client_core.$_$.f;
  var replace = kotlin_kotlin.$_$.xk;
  var SupabaseEncodingException = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.l;
  var MissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u2;
  var isBlank = kotlin_kotlin.$_$.dk;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.p5;
  var put = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.v;
  var RestException = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.k;
  var Long = kotlin_kotlin.$_$.kn;
  var equalsLong = kotlin_kotlin.$_$.oe;
  var ensureActive = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.m3;
  var SerializationException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.x2;
  var UnknownRestException = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.n;
  var BadRequestRestException = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.i;
  var Companion_getInstance_3 = kotlin_io_ktor_ktor_http.$_$.j;
  var UnauthorizedRestException = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.m;
  var MutableStateFlow = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.s1;
  var asStateFlow = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.v1;
  var MutableSharedFlow = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.r1;
  var asSharedFlow = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.u1;
  var SupervisorJob = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.g3;
  var CoroutineScope_0 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.x2;
  var supabaseApi = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.p;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.w4;
  var encodeURLParameter = kotlin_io_ktor_ktor_http.$_$.r1;
  var joinToString = kotlin_kotlin.$_$.aa;
  var resolveUrl = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.r;
  var DurationUnit_MINUTES_getInstance = kotlin_kotlin.$_$.r3;
  var AtomicReference = kotlin_kotlin.$_$.ed;
  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q;
  var ArrayListSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.y1;
  var LazyThreadSafetyMode_PUBLICATION_getInstance = kotlin_kotlin.$_$.v3;
  var lazy = kotlin_kotlin.$_$.so;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.g2;
  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.w;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a2;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b2;
  var initMetadataForObject = kotlin_kotlin.$_$.ig;
  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.n2;
  var objectCreate = kotlin_kotlin.$_$.dh;
  var StringCompanionObject_instance = kotlin_kotlin.$_$.y2;
  var serializer_0 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b1;
  var buildClassSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o1;
  var JsonDecoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.e;
  var get_jsonPrimitive = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.r;
  var Default_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.a;
  var ensureNotNull = kotlin_kotlin.$_$.lo;
  var UnsupportedOperationException_init_$Create$ = kotlin_kotlin.$_$.n6;
  var getStringHashCode = kotlin_kotlin.$_$.ag;
  var SerializableWith = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.w2;
  var putJsonObject_0 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.t;
  var Default_getInstance_0 = kotlin_dev_whyoleg_cryptography_cryptography_random.$_$.a;
  var Default_getInstance_1 = kotlin_kotlin.$_$.r2;
  var Companion_getInstance_4 = kotlin_com_squareup_okio_okio.$_$.a;
  var encodeToByteArray = kotlin_kotlin.$_$.tj;
  var SupabaseClient = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.y;
  var getBooleanHashCode = kotlin_kotlin.$_$.vf;
  var KFunctionImpl = kotlin_kotlin.$_$.ni;
  var HttpResponse = kotlin_io_ktor_ktor_client_core.$_$.y;
  var initMetadataForFunctionReference = kotlin_kotlin.$_$.fg;
  var bearerAuth = kotlin_io_ktor_ktor_client_core.$_$.s;
  var SupabaseApi = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.o;
  var enumEntries = kotlin_kotlin.$_$.ae;
  var captureStack = kotlin_kotlin.$_$.gf;
  var Url = kotlin_io_ktor_ktor_http.$_$.e1;
  var Exception_init_$Init$ = kotlin_kotlin.$_$.h5;
  var LongSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p;
  var lazy_0 = kotlin_kotlin.$_$.to;
  var Companion_getInstance_5 = kotlin_kotlin.$_$.e3;
  var createAnnotatedEnumSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.i2;
  var SerializerFactory = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.h2;
  var getKClassFromExpression = kotlin_kotlin.$_$.ri;
  var contentEquals = kotlin_kotlin.$_$.h8;
  var contentHashCode = kotlin_kotlin.$_$.i8;
  var listOf_0 = kotlin_kotlin.$_$.sa;
  var JsonPrimitive = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.k;
  var KtList = kotlin_kotlin.$_$.e7;
  var createInvariantKTypeProjection = kotlin_kotlin.$_$.oi;
  var JsonArray = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.d;
  var KProperty1 = kotlin_kotlin.$_$.yi;
  var getPropertyCallableRef = kotlin_kotlin.$_$.zf;
  var JsonNull = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.h;
  var createSimpleEnumSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.j2;
  var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a1;
  var Json = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.l;
  var PaddingOption_ABSENT_getInstance = kotlin_kotlin.$_$.p3;
  var split = kotlin_kotlin.$_$.cl;
  var decodeToString = kotlin_kotlin.$_$.pj;
  var FlowCollector = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.p1;
  var Flow = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.q1;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.a4;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.j4;
  var STRING_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c;
  var PrimitiveSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.i1;
  var serializer_1 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.d3;
  var JsonEncoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.g;
  var SealedClassSerializer_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.uo;
  var Companion_instance = kotlin_kotlin.$_$.j3;
  var createFailure = kotlin_kotlin.$_$.ko;
  var _Result___init__impl__xyqfz8 = kotlin_kotlin.$_$.z;
  var Result__exceptionOrNull_impl_p6xea9 = kotlin_kotlin.$_$.a1;
  var LogLevel_WARNING_getInstance = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.g;
  var JsonObjectSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.c;
  var BooleanSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.j;
  var NoSuchElementException_init_$Create$ = kotlin_kotlin.$_$.d6;
  var emptyMap = kotlin_kotlin.$_$.d9;
  var getOrNull = kotlin_kotlin.$_$.t9;
  var to = kotlin_kotlin.$_$.ip;
  var toMap = kotlin_kotlin.$_$.oc;
  var IllegalArgumentException = kotlin_kotlin.$_$.hn;
  var URLBuilder = kotlin_io_ktor_ktor_http.$_$.a1;
  var first = kotlin_kotlin.$_$.o9;
  var InstantSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.n;
  var KotlinXSerializer = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.w;
  var toSuspendSettings = kotlin_com_russhwolf_multiplatform_settings_coroutines.$_$.a;
  var PlatformUtils_getInstance = kotlin_io_ktor_ktor_utils.$_$.a;
  var removeSuffix = kotlin_kotlin.$_$.sk;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.q;
  var replace_0 = kotlin_kotlin.$_$.yk;
  var Settings = kotlin_com_russhwolf_multiplatform_settings_no_arg.$_$.a;
  var substring = kotlin_kotlin.$_$.ol;
  var contains = kotlin_kotlin.$_$.oj;
  //endregion
  //region block: pre-declaration
  initMetadataForCoroutine($resolveAccessTokenCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($checkAccessTokenCOROUTINE$, CoroutineImpl);
  initMetadataForInterface(ResolveAccessToken, 'ResolveAccessToken', VOID, VOID, VOID, [2]);
  initMetadataForClass(sam$io_github_jan_supabase_auth_api_ResolveAccessToken$0, 'sam$io_github_jan_supabase_auth_api_ResolveAccessToken$0', VOID, VOID, [ResolveAccessToken, FunctionAdapter], [2]);
  initMetadataForLambda(Auth$Companion$defaultResolveAccessToken$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForCompanion(Companion, VOID, [SupabasePluginProvider]);
  function signUpWith$default(provider, redirectUrl, config, $completion, $super) {
    redirectUrl = redirectUrl === VOID ? defaultRedirectUrl(this) : redirectUrl;
    config = config === VOID ? null : config;
    return $super === VOID ? this.uvy(provider, redirectUrl, config, $completion) : $super.uvy.call(this, provider, redirectUrl, config, $completion);
  }
  function signInWith$default(provider, redirectUrl, config, $completion, $super) {
    redirectUrl = redirectUrl === VOID ? defaultRedirectUrl(this) : redirectUrl;
    config = config === VOID ? null : config;
    return $super === VOID ? this.wvy(provider, redirectUrl, config, $completion) : $super.wvy.call(this, provider, redirectUrl, config, $completion);
  }
  function updateUser$default(updateCurrentUser, redirectUrl, config, $completion, $super) {
    updateCurrentUser = updateCurrentUser === VOID ? true : updateCurrentUser;
    redirectUrl = redirectUrl === VOID ? defaultRedirectUrl(this) : redirectUrl;
    return $super === VOID ? this.yvy(updateCurrentUser, redirectUrl, config, $completion) : $super.yvy.call(this, updateCurrentUser, redirectUrl, config, $completion);
  }
  function resetPasswordForEmail$default(email, redirectUrl, captchaToken, $completion, $super) {
    redirectUrl = redirectUrl === VOID ? defaultRedirectUrl(this) : redirectUrl;
    captchaToken = captchaToken === VOID ? null : captchaToken;
    return $super === VOID ? this.avz(email, redirectUrl, captchaToken, $completion) : $super.avz.call(this, email, redirectUrl, captchaToken, $completion);
  }
  function signOut$default(scope, $completion, $super) {
    scope = scope === VOID ? SignOutScope_LOCAL_getInstance() : scope;
    return $super === VOID ? this.dvz(scope, $completion) : $super.dvz.call(this, scope, $completion);
  }
  function importSession$default(session, autoRefresh, source, $completion, $super) {
    autoRefresh = autoRefresh === VOID ? this.ebw().bvx_1 : autoRefresh;
    source = source === VOID ? Unknown_instance : source;
    return $super === VOID ? this.fvz(session, autoRefresh, source, $completion) : $super.fvz.call(this, session, autoRefresh, source, $completion);
  }
  function exchangeCodeForSession$default(code, saveSession, $completion, $super) {
    saveSession = saveSession === VOID ? true : saveSession;
    return $super === VOID ? this.jvz(code, saveSession, $completion) : $super.jvz.call(this, code, saveSession, $completion);
  }
  function getOAuthUrl$default(provider, redirectUrl, url, additionalConfig, $super) {
    redirectUrl = redirectUrl === VOID ? defaultRedirectUrl(this) : redirectUrl;
    url = url === VOID ? 'authorize' : url;
    var tmp;
    if (additionalConfig === VOID) {
      tmp = Auth$getOAuthUrl$lambda;
    } else {
      tmp = additionalConfig;
    }
    additionalConfig = tmp;
    return $super === VOID ? this.lvz(provider, redirectUrl, url, additionalConfig) : $super.lvz.call(this, provider, redirectUrl, url, additionalConfig);
  }
  function currentAccessTokenOrNull() {
    var tmp0_safe_receiver = this.ovw();
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.pvw_1;
  }
  function currentSessionOrNull() {
    var status = this.svy().u1();
    var tmp;
    if (status instanceof Authenticated) {
      tmp = status.nvz_1;
    } else {
      tmp = null;
    }
    return tmp;
  }
  function currentUserOrNull() {
    var tmp0_safe_receiver = this.ovw();
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.vvw_1;
  }
  initMetadataForInterface(Auth, 'Auth', VOID, VOID, [MainPlugin], [3, 2, 4, 0, 1]);
  initMetadataForClass(AuthConfigDefaults, 'AuthConfigDefaults', AuthConfigDefaults, MainConfig);
  initMetadataForClass(FlowType, 'FlowType', VOID, Enum);
  initMetadataForLambda(AuthImpl$recreateSessionJob$slambda$slambda, CoroutineImpl, VOID, [0]);
  initMetadataForLambda(AuthImpl$recreateSessionJob$slambda$slambda_1, CoroutineImpl, VOID, [0]);
  initMetadataForLambda(AuthImpl$recreateSessionJob$slambda$slambda_3, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AuthImpl$init$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AuthImpl$init$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AuthImpl$signInWith$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AuthImpl$signUpWith$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AuthImpl$recreateSessionJob$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AuthImpl$checkErrorCodes$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AuthImpl$preparePKCEIfEnabled$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($updateUserCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($resetPasswordForEmailCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($signOutCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($retrieveUserCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($exchangeCodeForSessionCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($refreshSessionCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($refreshCurrentSessionCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($importSessionCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($recreateSessionJobCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($tryImportingSessionCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($handleExpiredSessionCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($loadFromStorageCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($parseErrorResponseCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($clearSessionCOROUTINE$, CoroutineImpl);
  initMetadataForClass(AuthImpl, 'AuthImpl', VOID, VOID, [Auth], [3, 2, 4, 0, 1]);
  initMetadataForClass(MemoryCodeVerifierCache, 'MemoryCodeVerifierCache', MemoryCodeVerifierCache, VOID, VOID, [1, 0]);
  initMetadataForCompanion(Companion_0);
  initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(WeakPassword, 'WeakPassword', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
  initMetadataForCompanion(Companion_1, VOID, [KSerializer]);
  initMetadataForClass(GoTrueErrorResponse, 'GoTrueErrorResponse', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_8});
  initMetadataForClass(OptionalJsonObjectModifier, 'OptionalJsonObjectModifier');
  initMetadataForClass(MemorySessionManager, 'MemorySessionManager', MemorySessionManager, VOID, VOID, [1, 0]);
  initMetadataForClass(SessionRefreshInformation, 'SessionRefreshInformation');
  initMetadataForClass(SignOutScope, 'SignOutScope', VOID, Enum);
  initMetadataForInterface(UrlLauncher, 'UrlLauncher', VOID, VOID, VOID, [2]);
  initMetadataForClass(sam$io_github_jan_supabase_auth_UrlLauncher$0, 'sam$io_github_jan_supabase_auth_UrlLauncher$0', VOID, VOID, [UrlLauncher, FunctionAdapter], [2]);
  initMetadataForLambda(UrlLauncher$Companion$DEFAULT$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForCompanion(Companion_2);
  initMetadataForCoroutine($tryToGetUserCOROUTINE$, CoroutineImpl);
  initMetadataForClass(AdminApiImpl, 'AdminApiImpl', VOID, VOID, VOID, [2, 1, 3]);
  initMetadataForClass(sam$io_github_jan_supabase_auth_api_ResolveAccessToken$0_0, 'sam$io_github_jan_supabase_auth_api_ResolveAccessToken$0', VOID, VOID, [ResolveAccessToken, FunctionAdapter], [2]);
  initMetadataForLambda(AuthenticatedApiConfig$Builder$build$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForClass(Context, 'Context');
  initMetadataForClass(Auth_0, 'Auth');
  initMetadataForClass(Request, 'Request', Request);
  initMetadataForClass(Builder, 'Builder', Builder);
  initMetadataForClass(AuthenticatedApiConfig, 'AuthenticatedApiConfig');
  initMetadataForFunctionReference(MainPlugin$parseErrorResponse$ref, KFunctionImpl, VOID, [1]);
  initMetadataForCompanion(Companion_3);
  initMetadataForCoroutine($rawRequestCOROUTINE$, CoroutineImpl);
  initMetadataForClass(AuthenticatedSupabaseApi, 'AuthenticatedSupabaseApi', VOID, SupabaseApi, VOID, [0, 2, 1]);
  initMetadataForClass(OtpError, 'OtpError');
  initMetadataForClass(RefreshFailure, 'RefreshFailure');
  initMetadataForCompanion(Companion_4);
  initMetadataForClass(AuthErrorCode, 'AuthErrorCode', VOID, Enum);
  initMetadataForClass(AuthRestException, 'AuthRestException', VOID, RestException);
  initMetadataForCompanion(Companion_5);
  initMetadataForClass(AuthSessionMissingException, 'AuthSessionMissingException', VOID, AuthRestException);
  initMetadataForCompanion(Companion_6);
  initMetadataForClass(AuthWeakPasswordException, 'AuthWeakPasswordException', VOID, AuthRestException);
  initMetadataForClass(SessionRequiredException, 'SessionRequiredException', VOID, Exception);
  initMetadataForClass(TokenExpiredException, 'TokenExpiredException', TokenExpiredException, Exception);
  initMetadataForCompanion(Companion_7);
  initMetadataForObject($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(AMREntry, 'AMREntry', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
  initMetadataForCompanion(Companion_8, VOID, [SerializerFactory]);
  initMetadataForClass(AMRMethod, 'AMRMethod', VOID, Enum, VOID, VOID, VOID, {0: Companion_getInstance_15});
  initMetadataForClass(ClaimsResponse, 'ClaimsResponse');
  initMetadataForClass(JwtPayload, 'JwtPayload');
  initMetadataForClass(Algorithm, 'Algorithm', VOID, Enum);
  initMetadataForCompanion(Companion_9);
  initMetadataForObject($serializer_1, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(JwtHeader, 'JwtHeader', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
  initMetadataForClass(JWTData, 'JWTData');
  initMetadataForObject(JWTUtils, 'JWTUtils');
  initMetadataForObject(SharedJwkCache, 'SharedJwkCache', VOID, VOID, VOID, [0, 1]);
  initMetadataForClass(MfaLevel, 'MfaLevel');
  initMetadataForCompanion(Companion_10, VOID, [SerializerFactory]);
  initMetadataForClass(AuthenticatorAssuranceLevel, 'AuthenticatorAssuranceLevel', VOID, Enum, VOID, VOID, VOID, {0: Companion_getInstance_17});
  function getAuthenticatorAssuranceLevel$default(jwt, $super) {
    jwt = jwt === VOID ? null : jwt;
    return $super === VOID ? this.bwj(jwt) : $super.bwj.call(this, jwt);
  }
  initMetadataForInterface(MfaApi, 'MfaApi', VOID, VOID, VOID, [3, 1, 2, 4, 0]);
  initMetadataForLambda(MfaApiImpl$statusFlow$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$, CoroutineImpl);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForClass(MfaApiImpl$statusFlow$$inlined$map$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForClass(MfaApiImpl, 'MfaApiImpl', VOID, VOID, [MfaApi], [3, 2, 4, 1, 0]);
  initMetadataForClass(MfaStatus, 'MfaStatus');
  initMetadataForClass(ExternalAuthConfigDefaults, 'ExternalAuthConfigDefaults', ExternalAuthConfigDefaults);
  initMetadataForCompanion(Companion_11, VOID, [KSerializer]);
  initMetadataForClass(OAuthProvider, 'OAuthProvider', VOID, VOID, VOID, [4]);
  initMetadataForClass(IDTokenProvider, 'IDTokenProvider', VOID, OAuthProvider, VOID, [4], VOID, {0: Companion_getInstance_18});
  initMetadataForCompanion(Companion_12);
  initMetadataForLambda(OAuthProvider$login$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForObject(Google, 'Google', VOID, IDTokenProvider, VOID, [4]);
  initMetadataForObject(CaptchaTokenSerializer, 'CaptchaTokenSerializer', VOID, VOID, [KSerializer]);
  initMetadataForCompanion(Companion_13, VOID, [SerializerFactory]);
  initMetadataForClass(Config, 'Config', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_20});
  initMetadataForCoroutine($loginCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($signUpCOROUTINE$, CoroutineImpl);
  function login(supabaseClient, onSuccess, redirectUrl, config, $completion) {
    var tmp = new $loginCOROUTINE$(this, supabaseClient, onSuccess, redirectUrl, config, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function signUp(supabaseClient, onSuccess, redirectUrl, config, $completion) {
    var tmp = new $signUpCOROUTINE$(this, supabaseClient, onSuccess, redirectUrl, config, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  initMetadataForInterface(DefaultAuthProvider, 'DefaultAuthProvider', VOID, VOID, VOID, [4]);
  initMetadataForCompanion(Companion_14);
  initMetadataForObject($serializer_2, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(Config_0, 'Config', Config_0, Config, VOID, VOID, VOID, {0: $serializer_getInstance_2});
  initMetadataForObject(Email, 'Email', VOID, VOID, [DefaultAuthProvider], [4]);
  initMetadataForCompanion(Companion_15);
  initMetadataForObject($serializer_3, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(Config_1, 'Config', Config_1, Config, VOID, VOID, VOID, {0: $serializer_getInstance_3});
  initMetadataForObject(IDToken, 'IDToken', VOID, VOID, [DefaultAuthProvider], [4]);
  initMetadataForCompanion(Companion_16);
  initMetadataForObject($serializer_4, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForCompanion(Companion_17, VOID, [KSerializer, SerializerFactory]);
  initMetadataForClass(Config_2, 'Config', Config_2, Config, VOID, VOID, VOID, {0: $serializer_getInstance_4});
  initMetadataForClass(Channel, 'Channel', VOID, Enum, VOID, VOID, VOID, {0: Companion_getInstance_24});
  initMetadataForObject(Phone, 'Phone', VOID, VOID, [DefaultAuthProvider], [4]);
  initMetadataForInterface(RefreshFailureCause, 'RefreshFailureCause');
  initMetadataForClass(NetworkError, 'NetworkError', VOID, VOID, [RefreshFailureCause]);
  initMetadataForClass(InternalServerError, 'InternalServerError', VOID, VOID, [RefreshFailureCause]);
  initMetadataForObject(Storage, 'Storage');
  initMetadataForClass(SignIn, 'SignIn');
  initMetadataForClass(SignUp, 'SignUp');
  initMetadataForObject(External, 'External');
  initMetadataForObject(Unknown, 'Unknown');
  initMetadataForClass(Refresh, 'Refresh');
  initMetadataForClass(UserChanged, 'UserChanged');
  initMetadataForInterface(SessionStatus, 'SessionStatus');
  initMetadataForClass(NotAuthenticated, 'NotAuthenticated', NotAuthenticated, VOID, [SessionStatus]);
  initMetadataForObject(Initializing, 'Initializing', VOID, VOID, [SessionStatus]);
  initMetadataForClass(RefreshFailure_0, 'RefreshFailure', VOID, VOID, [SessionStatus]);
  initMetadataForClass(Authenticated, 'Authenticated', VOID, VOID, [SessionStatus]);
  initMetadataForObject(ErrorFound, 'ErrorFound');
  initMetadataForClass(SessionFound, 'SessionFound');
  initMetadataForObject(Skipped, 'Skipped');
  initMetadataForObject($serializer_5, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(Identity, 'Identity', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_5});
  initMetadataForCompanion(Companion_18);
  initMetadataForObject($serializer_6, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(UserInfo, 'UserInfo', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_6});
  initMetadataForObject($serializer_7, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(UserMfaFactor, 'UserMfaFactor', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_7});
  initMetadataForCompanion(Companion_19);
  initMetadataForObject($serializer_8, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(UserSession, 'UserSession', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_8});
  initMetadataForCompanion(Companion_20);
  initMetadataForObject($serializer_9, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(UserUpdateBuilder, 'UserUpdateBuilder', UserUpdateBuilder, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_9});
  initMetadataForCoroutine($startExternalAuthCOROUTINE$, CoroutineImpl);
  initMetadataForCompanion(Companion_21);
  initMetadataForClass(SettingsCodeVerifierCache, 'SettingsCodeVerifierCache', SettingsCodeVerifierCache, VOID, VOID, [1, 0]);
  initMetadataForCompanion(Companion_22);
  initMetadataForCoroutine($loadSessionCOROUTINE$, CoroutineImpl);
  initMetadataForClass(SettingsSessionManager, 'SettingsSessionManager', SettingsSessionManager, VOID, VOID, [1, 0]);
  initMetadataForClass(AuthConfig, 'AuthConfig', AuthConfig, AuthConfigDefaults);
  initMetadataForClass(BrowserBridgeImpl, 'BrowserBridgeImpl', BrowserBridgeImpl);
  initMetadataForClass(ExternalAuthConfig, 'ExternalAuthConfig', ExternalAuthConfig, ExternalAuthConfigDefaults);
  initMetadataForCoroutine($setupPlatformCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($handlePKCECodeCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($handleHashSessionCOROUTINE$, CoroutineImpl);
  //endregion
  function resolveAccessToken(_this__u8e3s4, jwtToken, keyAsFallback, $completion) {
    jwtToken = jwtToken === VOID ? null : jwtToken;
    keyAsFallback = keyAsFallback === VOID ? true : keyAsFallback;
    var tmp = new $resolveAccessTokenCOROUTINE$(_this__u8e3s4, jwtToken, keyAsFallback, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function checkAccessToken(_this__u8e3s4, token, $completion) {
    var tmp = new $checkAccessTokenCOROUTINE$(_this__u8e3s4, token, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function resolveAccessToken_0(_this__u8e3s4, plugin, keyAsFallback, $completion) {
    keyAsFallback = keyAsFallback === VOID ? true : keyAsFallback;
    return resolveAccessToken(_this__u8e3s4, plugin.ebw().xvn_1, keyAsFallback, $completion);
  }
  function $resolveAccessTokenCOROUTINE$(_this__u8e3s4, jwtToken, keyAsFallback, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.uvv_1 = _this__u8e3s4;
    this.vvv_1 = jwtToken;
    this.wvv_1 = keyAsFallback;
  }
  protoOf($resolveAccessTokenCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 7;
            this.xvv_1 = this.wvv_1 ? this.uvv_1.svj() : null;
            var tmp0_elvis_lhs = this.vvv_1;
            if (tmp0_elvis_lhs == null) {
              var tmp1_safe_receiver = this.uvv_1.xvj();
              if (tmp1_safe_receiver == null) {
                this.cvw_1 = null;
                this.n9_1 = 2;
                continue $sm;
              } else {
                this.n9_1 = 1;
                suspendResult = tmp1_safe_receiver(this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              this.bvw_1 = tmp0_elvis_lhs;
              this.n9_1 = 3;
              continue $sm;
            }

          case 1:
            this.cvw_1 = suspendResult;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.bvw_1 = this.cvw_1;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            var tmp2_elvis_lhs = this.bvw_1;
            if (tmp2_elvis_lhs == null) {
              var tmp0 = this.uvv_1.tvj();
              var provider = Companion_getInstance_6();
              var tmp_0 = tmp0.wvk_1.w2(provider.t1());
              var tmp3_safe_receiver = (!(tmp_0 == null) ? isInterface(tmp_0, Auth) : false) ? tmp_0 : null;
              var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.nvw();
              if (tmp4_safe_receiver == null) {
                this.zvv_1 = null;
                this.n9_1 = 5;
                continue $sm;
              } else {
                this.avw_1 = tmp4_safe_receiver;
                var it = this.avw_1;
                this.n9_1 = 4;
                suspendResult = checkAccessToken(this.uvv_1, it, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              this.yvv_1 = tmp2_elvis_lhs;
              this.n9_1 = 6;
              continue $sm;
            }

          case 4:
            this.zvv_1 = this.avw_1;
            this.n9_1 = 5;
            continue $sm;
          case 5:
            this.yvv_1 = this.zvv_1;
            this.n9_1 = 6;
            continue $sm;
          case 6:
            var tmp5_elvis_lhs = this.yvv_1;
            return tmp5_elvis_lhs == null ? this.xvv_1 : tmp5_elvis_lhs;
          case 7:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 7) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $checkAccessTokenCOROUTINE$(_this__u8e3s4, token, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.lvw_1 = _this__u8e3s4;
    this.mvw_1 = token;
  }
  protoOf($checkAccessTokenCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            var tmp0 = this.lvw_1.tvj();
            var provider = Companion_getInstance_6();
            var tmp_0 = tmp0.wvk_1.w2(provider.t1());
            var tmp0_elvis_lhs = (!(tmp_0 == null) ? isInterface(tmp_0, Auth) : false) ? tmp_0 : null;
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              return Unit_instance;
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            var auth = tmp_1;
            var currentSession = auth.ovw();
            var now = System_instance.fp();
            var tmp_2;
            if (this.mvw_1 === (currentSession == null ? null : currentSession.pvw_1)) {
              tmp_2 = currentSession.xvw_1.aq(now) < 0;
            } else {
              tmp_2 = false;
            }

            var sessionExistsAndExpired = tmp_2;
            var autoRefreshEnabled = auth.ebw().bvx_1;
            if (sessionExistsAndExpired && autoRefreshEnabled) {
              var autoRefreshRunning = auth.svx();
              var tmp0_0 = Companion_getInstance_6().wvx_1;
              var level = LogLevel_ERROR_getInstance();
              var tmp0_elvis_lhs_0 = tmp0_0.fsu();
              if (level.i3(tmp0_elvis_lhs_0 == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs_0) >= 0) {
                tmp0_0.fvj(level, null, trimIndent('\n                Authenticated request attempted with expired access token. This should not happen. Please report this issue. Trying to refresh session before...\n                Auto refresh running: ' + autoRefreshRunning + '\n                Auto-refresher information: ' + toString(auth.yvx()) + '\n                OS: ' + toString(Companion_getInstance().hvj()) + '\n                Session: ' + maskSession(StringMasking_getInstance(), currentSession).toString() + '\n            '));
              }
              this.o9_1 = 4;
              this.n9_1 = 1;
              suspendResult = auth.zvx(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 3;
              continue $sm;
            }

          case 1:
            this.o9_1 = 5;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.o9_1 = 5;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            this.o9_1 = 5;
            var tmp_3 = this.q9_1;
            if (tmp_3 instanceof Exception) {
              var e = this.q9_1;
              var tmp0_1 = Companion_getInstance_6().wvx_1;
              var level_0 = LogLevel_DEBUG_getInstance();
              var tmp0_elvis_lhs_1 = tmp0_1.fsu();
              if (level_0.i3(tmp0_elvis_lhs_1 == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs_1) >= 0) {
                tmp0_1.fvj(level_0, e, 'Failed to force-refresh session before making a request with an expired access token');
              }
              throw new TokenExpiredException();
            } else {
              throw this.q9_1;
            }

          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 5) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function sam$io_github_jan_supabase_auth_api_ResolveAccessToken$0(function_0) {
    this.avy_1 = function_0;
  }
  protoOf(sam$io_github_jan_supabase_auth_api_ResolveAccessToken$0).bvy = function (jwtToken, fallbackToKey, $completion) {
    return this.avy_1(jwtToken, fallbackToKey, $completion);
  };
  protoOf(sam$io_github_jan_supabase_auth_api_ResolveAccessToken$0).q3 = function () {
    return this.avy_1;
  };
  protoOf(sam$io_github_jan_supabase_auth_api_ResolveAccessToken$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ResolveAccessToken) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$io_github_jan_supabase_auth_api_ResolveAccessToken$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function Auth$Companion$defaultResolveAccessToken$slambda($supabaseClient, resultContinuation) {
    this.kvy_1 = $supabaseClient;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(Auth$Companion$defaultResolveAccessToken$slambda).nvy = function (token, fallback, $completion) {
    var tmp = this.ovy(token, fallback, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(Auth$Companion$defaultResolveAccessToken$slambda).ha = function (p1, p2, $completion) {
    var tmp = (p1 == null ? true : typeof p1 === 'string') ? p1 : THROW_CCE();
    return this.nvy(tmp, (!(p2 == null) ? typeof p2 === 'boolean' : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(Auth$Companion$defaultResolveAccessToken$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = resolveAccessToken(this.kvy_1, this.lvy_1, this.mvy_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(Auth$Companion$defaultResolveAccessToken$slambda).ovy = function (token, fallback, completion) {
    var i = new Auth$Companion$defaultResolveAccessToken$slambda(this.kvy_1, completion);
    i.lvy_1 = token;
    i.mvy_1 = fallback;
    return i;
  };
  function Auth$Companion$defaultResolveAccessToken$slambda_0($supabaseClient, resultContinuation) {
    var i = new Auth$Companion$defaultResolveAccessToken$slambda($supabaseClient, resultContinuation);
    return constructCallableReference(function (token, fallback, $completion) {
      return i.nvy(token, fallback, $completion);
    }, 2);
  }
  function Companion() {
    Companion_instance_0 = this;
    this.tvx_1 = listOf(['access_token', 'refresh_token', 'expires_in', 'expires_at', 'token_type', 'type', 'provider_refresh_token', 'provider_token', 'error', 'error_code', 'error_description']);
    this.uvx_1 = listOf(['code', 'error_code', 'error', 'error_description']);
    this.vvx_1 = 'auth';
    this.wvx_1 = Companion_getInstance_0().ovj('Supabase-Auth');
    this.xvx_1 = 1;
  }
  protoOf(Companion).t1 = function () {
    return this.vvx_1;
  };
  protoOf(Companion).pvy = function (supabaseClient) {
    var tmp = Auth$Companion$defaultResolveAccessToken$slambda_0(supabaseClient, null);
    return new sam$io_github_jan_supabase_auth_api_ResolveAccessToken$0(tmp);
  };
  protoOf(Companion).qvy = function (init) {
    // Inline function 'kotlin.apply' call
    var this_0 = new AuthConfig();
    init(this_0);
    return this_0;
  };
  protoOf(Companion).ovl = function (init) {
    return this.qvy(init);
  };
  protoOf(Companion).rvy = function (supabaseClient, config) {
    return new AuthImpl(supabaseClient, config);
  };
  protoOf(Companion).xvk = function (supabaseClient, config) {
    return this.rvy(supabaseClient, config instanceof AuthConfig ? config : THROW_CCE());
  };
  var Companion_instance_0;
  function Companion_getInstance_6() {
    if (Companion_instance_0 == null)
      new Companion();
    return Companion_instance_0;
  }
  function Auth$getOAuthUrl$lambda(_this__u8e3s4) {
    return Unit_instance;
  }
  function Auth() {
  }
  function get_auth(_this__u8e3s4) {
    var tmp0 = _this__u8e3s4.tvj();
    // Inline function 'io.github.jan.supabase.plugins.PluginManager.getPlugin' call
    var provider = Companion_getInstance_6();
    // Inline function 'io.github.jan.supabase.plugins.PluginManager.getPluginOrNull' call
    var tmp = tmp0.wvk_1.w2(provider.t1());
    var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, Auth) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message = 'Plugin ' + provider.t1() + ' not installed or not of type ' + getKClass(Auth).o() + '. Consider installing ' + getKClass(Auth).o() + ' within your SupabaseClientBuilder';
      throw IllegalStateException_init_$Create$(toString_0(message));
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    return tmp_0;
  }
  function AuthConfigDefaults() {
    MainConfig.call(this);
    var tmp = this;
    // Inline function 'kotlin.time.Companion.seconds' call
    Companion_getInstance_1();
    tmp.avx_1 = toDuration(10, DurationUnit_SECONDS_getInstance());
    this.bvx_1 = true;
    this.cvx_1 = true;
    this.dvx_1 = true;
    this.evx_1 = null;
    this.fvx_1 = null;
    this.gvx_1 = null;
    this.hvx_1 = FlowType_IMPLICIT_getInstance();
    this.ivx_1 = null;
    this.jvx_1 = null;
    this.kvx_1 = null;
    this.lvx_1 = null;
    this.mvx_1 = true;
    this.nvx_1 = Companion_getInstance_9().svz_1;
    this.ovx_1 = true;
    this.pvx_1 = true;
    this.qvx_1 = false;
    this.rvx_1 = SharedJwkCache_getInstance();
  }
  protoOf(AuthConfigDefaults).rvz = function () {
    return this.ivx_1;
  };
  protoOf(AuthConfigDefaults).tvz = function () {
    return this.qvx_1;
  };
  var FlowType_IMPLICIT_instance;
  var FlowType_PKCE_instance;
  var FlowType_entriesInitialized;
  function FlowType_initEntries() {
    if (FlowType_entriesInitialized)
      return Unit_instance;
    FlowType_entriesInitialized = true;
    FlowType_IMPLICIT_instance = new FlowType('IMPLICIT', 0);
    FlowType_PKCE_instance = new FlowType('PKCE', 1);
  }
  function FlowType(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function FlowType_IMPLICIT_getInstance() {
    FlowType_initEntries();
    return FlowType_IMPLICIT_instance;
  }
  function FlowType_PKCE_getInstance() {
    FlowType_initEntries();
    return FlowType_PKCE_instance;
  }
  function parseSessionFromUrl(_this__u8e3s4, url) {
    return parseSessionFromFragment(_this__u8e3s4, substringAfter(url, '#'));
  }
  function parseSessionFromFragment(_this__u8e3s4, fragment) {
    var sessionParts = getFragmentParts(fragment);
    // Inline function 'io.github.jan.supabase.logging.d' call
    var tmp0 = Companion_getInstance_6().wvx_1;
    // Inline function 'io.github.jan.supabase.logging.SupabaseLogger.log' call
    var level = LogLevel_DEBUG_getInstance();
    var tmp0_elvis_lhs = tmp0.fsu();
    if (level.i3(tmp0_elvis_lhs == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs) >= 0) {
      var tmp$ret$2 = 'Fragment parts: ' + toString_0(sessionParts);
      tmp0.fvj(level, null, tmp$ret$2);
    }
    var tmp0_elvis_lhs_0 = sessionParts.w2('access_token');
    var tmp;
    if (tmp0_elvis_lhs_0 == null) {
      invalidArg('No access token found');
    } else {
      tmp = tmp0_elvis_lhs_0;
    }
    var accessToken = tmp;
    var tmp1_elvis_lhs = sessionParts.w2('refresh_token');
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      invalidArg('No refresh token found');
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var refreshToken = tmp_0;
    var tmp2_safe_receiver = sessionParts.w2('expires_in');
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : toLong(tmp2_safe_receiver);
    var tmp_1;
    if (tmp3_elvis_lhs == null) {
      invalidArg('No expires in found');
    } else {
      tmp_1 = tmp3_elvis_lhs;
    }
    var expiresIn = tmp_1;
    var tmp4_elvis_lhs = sessionParts.w2('token_type');
    var tmp_2;
    if (tmp4_elvis_lhs == null) {
      invalidArg('No token type found');
    } else {
      tmp_2 = tmp4_elvis_lhs;
    }
    var tokenType = tmp_2;
    var tmp5_elvis_lhs = sessionParts.w2('type');
    var type = tmp5_elvis_lhs == null ? '' : tmp5_elvis_lhs;
    var providerToken = sessionParts.w2('provider_token');
    var providerRefreshToken = sessionParts.w2('provider_refresh_token');
    return new UserSession(accessToken, refreshToken, providerRefreshToken, providerToken, expiresIn, tokenType, null, type);
  }
  var JWKS_TTL;
  function get_SIGNOUT_IGNORE_CODES() {
    _init_properties_AuthImpl_kt__jjr9x4();
    return SIGNOUT_IGNORE_CODES;
  }
  var SIGNOUT_IGNORE_CODES;
  function AuthImpl$recreateSessionJob$slambda$slambda(this$0, $session, resultContinuation) {
    this.cw0_1 = this$0;
    this.dw0_1 = $session;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AuthImpl$recreateSessionJob$slambda$slambda).r2b = function ($completion) {
    var tmp = this.s2b($completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthImpl$recreateSessionJob$slambda$slambda).ia = function ($completion) {
    return this.r2b($completion);
  };
  protoOf(AuthImpl$recreateSessionJob$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = handleExpiredSession(this.cw0_1, this.dw0_1, this.cw0_1.fw0_1.bvx_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AuthImpl$recreateSessionJob$slambda$slambda).s2b = function (completion) {
    return new AuthImpl$recreateSessionJob$slambda$slambda(this.cw0_1, this.dw0_1, completion);
  };
  function AuthImpl$recreateSessionJob$slambda$slambda_0(this$0, $session, resultContinuation) {
    var i = new AuthImpl$recreateSessionJob$slambda$slambda(this$0, $session, resultContinuation);
    return constructCallableReference(function ($completion) {
      return i.r2b($completion);
    }, 0);
  }
  function AuthImpl$recreateSessionJob$slambda$slambda_1(this$0, $session, $source, resultContinuation) {
    this.dw1_1 = this$0;
    this.ew1_1 = $session;
    this.fw1_1 = $source;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AuthImpl$recreateSessionJob$slambda$slambda_1).r2b = function ($completion) {
    var tmp = this.s2b($completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthImpl$recreateSessionJob$slambda$slambda_1).ia = function ($completion) {
    return this.r2b($completion);
  };
  protoOf(AuthImpl$recreateSessionJob$slambda$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.dw1_1.gvz(this.ew1_1, VOID, this.fw1_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AuthImpl$recreateSessionJob$slambda$slambda_1).s2b = function (completion) {
    return new AuthImpl$recreateSessionJob$slambda$slambda_1(this.dw1_1, this.ew1_1, this.fw1_1, completion);
  };
  function AuthImpl$recreateSessionJob$slambda$slambda_2(this$0, $session, $source, resultContinuation) {
    var i = new AuthImpl$recreateSessionJob$slambda$slambda_1(this$0, $session, $source, resultContinuation);
    return constructCallableReference(function ($completion) {
      return i.r2b($completion);
    }, 0);
  }
  function AuthImpl$recreateSessionJob$slambda$slambda_3(this$0, $session, resultContinuation) {
    this.ow1_1 = this$0;
    this.pw1_1 = $session;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AuthImpl$recreateSessionJob$slambda$slambda_3).rw1 = function (it, $completion) {
    var tmp = this.sw1(it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthImpl$recreateSessionJob$slambda$slambda_3).ja = function (p1, $completion) {
    return this.rw1((!(p1 == null) ? isInterface(p1, RefreshFailureCause) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AuthImpl$recreateSessionJob$slambda$slambda_3).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          updateStatusIfExpired(this.ow1_1, this.pw1_1, this.qw1_1);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(AuthImpl$recreateSessionJob$slambda$slambda_3).sw1 = function (it, completion) {
    var i = new AuthImpl$recreateSessionJob$slambda$slambda_3(this.ow1_1, this.pw1_1, completion);
    i.qw1_1 = it;
    return i;
  };
  function AuthImpl$recreateSessionJob$slambda$slambda_4(this$0, $session, resultContinuation) {
    var i = new AuthImpl$recreateSessionJob$slambda$slambda_3(this$0, $session, resultContinuation);
    return constructCallableReference(function (it, $completion) {
      return i.rw1(it, $completion);
    }, 1);
  }
  function recreateSessionJob($this, session, source, delay, initializing, $completion) {
    var tmp = new $recreateSessionJobCOROUTINE$($this, session, source, delay, initializing, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function tryImportingSession($this, importRefreshedSession, retry, updateStatus, $completion) {
    var tmp = new $tryImportingSessionCOROUTINE$($this, importRefreshedSession, retry, updateStatus, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function updateStatusIfExpired($this, session, reason) {
    if (session.xvw_1.aq(System_instance.fp()) <= 0) {
      // Inline function 'io.github.jan.supabase.logging.d' call
      var tmp0 = Companion_getInstance_6().wvx_1;
      // Inline function 'io.github.jan.supabase.logging.SupabaseLogger.log' call
      var level = LogLevel_DEBUG_getInstance();
      var tmp0_elvis_lhs = tmp0.fsu();
      if (level.i3(tmp0_elvis_lhs == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs) >= 0) {
        var tmp$ret$2 = 'Session expired while trying to refresh the session. Updating status...';
        tmp0.fvj(level, null, tmp$ret$2);
      }
      $this.hvz(new RefreshFailure_0(reason));
    }
    $this.ivz(new RefreshFailure(reason));
  }
  function delayBeforeExpiry($this, session, $completion) {
    var now = System_instance.fp();
    Companion_getInstance_1();
    // Inline function 'kotlin.time.Companion.seconds' call
    var this_0 = session.tvw_1;
    var tmp$ret$0 = toDuration_0(this_0, DurationUnit_SECONDS_getInstance());
    var timeAtBeginningOfSession = session.xvw_1.yp(tmp$ret$0);
    Companion_getInstance_1();
    // Inline function 'kotlin.time.Companion.seconds' call
    var this_1 = session.tvw_1;
    var tmp$ret$1 = toDuration_0(this_1, DurationUnit_SECONDS_getInstance());
    var targetRefreshTime = timeAtBeginningOfSession.xp(Duration__times_impl_sfuzvp(tmp$ret$1, 0.8));
    var delayDuration = targetRefreshTime.zp(now);
    updateRefreshInformation($this, targetRefreshTime, null);
    // Inline function 'io.github.jan.supabase.logging.d' call
    var tmp0 = Companion_getInstance_6().wvx_1;
    // Inline function 'io.github.jan.supabase.logging.SupabaseLogger.log' call
    var level = LogLevel_DEBUG_getInstance();
    var tmp0_elvis_lhs = tmp0.fsu();
    if (level.i3(tmp0_elvis_lhs == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs) >= 0) {
      var tmp$ret$4 = 'Refreshing session in ' + Duration__toString_impl_8d916b(delayDuration) + '.';
      tmp0.fvj(level, null, tmp$ret$4);
    }
    return delay(delayDuration, $completion);
  }
  function updateRefreshInformation($this, refreshingAt, lastRefreshedAt) {
    var tmp = $this;
    var tmp0_safe_receiver = $this.tw0_1;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp_1;
      if (refreshingAt == null) {
        var tmp2_safe_receiver = $this.tw0_1;
        tmp_1 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.vw2_1;
      } else {
        tmp_1 = refreshingAt;
      }
      var tmp6_refreshingAt = tmp_1;
      var tmp_2;
      if (lastRefreshedAt == null) {
        var tmp4_safe_receiver = $this.tw0_1;
        tmp_2 = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.uw2_1;
      } else {
        tmp_2 = lastRefreshedAt;
      }
      var tmp7_lastRefreshedAt = tmp_2;
      tmp_0 = tmp0_safe_receiver.ww2(VOID, tmp7_lastRefreshedAt, tmp6_refreshingAt);
    }
    var tmp8_elvis_lhs = tmp_0;
    tmp.tw0_1 = tmp8_elvis_lhs == null ? new SessionRefreshInformation(System_instance.fp(), lastRefreshedAt, refreshingAt) : tmp8_elvis_lhs;
  }
  function handleExpiredSession($this, session, autoRefresh, $completion) {
    autoRefresh = autoRefresh === VOID ? true : autoRefresh;
    var tmp = new $handleExpiredSessionCOROUTINE$($this, session, autoRefresh, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function checkErrorCodes($this, error, response) {
    var tmp;
    switch (error.iw3_1) {
      case 'weak_password':
        var tmp1_safe_receiver = error.kw3_1;
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.lw3_1;
        tmp = new AuthWeakPasswordException(error.jw3_1, response, tmp2_elvis_lhs == null ? emptyList() : tmp2_elvis_lhs);
        break;
      case 'session_not_found':
        launch($this.kw0_1, VOID, VOID, AuthImpl$checkErrorCodes$slambda_0($this, null));
        tmp = new AuthSessionMissingException(response);
        break;
      default:
        var tmp3_safe_receiver = error.iw3_1;
        var tmp_0;
        if (tmp3_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_0 = new AuthRestException(tmp3_safe_receiver, error.jw3_1, response);
        }

        tmp = tmp_0;
        break;
    }
    return tmp;
  }
  function preparePKCEIfEnabled($this) {
    if (!$this.fw0_1.hvx_1.equals(FlowType_PKCE_getInstance()))
      return null;
    var codeVerifier = generateCodeVerifier();
    launch($this.kw0_1, VOID, VOID, AuthImpl$preparePKCEIfEnabled$slambda_0($this, codeVerifier, null));
    return generateCodeChallenge(codeVerifier);
  }
  function AuthImpl$init$slambda(this$0, resultContinuation) {
    this.uw3_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AuthImpl$init$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthImpl$init$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AuthImpl$init$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            var tmp0 = Companion_getInstance_6().wvx_1;
            var level = LogLevel_INFO_getInstance();
            var tmp0_elvis_lhs = tmp0.fsu();
            if (level.i3(tmp0_elvis_lhs == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs) >= 0) {
              tmp0.fvj(level, null, 'Loading session from storage...');
            }

            this.n9_1 = 1;
            suspendResult = this.uw3_1.ww3(VOID, true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var successful = suspendResult;
            if (successful) {
              var tmp0_0 = Companion_getInstance_6().wvx_1;
              var level_0 = LogLevel_INFO_getInstance();
              var tmp0_elvis_lhs_0 = tmp0_0.fsu();
              if (level_0.i3(tmp0_elvis_lhs_0 == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs_0) >= 0) {
                tmp0_0.fvj(level_0, null, 'Successfully loaded session from storage!');
              }
            } else {
              var tmp0_1 = Companion_getInstance_6().wvx_1;
              var level_1 = LogLevel_INFO_getInstance();
              var tmp0_elvis_lhs_1 = tmp0_1.fsu();
              if (level_1.i3(tmp0_elvis_lhs_1 == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs_1) >= 0) {
                tmp0_1.fvj(level_1, null, 'No session found in storage.');
              }
            }

            if (this.uw3_1.fw0_1.ovx_1) {
              this.n9_1 = 2;
              suspendResult = setupPlatform(this.uw3_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 3;
              continue $sm;
            }

          case 2:
            this.n9_1 = 3;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AuthImpl$init$slambda).q24 = function ($this$launch, completion) {
    var i = new AuthImpl$init$slambda(this.uw3_1, completion);
    i.vw3_1 = $this$launch;
    return i;
  };
  function AuthImpl$init$slambda_0(this$0, resultContinuation) {
    var i = new AuthImpl$init$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function AuthImpl$init$slambda_1(this$0, resultContinuation) {
    this.fw4_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AuthImpl$init$slambda_1).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthImpl$init$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AuthImpl$init$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = setupPlatform(this.fw4_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AuthImpl$init$slambda_1).q24 = function ($this$launch, completion) {
    var i = new AuthImpl$init$slambda_1(this.fw4_1, completion);
    i.gw4_1 = $this$launch;
    return i;
  };
  function AuthImpl$init$slambda_2(this$0, resultContinuation) {
    var i = new AuthImpl$init$slambda_1(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function AuthImpl$signInWith$slambda(this$0, $provider, resultContinuation) {
    this.pw4_1 = this$0;
    this.qw4_1 = $provider;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AuthImpl$signInWith$slambda).sw4 = function (it, $completion) {
    var tmp = this.tw4(it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthImpl$signInWith$slambda).ja = function (p1, $completion) {
    return this.sw4(p1 instanceof UserSession ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AuthImpl$signInWith$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.pw4_1.gvz(this.rw4_1, VOID, new SignIn(this.qw4_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AuthImpl$signInWith$slambda).tw4 = function (it, completion) {
    var i = new AuthImpl$signInWith$slambda(this.pw4_1, this.qw4_1, completion);
    i.rw4_1 = it;
    return i;
  };
  function AuthImpl$signInWith$slambda_0(this$0, $provider, resultContinuation) {
    var i = new AuthImpl$signInWith$slambda(this$0, $provider, resultContinuation);
    return constructCallableReference(function (it, $completion) {
      return i.sw4(it, $completion);
    }, 1);
  }
  function AuthImpl$signUpWith$slambda(this$0, $provider, resultContinuation) {
    this.cw5_1 = this$0;
    this.dw5_1 = $provider;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AuthImpl$signUpWith$slambda).sw4 = function (it, $completion) {
    var tmp = this.tw4(it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthImpl$signUpWith$slambda).ja = function (p1, $completion) {
    return this.sw4(p1 instanceof UserSession ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AuthImpl$signUpWith$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.cw5_1.gvz(this.ew5_1, VOID, new SignUp(this.dw5_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AuthImpl$signUpWith$slambda).tw4 = function (it, completion) {
    var i = new AuthImpl$signUpWith$slambda(this.cw5_1, this.dw5_1, completion);
    i.ew5_1 = it;
    return i;
  };
  function AuthImpl$signUpWith$slambda_0(this$0, $provider, resultContinuation) {
    var i = new AuthImpl$signUpWith$slambda(this$0, $provider, resultContinuation);
    return constructCallableReference(function (it, $completion) {
      return i.sw4(it, $completion);
    }, 1);
  }
  function AuthImpl$updateUser$lambda($redirectUrl, $contentType, $body) {
    return function ($this$request) {
      $this$request.ztr_1 = Companion_getInstance_2().gt2_1;
      var tmp0_safe_receiver = $redirectUrl;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        $this$request.ytr_1.qt5_1.fsq('redirect_to', tmp0_safe_receiver);
      }
      contentType($this$request, $contentType);
      // Inline function 'io.ktor.client.request.setBody' call
      var body = $body;
      if (body == null) {
        $this$request.bts_1 = NullBody_instance;
        // Inline function 'io.ktor.util.reflect.typeInfo' call
        var tmp = PrimitiveClasses_getInstance().rc();
        // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
        var tmp_0;
        try {
          tmp_0 = createKType(PrimitiveClasses_getInstance().rc(), arrayOf([]), false);
        } catch ($p) {
          var tmp_1;
          if ($p instanceof Error) {
            var _unused_var__etf5q3 = $p;
            tmp_1 = null;
          } else {
            throw $p;
          }
          tmp_0 = tmp_1;
        }
        var tmp$ret$5 = tmp_0;
        var tmp$ret$4 = new TypeInfo(tmp, tmp$ret$5);
        $this$request.qtx(tmp$ret$4);
      } else {
        if (body instanceof OutgoingContent) {
          $this$request.bts_1 = body;
          $this$request.qtx(null);
        } else {
          $this$request.bts_1 = body;
          // Inline function 'io.ktor.util.reflect.typeInfo' call
          var tmp_2 = PrimitiveClasses_getInstance().rc();
          // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
          var tmp_3;
          try {
            tmp_3 = createKType(PrimitiveClasses_getInstance().rc(), arrayOf([]), false);
          } catch ($p_0) {
            var tmp_4;
            if ($p_0 instanceof Error) {
              var _unused_var__etf5q3_0 = $p_0;
              tmp_4 = null;
            } else {
              throw $p_0;
            }
            tmp_3 = tmp_4;
          }
          var tmp$ret$7 = tmp_3;
          var tmp$ret$6 = new TypeInfo(tmp_2, tmp$ret$7);
          $this$request.qtx(tmp$ret$6);
        }
      }
      return Unit_instance;
    };
  }
  function AuthImpl$resetPasswordForEmail$lambda($redirectUrl, $contentType, $body) {
    return function ($this$request) {
      $this$request.ztr_1 = Companion_getInstance_2().ft2_1;
      var tmp0_safe_receiver = $redirectUrl;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        $this$request.ytr_1.qt5_1.fsq('redirect_to', tmp0_safe_receiver);
      }
      contentType($this$request, $contentType);
      // Inline function 'io.ktor.client.request.setBody' call
      var body = $body;
      if (body == null) {
        $this$request.bts_1 = NullBody_instance;
        // Inline function 'io.ktor.util.reflect.typeInfo' call
        var tmp = PrimitiveClasses_getInstance().rc();
        // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
        var tmp_0;
        try {
          tmp_0 = createKType(PrimitiveClasses_getInstance().rc(), arrayOf([]), false);
        } catch ($p) {
          var tmp_1;
          if ($p instanceof Error) {
            var _unused_var__etf5q3 = $p;
            tmp_1 = null;
          } else {
            throw $p;
          }
          tmp_0 = tmp_1;
        }
        var tmp$ret$5 = tmp_0;
        var tmp$ret$4 = new TypeInfo(tmp, tmp$ret$5);
        $this$request.qtx(tmp$ret$4);
      } else {
        if (body instanceof OutgoingContent) {
          $this$request.bts_1 = body;
          $this$request.qtx(null);
        } else {
          $this$request.bts_1 = body;
          // Inline function 'io.ktor.util.reflect.typeInfo' call
          var tmp_2 = PrimitiveClasses_getInstance().rc();
          // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
          var tmp_3;
          try {
            tmp_3 = createKType(PrimitiveClasses_getInstance().rc(), arrayOf([]), false);
          } catch ($p_0) {
            var tmp_4;
            if ($p_0 instanceof Error) {
              var _unused_var__etf5q3_0 = $p_0;
              tmp_4 = null;
            } else {
              throw $p_0;
            }
            tmp_3 = tmp_4;
          }
          var tmp$ret$7 = tmp_3;
          var tmp$ret$6 = new TypeInfo(tmp_2, tmp$ret$7);
          $this$request.qtx(tmp$ret$6);
        }
      }
      return Unit_instance;
    };
  }
  function AuthImpl$signOut$lambda($scope) {
    return function ($this$request) {
      $this$request.ztr_1 = Companion_getInstance_2().ft2_1;
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$1 = $scope.z_1.toLowerCase();
      parameter($this$request, 'scope', tmp$ret$1);
      return Unit_instance;
    };
  }
  function AuthImpl$retrieveUser$lambda($jwt) {
    return function ($this$request) {
      $this$request.ztr_1 = Companion_getInstance_2().et2_1;
      $this$request.ats_1.dsq('Authorization', 'Bearer ' + $jwt);
      return Unit_instance;
    };
  }
  function AuthImpl$exchangeCodeForSession$lambda($contentType, $body) {
    return function ($this$request) {
      $this$request.ztr_1 = Companion_getInstance_2().ft2_1;
      contentType($this$request, $contentType);
      // Inline function 'io.ktor.client.request.setBody' call
      var body = $body;
      if (body == null) {
        $this$request.bts_1 = NullBody_instance;
        // Inline function 'io.ktor.util.reflect.typeInfo' call
        var tmp = getKClass(JsonObject);
        // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
        var tmp_0;
        try {
          tmp_0 = createKType(getKClass(JsonObject), arrayOf([]), false);
        } catch ($p) {
          var tmp_1;
          if ($p instanceof Error) {
            var _unused_var__etf5q3 = $p;
            tmp_1 = null;
          } else {
            throw $p;
          }
          tmp_0 = tmp_1;
        }
        var tmp$ret$3 = tmp_0;
        var tmp$ret$2 = new TypeInfo(tmp, tmp$ret$3);
        $this$request.qtx(tmp$ret$2);
      } else {
        if (body instanceof OutgoingContent) {
          $this$request.bts_1 = body;
          $this$request.qtx(null);
        } else {
          $this$request.bts_1 = body;
          // Inline function 'io.ktor.util.reflect.typeInfo' call
          var tmp_2 = getKClass(JsonObject);
          // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
          var tmp_3;
          try {
            tmp_3 = createKType(getKClass(JsonObject), arrayOf([]), false);
          } catch ($p_0) {
            var tmp_4;
            if ($p_0 instanceof Error) {
              var _unused_var__etf5q3_0 = $p_0;
              tmp_4 = null;
            } else {
              throw $p_0;
            }
            tmp_3 = tmp_4;
          }
          var tmp$ret$5 = tmp_3;
          var tmp$ret$4 = new TypeInfo(tmp_2, tmp$ret$5);
          $this$request.qtx(tmp$ret$4);
        }
      }
      return Unit_instance;
    };
  }
  function AuthImpl$refreshSession$lambda($contentType, $body) {
    return function ($this$request) {
      $this$request.ztr_1 = Companion_getInstance_2().ft2_1;
      contentType($this$request, $contentType);
      // Inline function 'io.ktor.client.request.setBody' call
      var body = $body;
      if (body == null) {
        $this$request.bts_1 = NullBody_instance;
        // Inline function 'io.ktor.util.reflect.typeInfo' call
        var tmp = getKClass(JsonObject);
        // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
        var tmp_0;
        try {
          tmp_0 = createKType(getKClass(JsonObject), arrayOf([]), false);
        } catch ($p) {
          var tmp_1;
          if ($p instanceof Error) {
            var _unused_var__etf5q3 = $p;
            tmp_1 = null;
          } else {
            throw $p;
          }
          tmp_0 = tmp_1;
        }
        var tmp$ret$3 = tmp_0;
        var tmp$ret$2 = new TypeInfo(tmp, tmp$ret$3);
        $this$request.qtx(tmp$ret$2);
      } else {
        if (body instanceof OutgoingContent) {
          $this$request.bts_1 = body;
          $this$request.qtx(null);
        } else {
          $this$request.bts_1 = body;
          // Inline function 'io.ktor.util.reflect.typeInfo' call
          var tmp_2 = getKClass(JsonObject);
          // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
          var tmp_3;
          try {
            tmp_3 = createKType(getKClass(JsonObject), arrayOf([]), false);
          } catch ($p_0) {
            var tmp_4;
            if ($p_0 instanceof Error) {
              var _unused_var__etf5q3_0 = $p_0;
              tmp_4 = null;
            } else {
              throw $p_0;
            }
            tmp_3 = tmp_4;
          }
          var tmp$ret$5 = tmp_3;
          var tmp$ret$4 = new TypeInfo(tmp_2, tmp$ret$5);
          $this$request.qtx(tmp$ret$4);
        }
      }
      return Unit_instance;
    };
  }
  function AuthImpl$recreateSessionJob$slambda($delay, this$0, $session, $source, resultContinuation) {
    this.nw5_1 = $delay;
    this.ow5_1 = this$0;
    this.pw5_1 = $session;
    this.qw5_1 = $source;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AuthImpl$recreateSessionJob$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthImpl$recreateSessionJob$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AuthImpl$recreateSessionJob$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            if (this.nw5_1) {
              this.n9_1 = 1;
              suspendResult = delayBeforeExpiry(this.ow5_1, this.pw5_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.n9_1 = 3;
            var tmp_0 = AuthImpl$recreateSessionJob$slambda$slambda_0(this.ow5_1, this.pw5_1, null);
            var tmp_1 = AuthImpl$recreateSessionJob$slambda$slambda_2(this.ow5_1, this.pw5_1, this.qw5_1, null);
            suspendResult = tryImportingSession(this.ow5_1, tmp_0, tmp_1, AuthImpl$recreateSessionJob$slambda$slambda_4(this.ow5_1, this.pw5_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AuthImpl$recreateSessionJob$slambda).q24 = function ($this$launch, completion) {
    var i = new AuthImpl$recreateSessionJob$slambda(this.nw5_1, this.ow5_1, this.pw5_1, this.qw5_1, completion);
    i.rw5_1 = $this$launch;
    return i;
  };
  function AuthImpl$recreateSessionJob$slambda_0($delay, this$0, $session, $source, resultContinuation) {
    var i = new AuthImpl$recreateSessionJob$slambda($delay, this$0, $session, $source, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function AuthImpl$checkErrorCodes$slambda(this$0, resultContinuation) {
    this.aw6_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AuthImpl$checkErrorCodes$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthImpl$checkErrorCodes$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AuthImpl$checkErrorCodes$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var tmp0 = Companion_getInstance_6().wvx_1;
            var level = LogLevel_ERROR_getInstance();
            var tmp0_elvis_lhs = tmp0.fsu();
            if (level.i3(tmp0_elvis_lhs == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs) >= 0) {
              tmp0.fvj(level, null, 'Received session not found api error. Clearing session...');
            }

            this.n9_1 = 1;
            suspendResult = this.aw6_1.cw6(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AuthImpl$checkErrorCodes$slambda).q24 = function ($this$launch, completion) {
    var i = new AuthImpl$checkErrorCodes$slambda(this.aw6_1, completion);
    i.bw6_1 = $this$launch;
    return i;
  };
  function AuthImpl$checkErrorCodes$slambda_0(this$0, resultContinuation) {
    var i = new AuthImpl$checkErrorCodes$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function AuthImpl$preparePKCEIfEnabled$slambda(this$0, $codeVerifier, resultContinuation) {
    this.lw6_1 = this$0;
    this.mw6_1 = $codeVerifier;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AuthImpl$preparePKCEIfEnabled$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthImpl$preparePKCEIfEnabled$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AuthImpl$preparePKCEIfEnabled$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = get_auth(this.lw6_1.ew0_1).tvy().ow6(this.mw6_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AuthImpl$preparePKCEIfEnabled$slambda).q24 = function ($this$launch, completion) {
    var i = new AuthImpl$preparePKCEIfEnabled$slambda(this.lw6_1, this.mw6_1, completion);
    i.nw6_1 = $this$launch;
    return i;
  };
  function AuthImpl$preparePKCEIfEnabled$slambda_0(this$0, $codeVerifier, resultContinuation) {
    var i = new AuthImpl$preparePKCEIfEnabled$slambda(this$0, $codeVerifier, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function $updateUserCOROUTINE$(_this__u8e3s4, updateCurrentUser, redirectUrl, config, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.xw6_1 = _this__u8e3s4;
    this.yw6_1 = updateCurrentUser;
    this.zw6_1 = redirectUrl;
    this.aw7_1 = config;
  }
  protoOf($updateUserCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 8;
            var tmp0 = new UserUpdateBuilder(VOID, VOID, VOID, VOID, VOID, VOID, this.xw6_1.uw0_1);
            this.aw7_1(tmp0);
            var updateBuilder = tmp0;
            var codeChallenge = preparePKCEIfEnabled(this.xw6_1);
            var builder = new JsonObjectBuilder();
            var this_0 = get_supabaseJson();
            var this_1 = this_0.c75();
            var this_2 = serializer(this_1, createKType(getKClass(UserUpdateBuilder), arrayOf([]), false));
            putJsonObject(builder, get_jsonObject(this_0.lmg(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), updateBuilder)));
            if (codeChallenge == null)
              null;
            else {
              putCodeChallenge(builder, codeChallenge);
            }

            var body = builder.wmh().toString();
            var tmp0_0 = this.xw6_1.pw0_1;
            var contentType = Application_getInstance().ksv_1;
            this.n9_1 = 1;
            suspendResult = tmp0_0.wvm('user', AuthImpl$updateUser$lambda(this.zw6_1, contentType, body), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var response = suspendResult;
            this.gw7_1 = null;
            this.n9_1 = 2;
            suspendResult = bodyAsText(response, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.ew7_1 = suspendResult;
            this.fw7_1 = !(this.gw7_1 == null) ? ' in ' + this.gw7_1 : '';
            this.o9_1 = 3;
            var tmp_0 = this;
            var tmp0_1 = get_supabaseJson();
            var string = this.ew7_1;
            var this_3 = tmp0_1.c75();
            var this_4 = serializer(this_3, createKType(getKClass(UserInfo), arrayOf([]), false));
            tmp_0.dw7_1 = tmp0_1.c72(isInterface(this_4, KSerializer) ? this_4 : THROW_CCE(), string);
            this.o9_1 = 8;
            this.n9_1 = 4;
            continue $sm;
          case 3:
            this.o9_1 = 8;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof MissingFieldException) {
              var e = this.q9_1;
              var tmp_2 = this;
              throw new SupabaseEncodingException("Couldn't decode payload" + this.fw7_1 + ' as ' + getKClass(UserInfo).o() + '. Input: ' + replace(this.ew7_1, '\n', ''));
            } else {
              throw this.q9_1;
            }

          case 4:
            this.o9_1 = 8;
            this.bw7_1 = this.dw7_1;
            var tmp_3;
            if (this.yw6_1) {
              var tmp_4 = this.xw6_1.hw0_1.u1();
              tmp_3 = tmp_4 instanceof Authenticated;
            } else {
              tmp_3 = false;
            }

            if (tmp_3) {
              var tmp_5 = this;
              var tmp_6 = this.xw6_1.hw0_1.u1();
              tmp_5.cw7_1 = (tmp_6 instanceof Authenticated ? tmp_6 : THROW_CCE()).nvz_1.hw7(VOID, VOID, VOID, VOID, VOID, VOID, this.bw7_1);
              if (this.xw6_1.fw0_1.dvx_1) {
                this.n9_1 = 5;
                suspendResult = this.xw6_1.lw0_1.iw7(this.cw7_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.n9_1 = 6;
                continue $sm;
              }
            } else {
              this.n9_1 = 7;
              continue $sm;
            }

          case 5:
            this.n9_1 = 6;
            continue $sm;
          case 6:
            this.xw6_1.hvz(new Authenticated(this.cw7_1, new UserChanged(this.cw7_1)));
            this.n9_1 = 7;
            continue $sm;
          case 7:
            return this.bw7_1;
          case 8:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 8) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function $resetPasswordForEmailCOROUTINE$(_this__u8e3s4, email, redirectUrl, captchaToken, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.rw7_1 = _this__u8e3s4;
    this.sw7_1 = email;
    this.tw7_1 = redirectUrl;
    this.uw7_1 = captchaToken;
  }
  protoOf($resetPasswordForEmailCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var this_0 = this.sw7_1;
            if (!!isBlank(this_0)) {
              var message = 'Email must not be blank';
              throw IllegalArgumentException_init_$Create$(toString_0(message));
            }

            var codeChallenge = preparePKCEIfEnabled(this.rw7_1);
            var builder = new JsonObjectBuilder();
            put(builder, 'email', this.sw7_1);
            var tmp0_safe_receiver = this.uw7_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              putCaptchaToken(builder, tmp0_safe_receiver);
            }

            if (codeChallenge == null)
              null;
            else {
              putCodeChallenge(builder, codeChallenge);
            }

            var body = builder.wmh().toString();
            var tmp0 = this.rw7_1.nw0_1;
            var contentType = Application_getInstance().ksv_1;
            this.n9_1 = 1;
            suspendResult = tmp0.wvm('recover', AuthImpl$resetPasswordForEmail$lambda(this.tw7_1, contentType, body), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $signOutCOROUTINE$(_this__u8e3s4, scope, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.dw8_1 = _this__u8e3s4;
    this.ew8_1 = scope;
  }
  protoOf($signOutCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 7;
            if (!(this.dw8_1.ovw() == null)) {
              this.o9_1 = 2;
              var this_0 = this.dw8_1.pw0_1;
              this.n9_1 = 1;
              suspendResult = this_0.wvm('logout', AuthImpl$signOut$lambda(this.ew8_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp0 = Companion_getInstance_6().wvx_1;
              var level = LogLevel_INFO_getInstance();
              var tmp0_elvis_lhs = tmp0.fsu();
              if (level.i3(tmp0_elvis_lhs == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs) >= 0) {
                tmp0.fvj(level, null, 'Skipping session logout as there is no session available. Proceeding to clean up local data...');
              }
              this.n9_1 = 4;
              continue $sm;
            }

          case 1:
            this.fw8_1 = suspendResult;
            this.o9_1 = 7;
            this.n9_1 = 3;
            continue $sm;
          case 2:
            this.o9_1 = 7;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof RestException) {
              var e = this.q9_1;
              var tmp_1 = this;
              if (get_SIGNOUT_IGNORE_CODES().m1(e.vvl_1)) {
                var tmp0_0 = Companion_getInstance_6().wvx_1;
                var level_0 = LogLevel_DEBUG_getInstance();
                var tmp0_elvis_lhs_0 = tmp0_0.fsu();
                if (level_0.i3(tmp0_elvis_lhs_0 == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs_0) >= 0) {
                  tmp0_0.fvj(level_0, null, 'Received error code ' + e.vvl_1 + " while signing out user. This can happen if the user doesn't exist anymore or the JWT is invalid/expired. Proceeding to clean up local data...");
                }
              } else
                throw e;
              tmp_1.fw8_1 = Unit_instance;
              this.n9_1 = 3;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 3:
            this.o9_1 = 7;
            var tmp0_1 = Companion_getInstance_6().wvx_1;
            var level_1 = LogLevel_DEBUG_getInstance();
            var tmp0_elvis_lhs_1 = tmp0_1.fsu();
            if (level_1.i3(tmp0_elvis_lhs_1 == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs_1) >= 0) {
              tmp0_1.fvj(level_1, null, 'Logged out session in Supabase');
            }

            this.n9_1 = 4;
            continue $sm;
          case 4:
            if (!this.ew8_1.equals(SignOutScope_OTHERS_getInstance())) {
              this.n9_1 = 5;
              suspendResult = this.dw8_1.cw6(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 6;
              continue $sm;
            }

          case 5:
            this.n9_1 = 6;
            continue $sm;
          case 6:
            var tmp0_2 = Companion_getInstance_6().wvx_1;
            var level_2 = LogLevel_DEBUG_getInstance();
            var tmp0_elvis_lhs_2 = tmp0_2.fsu();
            if (level_2.i3(tmp0_elvis_lhs_2 == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs_2) >= 0) {
              tmp0_2.fvj(level_2, null, 'Successfully logged out');
            }

            return Unit_instance;
          case 7:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 7) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function $retrieveUserCOROUTINE$(_this__u8e3s4, jwt, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ow8_1 = _this__u8e3s4;
    this.pw8_1 = jwt;
  }
  protoOf($retrieveUserCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var this_0 = this.ow8_1.pw0_1;
            this.n9_1 = 1;
            suspendResult = this_0.wvm('user', AuthImpl$retrieveUser$lambda(this.pw8_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var response = suspendResult;
            this.n9_1 = 2;
            suspendResult = bodyAsText(response, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var body = suspendResult;
            var this_1 = get_supabaseJson();
            var this_2 = this_1.c75();
            var this_3 = serializer(this_2, createKType(getKClass(UserInfo), arrayOf([]), false));
            return this_1.c72(isInterface(this_3, KSerializer) ? this_3 : THROW_CCE(), body);
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $exchangeCodeForSessionCOROUTINE$(_this__u8e3s4, code, saveSession, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.yw8_1 = _this__u8e3s4;
    this.zw8_1 = code;
    this.aw9_1 = saveSession;
  }
  protoOf($exchangeCodeForSessionCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 9;
            this.n9_1 = 1;
            suspendResult = this.yw8_1.mw0_1.gw9(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var codeVerifier = suspendResult;
            if (!!(codeVerifier == null)) {
              var message = 'No code verifier stored. Make sure to use `getOAuthUrl` for the OAuth Url to prepare the PKCE flow.';
              throw IllegalArgumentException_init_$Create$(toString_0(message));
            }

            var tmp0 = this.yw8_1.ow0_1;
            var tmp2 = 'token?grant_type=pkce';
            var builder = new JsonObjectBuilder();
            put(builder, 'auth_code', this.zw8_1);
            put(builder, 'code_verifier', codeVerifier);
            var tmp4 = builder.wmh();
            var contentType = Application_getInstance().ksv_1;
            this.n9_1 = 2;
            suspendResult = tmp0.wvm(tmp2, AuthImpl$exchangeCodeForSession$lambda(contentType, tmp4), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var this_0 = suspendResult;
            this.fw9_1 = null;
            this.n9_1 = 3;
            suspendResult = bodyAsText(this_0, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.dw9_1 = suspendResult;
            this.ew9_1 = !(this.fw9_1 == null) ? ' in ' + this.fw9_1 : '';
            this.o9_1 = 4;
            var tmp_0 = this;
            var tmp0_0 = get_supabaseJson();
            var string = this.dw9_1;
            var this_1 = tmp0_0.c75();
            var this_2 = serializer(this_1, createKType(getKClass(UserSession), arrayOf([]), false));
            tmp_0.cw9_1 = tmp0_0.c72(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), string);
            this.o9_1 = 9;
            this.n9_1 = 5;
            continue $sm;
          case 4:
            this.o9_1 = 9;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof MissingFieldException) {
              var e = this.q9_1;
              var tmp_2 = this;
              throw new SupabaseEncodingException("Couldn't decode payload" + this.ew9_1 + ' as ' + getKClass(UserSession).o() + '. Input: ' + replace(this.dw9_1, '\n', ''));
            } else {
              throw this.q9_1;
            }

          case 5:
            this.o9_1 = 9;
            this.bw9_1 = this.cw9_1;
            this.n9_1 = 6;
            suspendResult = this.yw8_1.mw0_1.hw9(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            if (this.aw9_1) {
              this.n9_1 = 7;
              suspendResult = this.yw8_1.gvz(this.bw9_1, VOID, External_instance, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 8;
              continue $sm;
            }

          case 7:
            this.n9_1 = 8;
            continue $sm;
          case 8:
            return this.bw9_1;
          case 9:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 9) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function $refreshSessionCOROUTINE$(_this__u8e3s4, refreshToken, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.qw9_1 = _this__u8e3s4;
    this.rw9_1 = refreshToken;
  }
  protoOf($refreshSessionCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            var tmp0 = Companion_getInstance_6().wvx_1;
            var level = LogLevel_DEBUG_getInstance();
            var tmp0_elvis_lhs = tmp0.fsu();
            if (level.i3(tmp0_elvis_lhs == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs) >= 0) {
              tmp0.fvj(level, null, 'Refreshing session');
            }

            var builder = new JsonObjectBuilder();
            put(builder, 'refresh_token', this.rw9_1);
            var body = builder.wmh();
            var tmp0_0 = this.qw9_1.ow0_1;
            var tmp2 = 'token?grant_type=refresh_token';
            var contentType = Application_getInstance().ksv_1;
            this.n9_1 = 1;
            suspendResult = tmp0_0.wvm(tmp2, AuthImpl$refreshSession$lambda(contentType, body), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var response = suspendResult;
            this.vw9_1 = 'Auth#refreshSession';
            this.n9_1 = 2;
            suspendResult = bodyAsText(response, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.tw9_1 = suspendResult;
            this.uw9_1 = !(this.vw9_1 == null) ? ' in ' + this.vw9_1 : '';
            this.o9_1 = 3;
            var tmp_0 = this;
            var tmp0_1 = get_supabaseJson();
            var string = this.tw9_1;
            var this_0 = tmp0_1.c75();
            var this_1 = serializer(this_0, createKType(getKClass(UserSession), arrayOf([]), false));
            tmp_0.sw9_1 = tmp0_1.c72(isInterface(this_1, KSerializer) ? this_1 : THROW_CCE(), string);
            this.o9_1 = 5;
            this.n9_1 = 4;
            continue $sm;
          case 3:
            this.o9_1 = 5;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof MissingFieldException) {
              var e = this.q9_1;
              var tmp_2 = this;
              throw new SupabaseEncodingException("Couldn't decode payload" + this.uw9_1 + ' as ' + getKClass(UserSession).o() + '. Input: ' + replace(this.tw9_1, '\n', ''));
            } else {
              throw this.q9_1;
            }

          case 4:
            this.o9_1 = 5;
            return this.sw9_1;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 5) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function $refreshCurrentSessionCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ewa_1 = _this__u8e3s4;
  }
  protoOf($refreshCurrentSessionCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.n9_1 = 1;
            var tmp0_safe_receiver = this.ewa_1.ovw();
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.qvw_1;
            var tmp_0;
            if (tmp1_elvis_lhs == null) {
              var message = 'No refresh token found in current session';
              throw IllegalStateException_init_$Create$(toString_0(message));
            } else {
              tmp_0 = tmp1_elvis_lhs;
            }

            suspendResult = this.ewa_1.fwa(tmp_0, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var newSession = suspendResult;
            this.n9_1 = 2;
            var tmp2_elvis_lhs = this.ewa_1.ovw();
            var tmp_1;
            if (tmp2_elvis_lhs == null) {
              var message_0 = 'No session found';
              throw IllegalStateException_init_$Create$(toString_0(message_0));
            } else {
              tmp_1 = tmp2_elvis_lhs;
            }

            suspendResult = this.ewa_1.gvz(newSession, VOID, new Refresh(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            updateRefreshInformation(this.ewa_1, null, System_instance.fp());
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $importSessionCOROUTINE$(_this__u8e3s4, session, autoRefresh, source, initializing, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.owa_1 = _this__u8e3s4;
    this.pwa_1 = session;
    this.qwa_1 = autoRefresh;
    this.rwa_1 = source;
    this.swa_1 = initializing;
  }
  protoOf($importSessionCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 9;
            var tmp0 = Companion_getInstance_6().wvx_1;
            var level = LogLevel_DEBUG_getInstance();
            var tmp0_elvis_lhs = tmp0.fsu();
            if (level.i3(tmp0_elvis_lhs == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs) >= 0) {
              tmp0.fvj(level, null, 'Importing session ' + this.pwa_1.toString() + ' from ' + toString_0(this.rwa_1) + ', auto refresh is set to ' + this.qwa_1 + '.');
            }

            if (!this.qwa_1) {
              var tmp_0;
              var tmp_1;
              var this_0 = this.pwa_1.qvw_1;
              if (!isBlank(this_0)) {
                tmp_1 = !equalsLong(this.pwa_1.tvw_1, new Long(0, 0));
              } else {
                tmp_1 = false;
              }
              if (tmp_1) {
                tmp_0 = this.owa_1.fw0_1.dvx_1;
              } else {
                tmp_0 = false;
              }
              if (tmp_0) {
                this.n9_1 = 7;
                suspendResult = this.owa_1.lw0_1.iw7(this.pwa_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.n9_1 = 8;
                continue $sm;
              }
            } else {
              this.n9_1 = 1;
              continue $sm;
            }

          case 1:
            Companion_getInstance_1();
            var this_1 = this.pwa_1.tvw_1;
            var thresholdDate = this.pwa_1.xvw_1.yp(Duration__times_impl_sfuzvp(toDuration_0(this_1, DurationUnit_SECONDS_getInstance()), 1 - 0.8));
            if (thresholdDate.aq(System_instance.fp()) <= 0) {
              var tmp0_0 = Companion_getInstance_6().wvx_1;
              var level_0 = LogLevel_DEBUG_getInstance();
              var tmp0_elvis_lhs_0 = tmp0_0.fsu();
              if (level_0.i3(tmp0_elvis_lhs_0 == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs_0) >= 0) {
                tmp0_0.fvj(level_0, null, 'Session is under the threshold date. Refreshing session...');
              }
              this.n9_1 = 5;
              suspendResult = recreateSessionJob(this.owa_1, this.pwa_1, this.rwa_1, false, this.swa_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (this.owa_1.fw0_1.dvx_1) {
                this.n9_1 = 2;
                suspendResult = this.owa_1.lw0_1.iw7(this.pwa_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.n9_1 = 3;
                continue $sm;
              }
            }

          case 2:
            var tmp0_1 = Companion_getInstance_6().wvx_1;
            var level_1 = LogLevel_DEBUG_getInstance();
            var tmp0_elvis_lhs_1 = tmp0_1.fsu();
            if (level_1.i3(tmp0_elvis_lhs_1 == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs_1) >= 0) {
              tmp0_1.fvj(level_1, null, 'Session saved to storage (auto refresh enabled)');
            }

            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.owa_1.hvz(new Authenticated(this.pwa_1, this.rwa_1));
            var tmp0_2 = Companion_getInstance_6().wvx_1;
            var level_2 = LogLevel_DEBUG_getInstance();
            var tmp0_elvis_lhs_2 = tmp0_2.fsu();
            if (level_2.i3(tmp0_elvis_lhs_2 == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs_2) >= 0) {
              tmp0_2.fvj(level_2, null, 'Session imported successfully. Starting auto refresh...');
            }

            this.n9_1 = 4;
            suspendResult = recreateSessionJob(this.owa_1, this.pwa_1, this.rwa_1, true, this.swa_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            var tmp0_3 = Companion_getInstance_6().wvx_1;
            var level_3 = LogLevel_DEBUG_getInstance();
            var tmp0_elvis_lhs_3 = tmp0_3.fsu();
            if (level_3.i3(tmp0_elvis_lhs_3 == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs_3) >= 0) {
              tmp0_3.fvj(level_3, null, 'Auto refresh started.');
            }

            this.n9_1 = 6;
            continue $sm;
          case 5:
            this.n9_1 = 6;
            continue $sm;
          case 6:
            return Unit_instance;
          case 7:
            var tmp0_4 = Companion_getInstance_6().wvx_1;
            var level_4 = LogLevel_DEBUG_getInstance();
            var tmp0_elvis_lhs_4 = tmp0_4.fsu();
            if (level_4.i3(tmp0_elvis_lhs_4 == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs_4) >= 0) {
              tmp0_4.fvj(level_4, null, 'Session saved to storage (no auto refresh)');
            }

            this.n9_1 = 8;
            continue $sm;
          case 8:
            this.owa_1.hvz(new Authenticated(this.pwa_1, this.rwa_1));
            var tmp0_5 = Companion_getInstance_6().wvx_1;
            var level_5 = LogLevel_DEBUG_getInstance();
            var tmp0_elvis_lhs_5 = tmp0_5.fsu();
            if (level_5.i3(tmp0_elvis_lhs_5 == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs_5) >= 0) {
              tmp0_5.fvj(level_5, null, 'Session imported successfully.');
            }

            return Unit_instance;
          case 9:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 9) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $recreateSessionJobCOROUTINE$(_this__u8e3s4, session, source, delay, initializing, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.bw2_1 = _this__u8e3s4;
    this.cw2_1 = session;
    this.dw2_1 = source;
    this.ew2_1 = delay;
    this.fw2_1 = initializing;
  }
  protoOf($recreateSessionJobCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            var tmp0_safe_receiver = this.bw2_1.sw0_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              tmp0_safe_receiver.b1b();
            }

            var tmp_0 = this.bw2_1;
            tmp_0.sw0_1 = launch(this.bw2_1.kw0_1, VOID, VOID, AuthImpl$recreateSessionJob$slambda_0(this.ew2_1, this.bw2_1, this.cw2_1, this.dw2_1, null));
            if (this.fw2_1) {
              var tmp1_safe_receiver = this.bw2_1.sw0_1;
              if (tmp1_safe_receiver == null) {
                this.gw2_1 = null;
                this.n9_1 = 2;
                continue $sm;
              } else {
                this.n9_1 = 1;
                suspendResult = tmp1_safe_receiver.x1a(this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              this.n9_1 = 3;
              continue $sm;
            }

          case 1:
            var tmp_1 = this;
            tmp_1.gw2_1 = Unit_instance;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.n9_1 = 3;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $tryImportingSessionCOROUTINE$(_this__u8e3s4, importRefreshedSession, retry, updateStatus, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.pw2_1 = _this__u8e3s4;
    this.qw2_1 = importRefreshedSession;
    this.rw2_1 = retry;
    this.sw2_1 = updateStatus;
  }
  protoOf($tryImportingSessionCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 12;
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.qw2_1(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.o9_1 = 12;
            this.n9_1 = 11;
            continue $sm;
          case 2:
            this.o9_1 = 12;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof RestException) {
              var e = this.q9_1;
              var containsArg = e.vvl_1;
              if (500 <= containsArg ? containsArg <= 599 : false) {
                var tmp0 = Companion_getInstance_6().wvx_1;
                var level = LogLevel_ERROR_getInstance();
                var tmp0_elvis_lhs = tmp0.fsu();
                if (level.i3(tmp0_elvis_lhs == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs) >= 0) {
                  tmp0.fvj(level, e, "Couldn't refresh session due to an internal server error. Retrying in " + Duration__toString_impl_8d916b(this.pw2_1.fw0_1.avx_1) + ' (Status code ' + e.vvl_1 + ')...');
                }
                this.n9_1 = 4;
                suspendResult = this.sw2_1(new InternalServerError(e), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp0_0 = Companion_getInstance_6().wvx_1;
                var level_0 = LogLevel_ERROR_getInstance();
                var tmp0_elvis_lhs_0 = tmp0_0.fsu();
                if (level_0.i3(tmp0_elvis_lhs_0 == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs_0) >= 0) {
                  tmp0_0.fvj(level_0, e, "Couldn't refresh session. The refresh token may have been revoked. Clearing session (Status code " + e.vvl_1 + ')... ');
                }
                this.n9_1 = 3;
                suspendResult = this.pw2_1.cw6(this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              var tmp_1 = this.q9_1;
              if (tmp_1 instanceof Exception) {
                var e_0 = this.q9_1;
                ensureActive(this.t9());
                var tmp0_1 = Companion_getInstance_6().wvx_1;
                var level_1 = LogLevel_DEBUG_getInstance();
                var tmp0_elvis_lhs_1 = tmp0_1.fsu();
                if (level_1.i3(tmp0_elvis_lhs_1 == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs_1) >= 0) {
                  tmp0_1.fvj(level_1, e_0, "Couldn't reach Supabase. Either the address doesn't exist or the network might not be on. Retrying in " + Duration__toString_impl_8d916b(this.pw2_1.fw0_1.avx_1) + '...');
                }
                this.n9_1 = 8;
                suspendResult = this.sw2_1(new NetworkError(e_0), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                throw this.q9_1;
              }
            }

          case 3:
            this.n9_1 = 7;
            continue $sm;
          case 4:
            this.n9_1 = 5;
            suspendResult = delay(this.pw2_1.fw0_1.avx_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.n9_1 = 6;
            suspendResult = this.rw2_1(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            this.n9_1 = 7;
            continue $sm;
          case 7:
            this.n9_1 = 11;
            continue $sm;
          case 8:
            this.n9_1 = 9;
            suspendResult = delay(this.pw2_1.fw0_1.avx_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 9:
            this.n9_1 = 10;
            suspendResult = this.rw2_1(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 10:
            this.n9_1 = 11;
            continue $sm;
          case 11:
            this.o9_1 = 12;
            return Unit_instance;
          case 12:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.o9_1 === 12) {
          throw e_1;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_1;
        }
      }
     while (true);
  };
  function $handleExpiredSessionCOROUTINE$(_this__u8e3s4, session, autoRefresh, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.fw3_1 = _this__u8e3s4;
    this.gw3_1 = session;
    this.hw3_1 = autoRefresh;
  }
  protoOf($handleExpiredSessionCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var tmp0 = Companion_getInstance_6().wvx_1;
            var level = LogLevel_DEBUG_getInstance();
            var tmp0_elvis_lhs = tmp0.fsu();
            if (level.i3(tmp0_elvis_lhs == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs) >= 0) {
              tmp0.fvj(level, null, 'Session expired. Refreshing session...');
            }

            this.n9_1 = 1;
            suspendResult = this.fw3_1.fwa(this.gw3_1.qvw_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var newSession = suspendResult;
            this.n9_1 = 2;
            suspendResult = this.fw3_1.fvz(newSession, this.hw3_1, new Refresh(this.gw3_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $loadFromStorageCOROUTINE$(_this__u8e3s4, autoRefresh, initializing, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.bwb_1 = _this__u8e3s4;
    this.cwb_1 = autoRefresh;
    this.dwb_1 = initializing;
  }
  protoOf($loadFromStorageCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.n9_1 = 1;
            suspendResult = this.bwb_1.lw0_1.gwb(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.ewb_1 = suspendResult;
            var tmp0_safe_receiver = this.ewb_1;
            if (tmp0_safe_receiver == null) {
              this.fwb_1 = null;
              this.n9_1 = 3;
              continue $sm;
            } else {
              this.n9_1 = 2;
              suspendResult = this.bwb_1.hwb(tmp0_safe_receiver, this.cwb_1, Storage_instance, this.dwb_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            var tmp_0 = this;
            tmp_0.fwb_1 = Unit_instance;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            return !(this.ewb_1 == null);
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $parseErrorResponseCOROUTINE$(_this__u8e3s4, response, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.qwb_1 = _this__u8e3s4;
    this.rwb_1 = response;
  }
  protoOf($parseErrorResponseCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            var this_0 = this.rwb_1;
            this.n9_1 = 1;
            suspendResult = bodyAsText(this_0, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.twb_1 = suspendResult;
            this.o9_1 = 2;
            var tmp_0 = this;
            var tmp0 = get_supabaseJson();
            var string = this.twb_1;
            var this_1 = tmp0.c75();
            var this_2 = serializer(this_1, createKType(getKClass(GoTrueErrorResponse), arrayOf([]), false));
            tmp_0.swb_1 = tmp0.c72(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), string);
            this.o9_1 = 4;
            this.n9_1 = 3;
            continue $sm;
          case 2:
            this.o9_1 = 4;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof SerializationException) {
              var e = this.q9_1;
              var tmp_2 = this;
              var tmp0_0 = Companion_getInstance_0().evj_1;
              var level = LogLevel_INFO_getInstance();
              var tmp0_elvis_lhs = tmp0_0.fsu();
              if (level.i3(tmp0_elvis_lhs == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs) >= 0) {
                tmp0_0.fvj(level, e, 'Could not decode ' + this.twb_1 + ' as ' + toString_0(getKClass(GoTrueErrorResponse)) + '.');
              }
              tmp_2.swb_1 = null;
              this.n9_1 = 3;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 3:
            this.o9_1 = 4;
            var tmp0_elvis_lhs_0 = this.swb_1;
            var errorBody = tmp0_elvis_lhs_0 == null ? new GoTrueErrorResponse('Unknown error', '') : tmp0_elvis_lhs_0;
            var tmp1_safe_receiver = checkErrorCodes(this.qwb_1, errorBody, this.rwb_1);
            if (tmp1_safe_receiver == null)
              null;
            else {
              return tmp1_safe_receiver;
            }

            var tmp2_subject = this.rwb_1.zbq();
            var tmp_3;
            if (tmp2_subject.equals(Companion_getInstance_3().vt3_1)) {
              var tmp3_elvis_lhs = errorBody.iw3_1;
              tmp_3 = new UnauthorizedRestException(tmp3_elvis_lhs == null ? 'Unauthorized' : tmp3_elvis_lhs, this.rwb_1, errorBody.jw3_1);
            } else if (tmp2_subject.equals(Companion_getInstance_3().ut3_1)) {
              var tmp4_elvis_lhs = errorBody.iw3_1;
              tmp_3 = new BadRequestRestException(tmp4_elvis_lhs == null ? 'Bad Request' : tmp4_elvis_lhs, this.rwb_1, errorBody.jw3_1);
            } else if (tmp2_subject.equals(Companion_getInstance_3().mt4_1)) {
              var tmp5_elvis_lhs = errorBody.iw3_1;
              tmp_3 = new BadRequestRestException(tmp5_elvis_lhs == null ? 'Unprocessable Entity' : tmp5_elvis_lhs, this.rwb_1, errorBody.jw3_1);
            } else {
              var tmp6_elvis_lhs = errorBody.iw3_1;
              tmp_3 = new UnknownRestException(tmp6_elvis_lhs == null ? 'Unknown Error' : tmp6_elvis_lhs, this.rwb_1);
            }

            return tmp_3;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 4) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function $clearSessionCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.cwc_1 = _this__u8e3s4;
  }
  protoOf($clearSessionCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.n9_1 = 1;
            suspendResult = this.cwc_1.mw0_1.hw9(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.n9_1 = 2;
            suspendResult = this.cwc_1.lw0_1.dwc(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.cwc_1.hvz(new NotAuthenticated(true));
            this.cwc_1.ewc();
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function AuthImpl(supabaseClient, config) {
    this.ew0_1 = supabaseClient;
    this.fw0_1 = config;
    this.gw0_1 = MutableStateFlow(Initializing_instance);
    this.hw0_1 = asStateFlow(this.gw0_1);
    this.iw0_1 = MutableSharedFlow(1);
    this.jw0_1 = asSharedFlow(this.iw0_1);
    var tmp = this;
    var tmp0_elvis_lhs = this.fw0_1.gvx_1;
    tmp.kw0_1 = CoroutineScope_0((tmp0_elvis_lhs == null ? this.ew0_1.yvj() : tmp0_elvis_lhs).xj(SupervisorJob()));
    var tmp_0 = this;
    var tmp0_elvis_lhs_0 = this.fw0_1.evx_1;
    tmp_0.lw0_1 = tmp0_elvis_lhs_0 == null ? createDefaultSessionManager(this) : tmp0_elvis_lhs_0;
    var tmp_1 = this;
    var tmp0_elvis_lhs_1 = this.fw0_1.fvx_1;
    tmp_1.mw0_1 = tmp0_elvis_lhs_1 == null ? createDefaultCodeVerifierCache(this) : tmp0_elvis_lhs_1;
    this.nw0_1 = authenticatedSupabaseApi(this.ew0_1, this, VOID, false);
    this.ow0_1 = supabaseApi(this.ew0_1, this);
    this.pw0_1 = this.fw0_1.tvz() ? authenticatedSupabaseApi(this.ew0_1, this) : this.nw0_1;
    this.qw0_1 = new AdminApiImpl(this.nw0_1);
    this.rw0_1 = new MfaApiImpl(this.pw0_1.mwc('factors'), this);
    this.sw0_1 = null;
    this.tw0_1 = null;
    var tmp_2 = this;
    var tmp0_elvis_lhs_2 = this.fw0_1.rvz();
    tmp_2.uw0_1 = tmp0_elvis_lhs_2 == null ? this.ew0_1.wvj() : tmp0_elvis_lhs_2;
    if (!(this.ew0_1.xvj() == null)) {
      // Inline function 'kotlin.error' call
      var message = 'The Auth plugin is not available when using a custom access token provider. Please uninstall the Auth plugin.';
      throw IllegalStateException_init_$Create$(toString_0(message));
    }
  }
  protoOf(AuthImpl).yvn = function () {
    return this.ew0_1;
  };
  protoOf(AuthImpl).ebw = function () {
    return this.fw0_1;
  };
  protoOf(AuthImpl).svy = function () {
    return this.hw0_1;
  };
  protoOf(AuthImpl).tvy = function () {
    return this.mw0_1;
  };
  protoOf(AuthImpl).svx = function () {
    var tmp0_safe_receiver = this.sw0_1;
    return (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r19()) === true;
  };
  protoOf(AuthImpl).rvz = function () {
    return this.uw0_1;
  };
  protoOf(AuthImpl).tvn = function () {
    return 1;
  };
  protoOf(AuthImpl).uvn = function () {
    return Companion_getInstance_6().vvx_1;
  };
  protoOf(AuthImpl).odl = function () {
    // Inline function 'io.github.jan.supabase.logging.d' call
    var tmp0 = Companion_getInstance_6().wvx_1;
    // Inline function 'io.github.jan.supabase.logging.SupabaseLogger.log' call
    var level = LogLevel_DEBUG_getInstance();
    var tmp0_elvis_lhs = tmp0.fsu();
    if (level.i3(tmp0_elvis_lhs == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs) >= 0) {
      var tmp$ret$2 = 'Initializing Auth plugin...';
      tmp0.fvj(level, null, tmp$ret$2);
    }
    if (this.fw0_1.cvx_1) {
      launch(this.kw0_1, VOID, VOID, AuthImpl$init$slambda_0(this, null));
    } else {
      // Inline function 'io.github.jan.supabase.logging.d' call
      var tmp0_0 = Companion_getInstance_6().wvx_1;
      // Inline function 'io.github.jan.supabase.logging.SupabaseLogger.log' call
      var level_0 = LogLevel_DEBUG_getInstance();
      var tmp0_elvis_lhs_0 = tmp0_0.fsu();
      if (level_0.i3(tmp0_elvis_lhs_0 == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs_0) >= 0) {
        var tmp$ret$5 = 'Skipping loading from storage (autoLoadFromStorage is set to false)';
        tmp0_0.fvj(level_0, null, tmp$ret$5);
      }
      if (this.fw0_1.ovx_1) {
        launch(this.kw0_1, VOID, VOID, AuthImpl$init$slambda_2(this, null));
      }
    }
    // Inline function 'io.github.jan.supabase.logging.d' call
    var tmp0_1 = Companion_getInstance_6().wvx_1;
    // Inline function 'io.github.jan.supabase.logging.SupabaseLogger.log' call
    var level_1 = LogLevel_DEBUG_getInstance();
    var tmp0_elvis_lhs_1 = tmp0_1.fsu();
    if (level_1.i3(tmp0_elvis_lhs_1 == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs_1) >= 0) {
      var tmp$ret$8 = 'Initialized Auth plugin';
      tmp0_1.fvj(level_1, null, tmp$ret$8);
    }
  };
  protoOf(AuthImpl).wvy = function (provider, redirectUrl, config, $completion) {
    return provider.nwc(this.ew0_1, AuthImpl$signInWith$slambda_0(this, provider, null), redirectUrl, config, $completion);
  };
  protoOf(AuthImpl).uvy = function (provider, redirectUrl, config, $completion) {
    return provider.owc(this.ew0_1, AuthImpl$signUpWith$slambda_0(this, provider, null), redirectUrl, config, $completion);
  };
  protoOf(AuthImpl).yvy = function (updateCurrentUser, redirectUrl, config, $completion) {
    var tmp = new $updateUserCOROUTINE$(this, updateCurrentUser, redirectUrl, config, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthImpl).avz = function (email, redirectUrl, captchaToken, $completion) {
    var tmp = new $resetPasswordForEmailCOROUTINE$(this, email, redirectUrl, captchaToken, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthImpl).dvz = function (scope, $completion) {
    var tmp = new $signOutCOROUTINE$(this, scope, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthImpl).cvz = function (jwt, $completion) {
    var tmp = new $retrieveUserCOROUTINE$(this, jwt, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthImpl).jvz = function (code, saveSession, $completion) {
    var tmp = new $exchangeCodeForSessionCOROUTINE$(this, code, saveSession, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthImpl).fwa = function (refreshToken, $completion) {
    var tmp = new $refreshSessionCOROUTINE$(this, refreshToken, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthImpl).zvx = function ($completion) {
    var tmp = new $refreshCurrentSessionCOROUTINE$(this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthImpl).fvz = function (session, autoRefresh, source, $completion) {
    return this.hwb(session, autoRefresh, source, false, $completion);
  };
  protoOf(AuthImpl).hwb = function (session, autoRefresh, source, initializing, $completion) {
    var tmp = new $importSessionCOROUTINE$(this, session, autoRefresh, source, initializing, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthImpl).ewc = function () {
    // Inline function 'io.github.jan.supabase.logging.d' call
    var tmp0 = Companion_getInstance_6().wvx_1;
    // Inline function 'io.github.jan.supabase.logging.SupabaseLogger.log' call
    var level = LogLevel_DEBUG_getInstance();
    var tmp0_elvis_lhs = tmp0.fsu();
    if (level.i3(tmp0_elvis_lhs == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs) >= 0) {
      var tmp$ret$2 = 'Stopping auto refresh for current session';
      tmp0.fvj(level, null, tmp$ret$2);
    }
    var tmp0_safe_receiver = this.sw0_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.b1b();
    }
    this.sw0_1 = null;
  };
  protoOf(AuthImpl).yvx = function () {
    return this.tw0_1;
  };
  protoOf(AuthImpl).pwc = function (autoRefresh, initializing, $completion) {
    var tmp = new $loadFromStorageCOROUTINE$(this, autoRefresh, initializing, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthImpl).ww3 = function (autoRefresh, initializing, $completion, $super) {
    autoRefresh = autoRefresh === VOID ? this.fw0_1.bvx_1 : autoRefresh;
    return $super === VOID ? this.pwc(autoRefresh, initializing, $completion) : $super.pwc.call(this, autoRefresh, initializing, $completion);
  };
  protoOf(AuthImpl).svn = function (response, $completion) {
    var tmp = new $parseErrorResponseCOROUTINE$(this, response, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthImpl).lvz = function (provider, redirectUrl, url, additionalConfig) {
    // Inline function 'kotlin.apply' call
    var this_0 = new ExternalAuthConfigDefaults();
    additionalConfig(this_0);
    var config = this_0;
    var codeChallenge = preparePKCEIfEnabled(this);
    if (codeChallenge == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp0 = config.rwc_1;
      // Inline function 'kotlin.collections.set' call
      var key = 'code_challenge';
      tmp0.z2(key, codeChallenge);
      var tmp0_0 = config.rwc_1;
      // Inline function 'kotlin.collections.set' call
      var key_0 = 'code_challenge_method';
      tmp0_0.z2(key_0, 's256');
    }
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_1 = StringBuilder_init_$Create$();
    var tmp = provider.m();
    this_1.q(url + '?provider=' + tmp + '&redirect_to=' + (redirectUrl == null ? null : encodeURLParameter(redirectUrl)));
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!config.qwc_1.r()) {
      this_1.q('&scopes=' + joinToString(config.qwc_1, '+'));
    }
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!config.rwc_1.r()) {
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s = config.rwc_1.s1().t();
      while (_iterator__ex2g4s.u()) {
        var _destruct__k2r9zo = _iterator__ex2g4s.v();
        // Inline function 'kotlin.collections.component1' call
        var key_1 = _destruct__k2r9zo.t1();
        // Inline function 'kotlin.collections.component2' call
        var value = _destruct__k2r9zo.u1();
        this_1.q('&' + key_1 + '=' + encodeURLParameter(value));
      }
    }
    var tmp$ret$5 = this_1.toString();
    return this.vvn(tmp$ret$5);
  };
  protoOf(AuthImpl).cw6 = function ($completion) {
    var tmp = new $clearSessionCOROUTINE$(this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthImpl).hvz = function (status) {
    // Inline function 'io.github.jan.supabase.logging.d' call
    var tmp0 = Companion_getInstance_6().wvx_1;
    // Inline function 'io.github.jan.supabase.logging.SupabaseLogger.log' call
    var level = LogLevel_DEBUG_getInstance();
    var tmp0_elvis_lhs = tmp0.fsu();
    if (level.i3(tmp0_elvis_lhs == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs) >= 0) {
      var tmp$ret$2 = 'Setting session status to ' + toString_0(status);
      tmp0.fvj(level, null, tmp$ret$2);
    }
    this.gw0_1.s21(status);
  };
  protoOf(AuthImpl).ivz = function (event) {
    // Inline function 'io.github.jan.supabase.logging.d' call
    var tmp0 = Companion_getInstance_6().wvx_1;
    // Inline function 'io.github.jan.supabase.logging.SupabaseLogger.log' call
    var level = LogLevel_DEBUG_getInstance();
    var tmp0_elvis_lhs = tmp0.fsu();
    if (level.i3(tmp0_elvis_lhs == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs) >= 0) {
      var tmp$ret$2 = 'Emitting event ' + toString_0(event);
      tmp0.fvj(level, null, tmp$ret$2);
    }
    this.iw0_1.i1z(event);
  };
  var properties_initialized_AuthImpl_kt_pud8eu;
  function _init_properties_AuthImpl_kt__jjr9x4() {
    if (!properties_initialized_AuthImpl_kt_pud8eu) {
      properties_initialized_AuthImpl_kt_pud8eu = true;
      // Inline function 'kotlin.time.Companion.minutes' call
      Companion_getInstance_1();
      JWKS_TTL = toDuration(10, DurationUnit_MINUTES_getInstance());
      SIGNOUT_IGNORE_CODES = listOf([401, 403, 404]);
    }
  }
  function maskSession(_this__u8e3s4, value) {
    var tmp = _this__u8e3s4.kvj(value.pvw_1, VOID, true);
    var tmp_0 = _this__u8e3s4.kvj(value.qvw_1, VOID, true);
    var tmp0_safe_receiver = value.rvw_1;
    var tmp_1;
    if (tmp0_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_1 = _this__u8e3s4.kvj(tmp0_safe_receiver, VOID, true);
    }
    var tmp_2 = tmp_1;
    var tmp1_safe_receiver = value.svw_1;
    var tmp_3;
    if (tmp1_safe_receiver == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_3 = _this__u8e3s4.kvj(tmp1_safe_receiver, VOID, true);
    }
    return value.hw7(tmp, tmp_0, tmp_2, tmp_3);
  }
  function MemoryCodeVerifierCache(codeVerifier) {
    codeVerifier = codeVerifier === VOID ? null : codeVerifier;
    this.twc_1 = new AtomicReference(codeVerifier);
  }
  protoOf(MemoryCodeVerifierCache).ow6 = function (codeVerifier, $completion) {
    this.twc_1.b9(codeVerifier);
    return Unit_instance;
  };
  protoOf(MemoryCodeVerifierCache).gw9 = function ($completion) {
    return this.twc_1.a9();
  };
  protoOf(MemoryCodeVerifierCache).hw9 = function ($completion) {
    this.twc_1.b9(null);
    return Unit_instance;
  };
  function GoTrueErrorResponse$WeakPassword$Companion$$childSerializers$_anonymous__hz5op2() {
    return new ArrayListSerializer(StringSerializer_getInstance());
  }
  function Companion_0() {
    Companion_instance_1 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.uwc_1 = [lazy(tmp_0, GoTrueErrorResponse$WeakPassword$Companion$$childSerializers$_anonymous__hz5op2)];
  }
  var Companion_instance_1;
  function Companion_getInstance_7() {
    if (Companion_instance_1 == null)
      new Companion_0();
    return Companion_instance_1;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.github.jan.supabase.auth.GoTrueErrorResponse.WeakPassword', this, 1);
    tmp0_serialDesc.a7c('reasons', false);
    this.vwc_1 = tmp0_serialDesc;
  }
  protoOf($serializer).wwc = function (encoder, value) {
    var tmp0_desc = this.vwc_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    var tmp2_cached = Companion_getInstance_7().uwc_1;
    tmp1_output.e76(tmp0_desc, 0, tmp2_cached[0].u1(), value.lw3_1);
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer).z70 = function (encoder, value) {
    return this.wwc(encoder, value instanceof WeakPassword ? value : THROW_CCE());
  };
  protoOf($serializer).a71 = function (decoder) {
    var tmp0_desc = this.vwc_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.n74(tmp0_desc);
    var tmp6_cached = Companion_getInstance_7().uwc_1;
    if (tmp5_input.d75()) {
      tmp4_local0 = tmp5_input.z74(tmp0_desc, 0, tmp6_cached[0].u1(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.z74(tmp0_desc, 0, tmp6_cached[0].u1(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.o74(tmp0_desc);
    return WeakPassword_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer).y70 = function () {
    return this.vwc_1;
  };
  protoOf($serializer).t7c = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_7().uwc_1[0].u1()];
  };
  var $serializer_instance;
  function $serializer_getInstance() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function WeakPassword_init_$Init$(seen0, reasons, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance().vwc_1);
    }
    $this.lw3_1 = reasons;
    return $this;
  }
  function WeakPassword_init_$Create$(seen0, reasons, serializationConstructorMarker) {
    return WeakPassword_init_$Init$(seen0, reasons, serializationConstructorMarker, objectCreate(protoOf(WeakPassword)));
  }
  function GoTrueErrorResponse$Companion$descriptor$lambda($this$buildClassSerialDescriptor) {
    $this$buildClassSerialDescriptor.m71('error', serializer_0(StringCompanionObject_instance).y70());
    return Unit_instance;
  }
  function WeakPassword(reasons) {
    Companion_getInstance_7();
    this.lw3_1 = reasons;
  }
  protoOf(WeakPassword).toString = function () {
    return 'WeakPassword(reasons=' + toString_0(this.lw3_1) + ')';
  };
  protoOf(WeakPassword).hashCode = function () {
    return hashCode(this.lw3_1);
  };
  protoOf(WeakPassword).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof WeakPassword))
      return false;
    if (!equals(this.lw3_1, other.lw3_1))
      return false;
    return true;
  };
  function Companion_1() {
    Companion_instance_2 = this;
    var tmp = this;
    tmp.xwc_1 = buildClassSerialDescriptor('GoTrueErrorResponse', [], GoTrueErrorResponse$Companion$descriptor$lambda);
  }
  protoOf(Companion_1).y70 = function () {
    return this.xwc_1;
  };
  protoOf(Companion_1).a71 = function (decoder) {
    if (!isInterface(decoder, JsonDecoder))
      THROW_CCE();
    var json = decoder.qmi();
    var tmp0_safe_receiver = get_jsonObject(json).je('error_code');
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
    var error = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.rj3();
    var tmp2_safe_receiver = get_jsonObject(json).je('error_description');
    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : get_jsonPrimitive(tmp2_safe_receiver);
    var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.rj3();
    var tmp;
    if (tmp4_elvis_lhs == null) {
      var tmp5_safe_receiver = get_jsonObject(json).je('msg');
      var tmp6_safe_receiver = tmp5_safe_receiver == null ? null : get_jsonPrimitive(tmp5_safe_receiver);
      tmp = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.rj3();
    } else {
      tmp = tmp4_elvis_lhs;
    }
    var tmp7_elvis_lhs = tmp;
    var tmp_0;
    if (tmp7_elvis_lhs == null) {
      var tmp8_safe_receiver = get_jsonObject(json).je('message');
      var tmp9_safe_receiver = tmp8_safe_receiver == null ? null : get_jsonPrimitive(tmp8_safe_receiver);
      tmp_0 = tmp9_safe_receiver == null ? null : tmp9_safe_receiver.rj3();
    } else {
      tmp_0 = tmp7_elvis_lhs;
    }
    var tmp10_elvis_lhs = tmp_0;
    var description = tmp10_elvis_lhs == null ? toString_0(json) : tmp10_elvis_lhs;
    var tmp_1;
    if (get_jsonObject(json).xmi('weak_password')) {
      var tmp0 = Default_getInstance();
      // Inline function 'kotlinx.serialization.json.decodeFromJsonElement' call
      var json_0 = ensureNotNull(get_jsonObject(json).je('weak_password'));
      // Inline function 'kotlinx.serialization.serializer' call
      var this_0 = tmp0.c75();
      // Inline function 'kotlinx.serialization.internal.cast' call
      var this_1 = serializer(this_0, createKType(getKClass(WeakPassword), arrayOf([]), false));
      var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
      tmp_1 = tmp0.mmg(tmp$ret$1, json_0);
    } else {
      tmp_1 = null;
    }
    var weakPassword = tmp_1;
    return new GoTrueErrorResponse(error, description, weakPassword);
  };
  protoOf(Companion_1).ywc = function (encoder, value) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(Companion_1).z70 = function (encoder, value) {
    return this.ywc(encoder, value instanceof GoTrueErrorResponse ? value : THROW_CCE());
  };
  var Companion_instance_2;
  function Companion_getInstance_8() {
    if (Companion_instance_2 == null)
      new Companion_1();
    return Companion_instance_2;
  }
  function GoTrueErrorResponse(error, description, weakPassword) {
    Companion_getInstance_8();
    description = description === VOID ? '' : description;
    weakPassword = weakPassword === VOID ? null : weakPassword;
    this.iw3_1 = error;
    this.jw3_1 = description;
    this.kw3_1 = weakPassword;
  }
  protoOf(GoTrueErrorResponse).toString = function () {
    return 'GoTrueErrorResponse(error=' + this.iw3_1 + ', description=' + this.jw3_1 + ', weakPassword=' + toString(this.kw3_1) + ')';
  };
  protoOf(GoTrueErrorResponse).hashCode = function () {
    var result = this.iw3_1 == null ? 0 : getStringHashCode(this.iw3_1);
    result = imul(result, 31) + getStringHashCode(this.jw3_1) | 0;
    result = imul(result, 31) + (this.kw3_1 == null ? 0 : this.kw3_1.hashCode()) | 0;
    return result;
  };
  protoOf(GoTrueErrorResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GoTrueErrorResponse))
      return false;
    if (!(this.iw3_1 == other.iw3_1))
      return false;
    if (!(this.jw3_1 === other.jw3_1))
      return false;
    if (!equals(this.kw3_1, other.kw3_1))
      return false;
    return true;
  };
  function OptionalJsonObjectModifier(json, withKey) {
    withKey = withKey === VOID ? null : withKey;
    this.zwc_1 = json;
    this.awd_1 = withKey;
  }
  protoOf(OptionalJsonObjectModifier).bwd = function (key) {
    return new OptionalJsonObjectModifier(this.zwc_1, key);
  };
  function get_optional(_this__u8e3s4) {
    return new OptionalJsonObjectModifier(_this__u8e3s4);
  }
  function putCaptchaToken(_this__u8e3s4, token) {
    putJsonObject_0(_this__u8e3s4, 'gotrue_meta_security', putCaptchaToken$lambda(token));
  }
  function putCodeChallenge(_this__u8e3s4, codeChallenge) {
    put(_this__u8e3s4, 'code_challenge', codeChallenge);
    put(_this__u8e3s4, 'code_challenge_method', 's256');
  }
  function putCaptchaToken$lambda($token) {
    return function ($this$putJsonObject) {
      put($this$putJsonObject, 'captcha_token', $token);
      return Unit_instance;
    };
  }
  function generateCodeVerifier() {
    var bytes = new Int8Array(64);
    Default_getInstance_0().tl(bytes);
    return Default_getInstance_1().xk_1.cl(bytes);
  }
  function generateCodeChallenge(codeVerifier) {
    var byteString = Companion_getInstance_4().ivs(encodeToByteArray(codeVerifier));
    var hash = byteString.nvs();
    return replace(Default_getInstance_1().xk_1.cl(hash.svs()), '=', '');
  }
  function defaultRedirectUrl(_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4.ebw().lvx_1;
    return tmp0_elvis_lhs == null ? defaultPlatformRedirectUrl(_this__u8e3s4) : tmp0_elvis_lhs;
  }
  function MemorySessionManager(session) {
    session = session === VOID ? null : session;
    this.cwd_1 = new AtomicReference(session);
  }
  protoOf(MemorySessionManager).iw7 = function (session, $completion) {
    this.cwd_1.b9(session);
    return Unit_instance;
  };
  protoOf(MemorySessionManager).gwb = function ($completion) {
    return this.cwd_1.a9();
  };
  protoOf(MemorySessionManager).dwc = function ($completion) {
    this.cwd_1.b9(null);
    return Unit_instance;
  };
  function SessionRefreshInformation(autoRefreshStartedAt, lastRefreshedAt, refreshingAt) {
    this.tw2_1 = autoRefreshStartedAt;
    this.uw2_1 = lastRefreshedAt;
    this.vw2_1 = refreshingAt;
  }
  protoOf(SessionRefreshInformation).dwd = function (autoRefreshStartedAt, lastRefreshedAt, refreshingAt) {
    return new SessionRefreshInformation(autoRefreshStartedAt, lastRefreshedAt, refreshingAt);
  };
  protoOf(SessionRefreshInformation).ww2 = function (autoRefreshStartedAt, lastRefreshedAt, refreshingAt, $super) {
    autoRefreshStartedAt = autoRefreshStartedAt === VOID ? this.tw2_1 : autoRefreshStartedAt;
    lastRefreshedAt = lastRefreshedAt === VOID ? this.uw2_1 : lastRefreshedAt;
    refreshingAt = refreshingAt === VOID ? this.vw2_1 : refreshingAt;
    return $super === VOID ? this.dwd(autoRefreshStartedAt, lastRefreshedAt, refreshingAt) : $super.dwd.call(this, autoRefreshStartedAt, lastRefreshedAt, refreshingAt);
  };
  protoOf(SessionRefreshInformation).toString = function () {
    return 'SessionRefreshInformation(autoRefreshStartedAt=' + this.tw2_1.toString() + ', lastRefreshedAt=' + toString(this.uw2_1) + ', refreshingAt=' + toString(this.vw2_1) + ')';
  };
  protoOf(SessionRefreshInformation).hashCode = function () {
    var result = this.tw2_1.hashCode();
    result = imul(result, 31) + (this.uw2_1 == null ? 0 : this.uw2_1.hashCode()) | 0;
    result = imul(result, 31) + (this.vw2_1 == null ? 0 : this.vw2_1.hashCode()) | 0;
    return result;
  };
  protoOf(SessionRefreshInformation).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SessionRefreshInformation))
      return false;
    if (!this.tw2_1.equals(other.tw2_1))
      return false;
    if (!equals(this.uw2_1, other.uw2_1))
      return false;
    if (!equals(this.vw2_1, other.vw2_1))
      return false;
    return true;
  };
  var SignOutScope_GLOBAL_instance;
  var SignOutScope_LOCAL_instance;
  var SignOutScope_OTHERS_instance;
  var SignOutScope_entriesInitialized;
  function SignOutScope_initEntries() {
    if (SignOutScope_entriesInitialized)
      return Unit_instance;
    SignOutScope_entriesInitialized = true;
    SignOutScope_GLOBAL_instance = new SignOutScope('GLOBAL', 0);
    SignOutScope_LOCAL_instance = new SignOutScope('LOCAL', 1);
    SignOutScope_OTHERS_instance = new SignOutScope('OTHERS', 2);
  }
  function SignOutScope(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function SignOutScope_LOCAL_getInstance() {
    SignOutScope_initEntries();
    return SignOutScope_LOCAL_instance;
  }
  function SignOutScope_OTHERS_getInstance() {
    SignOutScope_initEntries();
    return SignOutScope_OTHERS_instance;
  }
  function sam$io_github_jan_supabase_auth_UrlLauncher$0(function_0) {
    this.ewd_1 = function_0;
  }
  protoOf(sam$io_github_jan_supabase_auth_UrlLauncher$0).fwd = function (supabase, url, $completion) {
    return this.ewd_1(supabase, url, $completion);
  };
  protoOf(sam$io_github_jan_supabase_auth_UrlLauncher$0).q3 = function () {
    return this.ewd_1;
  };
  protoOf(sam$io_github_jan_supabase_auth_UrlLauncher$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, UrlLauncher) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$io_github_jan_supabase_auth_UrlLauncher$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function UrlLauncher$Companion$DEFAULT$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(UrlLauncher$Companion$DEFAULT$slambda).qwd = function (supabase, url, $completion) {
    var tmp = this.rwd(supabase, url, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(UrlLauncher$Companion$DEFAULT$slambda).ha = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, SupabaseClient) : false) ? p1 : THROW_CCE();
    return this.qwd(tmp, (!(p2 == null) ? typeof p2 === 'string' : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(UrlLauncher$Companion$DEFAULT$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = openExternalUrl(this.owd_1, this.pwd_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(UrlLauncher$Companion$DEFAULT$slambda).rwd = function (supabase, url, completion) {
    var i = new UrlLauncher$Companion$DEFAULT$slambda(completion);
    i.owd_1 = supabase;
    i.pwd_1 = url;
    return i;
  };
  function UrlLauncher$Companion$DEFAULT$slambda_0(resultContinuation) {
    var i = new UrlLauncher$Companion$DEFAULT$slambda(resultContinuation);
    return constructCallableReference(function (supabase, url, $completion) {
      return i.qwd(supabase, url, $completion);
    }, 2);
  }
  function Companion_2() {
    Companion_instance_3 = this;
    var tmp = this;
    var tmp_0 = UrlLauncher$Companion$DEFAULT$slambda_0(null);
    tmp.svz_1 = new sam$io_github_jan_supabase_auth_UrlLauncher$0(tmp_0);
  }
  var Companion_instance_3;
  function Companion_getInstance_9() {
    if (Companion_instance_3 == null)
      new Companion_2();
    return Companion_instance_3;
  }
  function UrlLauncher() {
  }
  function redirectTo(_this__u8e3s4, url) {
    _this__u8e3s4.ytr_1.qt5_1.dsq('redirect_to', url);
  }
  function tryToGetUser(_this__u8e3s4, accessToken, $completion) {
    var tmp = new $tryToGetUserCOROUTINE$(_this__u8e3s4, accessToken, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function invalidArg(message) {
    throw IllegalArgumentException_init_$Create$(message);
  }
  function initDone(_this__u8e3s4) {
    var tmp = _this__u8e3s4.svy().u1();
    if (tmp instanceof Initializing) {
      _this__u8e3s4.hvz(new NotAuthenticated());
    }
  }
  function $tryToGetUserCOROUTINE$(_this__u8e3s4, accessToken, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.awe_1 = _this__u8e3s4;
    this.bwe_1 = accessToken;
  }
  protoOf($tryToGetUserCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.awe_1.cvz(this.bwe_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.cwe_1 = suspendResult;
            this.o9_1 = 3;
            this.n9_1 = 4;
            continue $sm;
          case 2:
            this.o9_1 = 3;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Exception) {
              var e = this.q9_1;
              var tmp_1 = this;
              ensureActive(this.t9());
              var tmp0 = Companion_getInstance_6().wvx_1;
              var level = LogLevel_ERROR_getInstance();
              var tmp0_elvis_lhs = tmp0.fsu();
              if (level.i3(tmp0_elvis_lhs == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs) >= 0) {
                tmp0.fvj(level, e, "Couldn't retrieve user using access token " + this.bwe_1 + '.\nIf you use the project secret, ignore this message.');
              }
              tmp_1.cwe_1 = null;
              this.n9_1 = 4;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 3:
            throw this.q9_1;
          case 4:
            this.o9_1 = 3;
            return this.cwe_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 3) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function AdminApiImpl(api) {
    this.dwe_1 = api;
  }
  function ResolveAccessToken() {
  }
  function sam$io_github_jan_supabase_auth_api_ResolveAccessToken$0_0(function_0) {
    this.ewe_1 = function_0;
  }
  protoOf(sam$io_github_jan_supabase_auth_api_ResolveAccessToken$0_0).bvy = function (jwtToken, fallbackToKey, $completion) {
    return this.ewe_1(jwtToken, fallbackToKey, $completion);
  };
  protoOf(sam$io_github_jan_supabase_auth_api_ResolveAccessToken$0_0).q3 = function () {
    return this.ewe_1;
  };
  protoOf(sam$io_github_jan_supabase_auth_api_ResolveAccessToken$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ResolveAccessToken) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$io_github_jan_supabase_auth_api_ResolveAccessToken$0_0).hashCode = function () {
    return hashCode(this.q3());
  };
  function AuthenticatedApiConfig$Builder$build$lambda(it) {
    return it;
  }
  function AuthenticatedApiConfig$Builder$build$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AuthenticatedApiConfig$Builder$build$slambda).nvy = function (token, _unused_var__etf5q3, $completion) {
    var tmp = this.ovy(token, _unused_var__etf5q3, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthenticatedApiConfig$Builder$build$slambda).ha = function (p1, p2, $completion) {
    var tmp = (p1 == null ? true : typeof p1 === 'string') ? p1 : THROW_CCE();
    return this.nvy(tmp, (!(p2 == null) ? typeof p2 === 'boolean' : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(AuthenticatedApiConfig$Builder$build$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          return this.nwe_1;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(AuthenticatedApiConfig$Builder$build$slambda).ovy = function (token, _unused_var__etf5q3, completion) {
    var i = new AuthenticatedApiConfig$Builder$build$slambda(completion);
    i.nwe_1 = token;
    i.owe_1 = _unused_var__etf5q3;
    return i;
  };
  function AuthenticatedApiConfig$Builder$build$slambda_0(resultContinuation) {
    var i = new AuthenticatedApiConfig$Builder$build$slambda(resultContinuation);
    return constructCallableReference(function (token, _unused_var__etf5q3, $completion) {
      return i.nvy(token, _unused_var__etf5q3, $completion);
    }, 2);
  }
  function Context(resolveUrl, parseErrorResponse) {
    parseErrorResponse = parseErrorResponse === VOID ? null : parseErrorResponse;
    this.pwe_1 = resolveUrl;
    this.qwe_1 = parseErrorResponse;
  }
  protoOf(Context).rwe = function (resolveUrl, parseErrorResponse) {
    return new Context(resolveUrl, parseErrorResponse);
  };
  protoOf(Context).swe = function (resolveUrl, parseErrorResponse, $super) {
    resolveUrl = resolveUrl === VOID ? this.pwe_1 : resolveUrl;
    parseErrorResponse = parseErrorResponse === VOID ? this.qwe_1 : parseErrorResponse;
    return $super === VOID ? this.rwe(resolveUrl, parseErrorResponse) : $super.rwe.call(this, resolveUrl, parseErrorResponse);
  };
  protoOf(Context).toString = function () {
    return 'Context(resolveUrl=' + toString_0(this.pwe_1) + ', parseErrorResponse=' + toString(this.qwe_1) + ')';
  };
  protoOf(Context).hashCode = function () {
    var result = hashCode(this.pwe_1);
    result = imul(result, 31) + (this.qwe_1 == null ? 0 : hashCode(this.qwe_1)) | 0;
    return result;
  };
  protoOf(Context).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Context))
      return false;
    if (!equals(this.pwe_1, other.pwe_1))
      return false;
    if (!equals(this.qwe_1, other.qwe_1))
      return false;
    return true;
  };
  function Auth_0(requireSession, getAccessToken, jwtToken) {
    jwtToken = jwtToken === VOID ? null : jwtToken;
    this.twe_1 = requireSession;
    this.uwe_1 = getAccessToken;
    this.vwe_1 = jwtToken;
  }
  protoOf(Auth_0).toString = function () {
    return 'Auth(requireSession=' + this.twe_1 + ', getAccessToken=' + toString_0(this.uwe_1) + ', jwtToken=' + this.vwe_1 + ')';
  };
  protoOf(Auth_0).hashCode = function () {
    var result = getBooleanHashCode(this.twe_1);
    result = imul(result, 31) + hashCode(this.uwe_1) | 0;
    result = imul(result, 31) + (this.vwe_1 == null ? 0 : getStringHashCode(this.vwe_1)) | 0;
    return result;
  };
  protoOf(Auth_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Auth_0))
      return false;
    if (!(this.twe_1 === other.twe_1))
      return false;
    if (!equals(this.uwe_1, other.uwe_1))
      return false;
    if (!(this.vwe_1 == other.vwe_1))
      return false;
    return true;
  };
  function Request(defaultRequest, urlLengthLimit) {
    defaultRequest = defaultRequest === VOID ? null : defaultRequest;
    urlLengthLimit = urlLengthLimit === VOID ? null : urlLengthLimit;
    this.wwe_1 = defaultRequest;
    this.xwe_1 = urlLengthLimit;
  }
  protoOf(Request).ywe = function (defaultRequest, urlLengthLimit) {
    return new Request(defaultRequest, urlLengthLimit);
  };
  protoOf(Request).zwe = function (defaultRequest, urlLengthLimit, $super) {
    defaultRequest = defaultRequest === VOID ? this.wwe_1 : defaultRequest;
    urlLengthLimit = urlLengthLimit === VOID ? this.xwe_1 : urlLengthLimit;
    return $super === VOID ? this.ywe(defaultRequest, urlLengthLimit) : $super.ywe.call(this, defaultRequest, urlLengthLimit);
  };
  protoOf(Request).toString = function () {
    return 'Request(defaultRequest=' + toString(this.wwe_1) + ', urlLengthLimit=' + this.xwe_1 + ')';
  };
  protoOf(Request).hashCode = function () {
    var result = this.wwe_1 == null ? 0 : hashCode(this.wwe_1);
    result = imul(result, 31) + (this.xwe_1 == null ? 0 : this.xwe_1) | 0;
    return result;
  };
  protoOf(Request).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Request))
      return false;
    if (!equals(this.wwe_1, other.wwe_1))
      return false;
    if (!(this.xwe_1 == other.xwe_1))
      return false;
    return true;
  };
  function Builder() {
    this.awf_1 = null;
    this.bwf_1 = null;
    this.cwf_1 = null;
    this.dwf_1 = null;
    this.ewf_1 = false;
    this.fwf_1 = null;
    this.gwf_1 = null;
  }
  protoOf(Builder).g3d = function () {
    var tmp0_elvis_lhs = this.awf_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      tmp = AuthenticatedApiConfig$Builder$build$lambda;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var tmp_0 = new Context(tmp, this.bwf_1);
    var tmp_1 = this.ewf_1;
    var tmp1_elvis_lhs = this.gwf_1;
    var tmp_2;
    if (tmp1_elvis_lhs == null) {
      var tmp_3 = AuthenticatedApiConfig$Builder$build$slambda_0(null);
      tmp_2 = new sam$io_github_jan_supabase_auth_api_ResolveAccessToken$0_0(tmp_3);
    } else {
      tmp_2 = tmp1_elvis_lhs;
    }
    return new AuthenticatedApiConfig(tmp_0, new Auth_0(tmp_1, tmp_2, this.cwf_1), new Request(this.dwf_1, this.fwf_1));
  };
  function AuthenticatedApiConfig(context, auth, request) {
    request = request === VOID ? new Request() : request;
    this.hwf_1 = context;
    this.iwf_1 = auth;
    this.jwf_1 = request;
  }
  protoOf(AuthenticatedApiConfig).kwf = function (context, auth, request) {
    return new AuthenticatedApiConfig(context, auth, request);
  };
  protoOf(AuthenticatedApiConfig).lwf = function (context, auth, request, $super) {
    context = context === VOID ? this.hwf_1 : context;
    auth = auth === VOID ? this.iwf_1 : auth;
    request = request === VOID ? this.jwf_1 : request;
    return $super === VOID ? this.kwf(context, auth, request) : $super.kwf.call(this, context, auth, request);
  };
  protoOf(AuthenticatedApiConfig).toString = function () {
    return 'AuthenticatedApiConfig(context=' + this.hwf_1.toString() + ', auth=' + this.iwf_1.toString() + ', request=' + this.jwf_1.toString() + ')';
  };
  protoOf(AuthenticatedApiConfig).hashCode = function () {
    var result = this.hwf_1.hashCode();
    result = imul(result, 31) + this.iwf_1.hashCode() | 0;
    result = imul(result, 31) + this.jwf_1.hashCode() | 0;
    return result;
  };
  protoOf(AuthenticatedApiConfig).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AuthenticatedApiConfig))
      return false;
    if (!this.hwf_1.equals(other.hwf_1))
      return false;
    if (!this.iwf_1.equals(other.iwf_1))
      return false;
    if (!this.jwf_1.equals(other.jwf_1))
      return false;
    return true;
  };
  function authenticatedSupabaseApi(_this__u8e3s4, plugin, defaultRequest, requireSession, urlLengthLimit) {
    defaultRequest = defaultRequest === VOID ? null : defaultRequest;
    requireSession = requireSession === VOID ? plugin.ebw().tvz() : requireSession;
    urlLengthLimit = urlLengthLimit === VOID ? null : urlLengthLimit;
    return authenticatedSupabaseApi_0(_this__u8e3s4, plugin, requireSession, authenticatedSupabaseApi$lambda(defaultRequest, urlLengthLimit));
  }
  function authenticatedSupabaseApi_0(_this__u8e3s4, plugin, requireSession, configure) {
    requireSession = requireSession === VOID ? plugin.ebw().tvz() : requireSession;
    var client = _this__u8e3s4;
    var tmp = MainPlugin$resolveUrl$ref(plugin);
    var tmp_0 = MainPlugin$parseErrorResponse$ref_0(plugin);
    return authenticatedSupabaseApi_1(_this__u8e3s4, tmp, tmp_0, requireSession, authenticatedSupabaseApi$lambda_0(plugin, client, configure));
  }
  function authenticatedSupabaseApi_1(_this__u8e3s4, resolveUrl, parseErrorResponse, requireSession, configure) {
    parseErrorResponse = parseErrorResponse === VOID ? null : parseErrorResponse;
    return new AuthenticatedSupabaseApi(_this__u8e3s4.uvj(), buildAuthenticatedApiConfig(_this__u8e3s4, resolveUrl, parseErrorResponse, requireSession, configure));
  }
  function buildAuthenticatedApiConfig(_this__u8e3s4, resolveUrl, parseErrorResponse, requireSession, configure) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Builder();
    this_0.awf_1 = resolveUrl;
    this_0.bwf_1 = parseErrorResponse;
    this_0.ewf_1 = requireSession;
    this_0.gwf_1 = Companion_getInstance_6().pvy(_this__u8e3s4);
    configure(this_0);
    return this_0.g3d();
  }
  function authenticatedSupabaseApi$lambda($defaultRequest, $urlLengthLimit) {
    return function ($this$authenticatedSupabaseApi) {
      $this$authenticatedSupabaseApi.dwf_1 = $defaultRequest;
      $this$authenticatedSupabaseApi.fwf_1 = $urlLengthLimit;
      return Unit_instance;
    };
  }
  function MainPlugin$resolveUrl$ref(p0) {
    return constructCallableReference(function (p0_0) {
      return p0.vvn(p0_0);
    }, 1, 0, 517, 'resolveUrl', [p0]);
  }
  function MainPlugin$parseErrorResponse$ref(p0) {
    KFunctionImpl.call(this, 1, 2, 516);
    this.pwf_1 = p0;
  }
  protoOf(MainPlugin$parseErrorResponse$ref).rvn = function (p0, $completion) {
    return this.pwf_1.svn(p0, $completion);
  };
  protoOf(MainPlugin$parseErrorResponse$ref).ja = function (p1, $completion) {
    return this.rvn(p1 instanceof HttpResponse ? p1 : THROW_CCE(), $completion);
  };
  function MainPlugin$parseErrorResponse$ref_0(p0) {
    var i = new MainPlugin$parseErrorResponse$ref(p0);
    return constructCallableReference(function (p0, $completion) {
      return i.rvn(p0, $completion);
    }, 1, 1, 516, 'parseErrorResponse', [p0]);
  }
  function authenticatedSupabaseApi$lambda_0($plugin, $client, $configure) {
    return function ($this$authenticatedSupabaseApi) {
      $this$authenticatedSupabaseApi.cwf_1 = $plugin.ebw().xvn_1;
      $this$authenticatedSupabaseApi.gwf_1 = Companion_getInstance_6().pvy($client);
      $configure($this$authenticatedSupabaseApi);
      return Unit_instance;
    };
  }
  function checkUrlLength($this, $receiver) {
    if ($this.iwc_1.jwf_1.xwe_1 == null)
      return Unit_instance;
    var length = $receiver.ytr_1.toString().length;
    if (length > $this.iwc_1.jwf_1.xwe_1) {
      // Inline function 'kotlin.error' call
      var message = 'Your URL length exceeds the limit of ' + $this.iwc_1.jwf_1.xwe_1 + ' characters (' + length + '). Url: ' + StringMasking_getInstance().mvj($receiver.ytr_1.g3d());
      throw IllegalStateException_init_$Create$(toString_0(message));
    }
  }
  function Companion_3() {
  }
  var Companion_instance_4;
  function Companion_getInstance_10() {
    return Companion_instance_4;
  }
  function AuthenticatedSupabaseApi$rawRequest$lambda($accessToken, this$0, $builder) {
    return function ($this$rawRequest) {
      bearerAuth($this$rawRequest, $accessToken);
      var tmp0_safe_receiver = this$0.jwc_1;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver($this$rawRequest);
      $builder($this$rawRequest);
      checkUrlLength(this$0, $this$rawRequest);
      return Unit_instance;
    };
  }
  function AuthenticatedSupabaseApi$withDefaultRequest$lambda(this$0, $builder) {
    return function ($this$copy) {
      var tmp0_safe_receiver = this$0.iwc_1.jwf_1.wwe_1;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver($this$copy);
      $builder($this$copy);
      return Unit_instance;
    };
  }
  function AuthenticatedSupabaseApi$resolve$lambda(this$0, $path) {
    return function (it) {
      return this$0.jvn_1($path + '/' + it);
    };
  }
  function $rawRequestCOROUTINE$(_this__u8e3s4, url, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ywf_1 = _this__u8e3s4;
    this.zwf_1 = url;
    this.awg_1 = builder;
  }
  protoOf($rawRequestCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.n9_1 = 1;
            suspendResult = this.ywf_1.iwc_1.iwf_1.uwe_1.bvy(this.ywf_1.kwc_1, !this.ywf_1.lwc_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_elvis_lhs = suspendResult;
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              throw new SessionRequiredException(this.zwf_1);
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var accessToken = tmp_0;
            this.n9_1 = 2;
            suspendResult = protoOf(SupabaseApi).mvn.call(this.ywf_1, this.zwf_1, AuthenticatedSupabaseApi$rawRequest$lambda(accessToken, this.ywf_1, this.awg_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function AuthenticatedSupabaseApi(httpClient, config) {
    SupabaseApi.call(this, config.hwf_1.pwe_1, config.hwf_1.qwe_1, httpClient);
    this.iwc_1 = config;
    this.jwc_1 = this.iwc_1.jwf_1.wwe_1;
    this.kwc_1 = this.iwc_1.iwf_1.vwe_1;
    this.lwc_1 = this.iwc_1.iwf_1.twe_1;
  }
  protoOf(AuthenticatedSupabaseApi).mvn = function (url, builder, $completion) {
    var tmp = new $rawRequestCOROUTINE$(this, url, builder, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AuthenticatedSupabaseApi).bwg = function (builder, $completion) {
    return this.mvn('', builder, $completion);
  };
  protoOf(AuthenticatedSupabaseApi).cwg = function (builder) {
    return new AuthenticatedSupabaseApi(this.lvn_1, this.iwc_1.lwf(VOID, VOID, this.iwc_1.jwf_1.zwe(AuthenticatedSupabaseApi$withDefaultRequest$lambda(this, builder))));
  };
  protoOf(AuthenticatedSupabaseApi).mwc = function (path) {
    return new AuthenticatedSupabaseApi(this.lvn_1, this.iwc_1.lwf(this.iwc_1.hwf_1.swe(AuthenticatedSupabaseApi$resolve$lambda(this, path))));
  };
  function OtpError(error, errorDescription) {
    this.dwg_1 = error;
    this.ewg_1 = errorDescription;
    this.fwg_1 = Companion_instance_5.gwg(this.dwg_1);
  }
  protoOf(OtpError).toString = function () {
    return 'OtpError(error=' + this.dwg_1 + ', errorDescription=' + this.ewg_1 + ')';
  };
  protoOf(OtpError).hashCode = function () {
    var result = getStringHashCode(this.dwg_1);
    result = imul(result, 31) + getStringHashCode(this.ewg_1) | 0;
    return result;
  };
  protoOf(OtpError).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OtpError))
      return false;
    if (!(this.dwg_1 === other.dwg_1))
      return false;
    if (!(this.ewg_1 === other.ewg_1))
      return false;
    return true;
  };
  function RefreshFailure(cause) {
    this.hwg_1 = cause;
  }
  protoOf(RefreshFailure).toString = function () {
    return 'RefreshFailure(cause=' + toString_0(this.hwg_1) + ')';
  };
  protoOf(RefreshFailure).hashCode = function () {
    return hashCode(this.hwg_1);
  };
  protoOf(RefreshFailure).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RefreshFailure))
      return false;
    if (!equals(this.hwg_1, other.hwg_1))
      return false;
    return true;
  };
  var AuthErrorCode_UnexpectedFailure_instance;
  var AuthErrorCode_ValidationFailed_instance;
  var AuthErrorCode_BadJson_instance;
  var AuthErrorCode_EmailExists_instance;
  var AuthErrorCode_PhoneExists_instance;
  var AuthErrorCode_BadJwt_instance;
  var AuthErrorCode_NotAdmin_instance;
  var AuthErrorCode_NoAuthorization_instance;
  var AuthErrorCode_UserNotFound_instance;
  var AuthErrorCode_SessionNotFound_instance;
  var AuthErrorCode_SessionExpired_instance;
  var AuthErrorCode_RefreshTokenNotFound_instance;
  var AuthErrorCode_RefreshTokenAlreadyUsed_instance;
  var AuthErrorCode_FlowStateNotFound_instance;
  var AuthErrorCode_FlowStateExpired_instance;
  var AuthErrorCode_SignupDisabled_instance;
  var AuthErrorCode_UserBanned_instance;
  var AuthErrorCode_ProviderEmailNeedsVerification_instance;
  var AuthErrorCode_InviteNotFound_instance;
  var AuthErrorCode_BadOauthState_instance;
  var AuthErrorCode_BadOauthCallback_instance;
  var AuthErrorCode_OauthProviderNotSupported_instance;
  var AuthErrorCode_UnexpectedAudience_instance;
  var AuthErrorCode_SingleIdentityNotDeletable_instance;
  var AuthErrorCode_EmailConflictIdentityNotDeletable_instance;
  var AuthErrorCode_IdentityAlreadyExists_instance;
  var AuthErrorCode_EmailProviderDisabled_instance;
  var AuthErrorCode_PhoneProviderDisabled_instance;
  var AuthErrorCode_TooManyEnrolledMfaFactors_instance;
  var AuthErrorCode_MfaFactorNameConflict_instance;
  var AuthErrorCode_MfaFactorNotFound_instance;
  var AuthErrorCode_MfaIpAddressMismatch_instance;
  var AuthErrorCode_MfaChallengeExpired_instance;
  var AuthErrorCode_MfaVerificationFailed_instance;
  var AuthErrorCode_MfaVerificationRejected_instance;
  var AuthErrorCode_InsufficientAal_instance;
  var AuthErrorCode_CaptchaFailed_instance;
  var AuthErrorCode_SamlProviderDisabled_instance;
  var AuthErrorCode_ManualLinkingDisabled_instance;
  var AuthErrorCode_SmsSendFailed_instance;
  var AuthErrorCode_EmailNotConfirmed_instance;
  var AuthErrorCode_PhoneNotConfirmed_instance;
  var AuthErrorCode_ReauthNonceMissing_instance;
  var AuthErrorCode_SamlRelayStateNotFound_instance;
  var AuthErrorCode_SamlRelayStateExpired_instance;
  var AuthErrorCode_SamlIdpNotFound_instance;
  var AuthErrorCode_SamlAssertionNoUserId_instance;
  var AuthErrorCode_SamlAssertionNoEmail_instance;
  var AuthErrorCode_UserAlreadyExists_instance;
  var AuthErrorCode_SsoProviderNotFound_instance;
  var AuthErrorCode_SamlMetadataFetchFailed_instance;
  var AuthErrorCode_SamlIdpAlreadyExists_instance;
  var AuthErrorCode_SsoDomainAlreadyExists_instance;
  var AuthErrorCode_SamlEntityIdMismatch_instance;
  var AuthErrorCode_Conflict_instance;
  var AuthErrorCode_ProviderDisabled_instance;
  var AuthErrorCode_UserSsoManaged_instance;
  var AuthErrorCode_ReauthenticationNeeded_instance;
  var AuthErrorCode_SamePassword_instance;
  var AuthErrorCode_ReauthenticationNotValid_instance;
  var AuthErrorCode_OtpExpired_instance;
  var AuthErrorCode_OtpDisabled_instance;
  var AuthErrorCode_IdentityNotFound_instance;
  var AuthErrorCode_WeakPassword_instance;
  var AuthErrorCode_OverRequestRateLimit_instance;
  var AuthErrorCode_OverEmailSendRateLimit_instance;
  var AuthErrorCode_OverSmsSendRateLimit_instance;
  var AuthErrorCode_BadCodeVerifier_instance;
  var AuthErrorCode_InvalidCredentials_instance;
  var AuthErrorCode_EmailAddressNotAuthorized_instance;
  var AuthErrorCode_AnonymousProviderDisabled_instance;
  var AuthErrorCode_HookTimeout_instance;
  var AuthErrorCode_HookTimeoutAfterRetry_instance;
  var AuthErrorCode_HookPayloadOverSizeLimit_instance;
  var AuthErrorCode_HookPayloadInvalidContentType_instance;
  var AuthErrorCode_RequestTimeout_instance;
  var AuthErrorCode_MfaPhoneEnrollDisabled_instance;
  var AuthErrorCode_MfaPhoneVerifyDisabled_instance;
  var AuthErrorCode_MfaTotpEnrollDisabled_instance;
  var AuthErrorCode_MfaTotpVerifyDisabled_instance;
  var AuthErrorCode_MfaWebAuthnEnrollDisabled_instance;
  var AuthErrorCode_MfaWebAuthnVerifyDisabled_instance;
  var AuthErrorCode_MfaVerifiedFactorExists_instance;
  var AuthErrorCode_EmailAddressInvalid_instance;
  var AuthErrorCode_Web3ProviderDisabled_instance;
  var AuthErrorCode_Web3UnsupportedChain_instance;
  function Companion_4() {
  }
  protoOf(Companion_4).gwg = function (value) {
    var tmp0 = get_entries();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        if (element.kwg_1 === value) {
          tmp$ret$0 = element;
          break $l$block;
        }
      }
      tmp$ret$0 = null;
    }
    return tmp$ret$0;
  };
  var Companion_instance_5;
  function Companion_getInstance_11() {
    return Companion_instance_5;
  }
  function values() {
    return [AuthErrorCode_UnexpectedFailure_getInstance(), AuthErrorCode_ValidationFailed_getInstance(), AuthErrorCode_BadJson_getInstance(), AuthErrorCode_EmailExists_getInstance(), AuthErrorCode_PhoneExists_getInstance(), AuthErrorCode_BadJwt_getInstance(), AuthErrorCode_NotAdmin_getInstance(), AuthErrorCode_NoAuthorization_getInstance(), AuthErrorCode_UserNotFound_getInstance(), AuthErrorCode_SessionNotFound_getInstance(), AuthErrorCode_SessionExpired_getInstance(), AuthErrorCode_RefreshTokenNotFound_getInstance(), AuthErrorCode_RefreshTokenAlreadyUsed_getInstance(), AuthErrorCode_FlowStateNotFound_getInstance(), AuthErrorCode_FlowStateExpired_getInstance(), AuthErrorCode_SignupDisabled_getInstance(), AuthErrorCode_UserBanned_getInstance(), AuthErrorCode_ProviderEmailNeedsVerification_getInstance(), AuthErrorCode_InviteNotFound_getInstance(), AuthErrorCode_BadOauthState_getInstance(), AuthErrorCode_BadOauthCallback_getInstance(), AuthErrorCode_OauthProviderNotSupported_getInstance(), AuthErrorCode_UnexpectedAudience_getInstance(), AuthErrorCode_SingleIdentityNotDeletable_getInstance(), AuthErrorCode_EmailConflictIdentityNotDeletable_getInstance(), AuthErrorCode_IdentityAlreadyExists_getInstance(), AuthErrorCode_EmailProviderDisabled_getInstance(), AuthErrorCode_PhoneProviderDisabled_getInstance(), AuthErrorCode_TooManyEnrolledMfaFactors_getInstance(), AuthErrorCode_MfaFactorNameConflict_getInstance(), AuthErrorCode_MfaFactorNotFound_getInstance(), AuthErrorCode_MfaIpAddressMismatch_getInstance(), AuthErrorCode_MfaChallengeExpired_getInstance(), AuthErrorCode_MfaVerificationFailed_getInstance(), AuthErrorCode_MfaVerificationRejected_getInstance(), AuthErrorCode_InsufficientAal_getInstance(), AuthErrorCode_CaptchaFailed_getInstance(), AuthErrorCode_SamlProviderDisabled_getInstance(), AuthErrorCode_ManualLinkingDisabled_getInstance(), AuthErrorCode_SmsSendFailed_getInstance(), AuthErrorCode_EmailNotConfirmed_getInstance(), AuthErrorCode_PhoneNotConfirmed_getInstance(), AuthErrorCode_ReauthNonceMissing_getInstance(), AuthErrorCode_SamlRelayStateNotFound_getInstance(), AuthErrorCode_SamlRelayStateExpired_getInstance(), AuthErrorCode_SamlIdpNotFound_getInstance(), AuthErrorCode_SamlAssertionNoUserId_getInstance(), AuthErrorCode_SamlAssertionNoEmail_getInstance(), AuthErrorCode_UserAlreadyExists_getInstance(), AuthErrorCode_SsoProviderNotFound_getInstance(), AuthErrorCode_SamlMetadataFetchFailed_getInstance(), AuthErrorCode_SamlIdpAlreadyExists_getInstance(), AuthErrorCode_SsoDomainAlreadyExists_getInstance(), AuthErrorCode_SamlEntityIdMismatch_getInstance(), AuthErrorCode_Conflict_getInstance(), AuthErrorCode_ProviderDisabled_getInstance(), AuthErrorCode_UserSsoManaged_getInstance(), AuthErrorCode_ReauthenticationNeeded_getInstance(), AuthErrorCode_SamePassword_getInstance(), AuthErrorCode_ReauthenticationNotValid_getInstance(), AuthErrorCode_OtpExpired_getInstance(), AuthErrorCode_OtpDisabled_getInstance(), AuthErrorCode_IdentityNotFound_getInstance(), AuthErrorCode_WeakPassword_getInstance(), AuthErrorCode_OverRequestRateLimit_getInstance(), AuthErrorCode_OverEmailSendRateLimit_getInstance(), AuthErrorCode_OverSmsSendRateLimit_getInstance(), AuthErrorCode_BadCodeVerifier_getInstance(), AuthErrorCode_InvalidCredentials_getInstance(), AuthErrorCode_EmailAddressNotAuthorized_getInstance(), AuthErrorCode_AnonymousProviderDisabled_getInstance(), AuthErrorCode_HookTimeout_getInstance(), AuthErrorCode_HookTimeoutAfterRetry_getInstance(), AuthErrorCode_HookPayloadOverSizeLimit_getInstance(), AuthErrorCode_HookPayloadInvalidContentType_getInstance(), AuthErrorCode_RequestTimeout_getInstance(), AuthErrorCode_MfaPhoneEnrollDisabled_getInstance(), AuthErrorCode_MfaPhoneVerifyDisabled_getInstance(), AuthErrorCode_MfaTotpEnrollDisabled_getInstance(), AuthErrorCode_MfaTotpVerifyDisabled_getInstance(), AuthErrorCode_MfaWebAuthnEnrollDisabled_getInstance(), AuthErrorCode_MfaWebAuthnVerifyDisabled_getInstance(), AuthErrorCode_MfaVerifiedFactorExists_getInstance(), AuthErrorCode_EmailAddressInvalid_getInstance(), AuthErrorCode_Web3ProviderDisabled_getInstance(), AuthErrorCode_Web3UnsupportedChain_getInstance()];
  }
  function get_entries() {
    if ($ENTRIES == null)
      $ENTRIES = enumEntries(values());
    return $ENTRIES;
  }
  var AuthErrorCode_entriesInitialized;
  function AuthErrorCode_initEntries() {
    if (AuthErrorCode_entriesInitialized)
      return Unit_instance;
    AuthErrorCode_entriesInitialized = true;
    AuthErrorCode_UnexpectedFailure_instance = new AuthErrorCode('UnexpectedFailure', 0, 'unexpected_failure');
    AuthErrorCode_ValidationFailed_instance = new AuthErrorCode('ValidationFailed', 1, 'validation_failed');
    AuthErrorCode_BadJson_instance = new AuthErrorCode('BadJson', 2, 'bad_json');
    AuthErrorCode_EmailExists_instance = new AuthErrorCode('EmailExists', 3, 'email_exists');
    AuthErrorCode_PhoneExists_instance = new AuthErrorCode('PhoneExists', 4, 'phone_exists');
    AuthErrorCode_BadJwt_instance = new AuthErrorCode('BadJwt', 5, 'bad_jwt');
    AuthErrorCode_NotAdmin_instance = new AuthErrorCode('NotAdmin', 6, 'not_admin');
    AuthErrorCode_NoAuthorization_instance = new AuthErrorCode('NoAuthorization', 7, 'no_authorization');
    AuthErrorCode_UserNotFound_instance = new AuthErrorCode('UserNotFound', 8, 'user_not_found');
    AuthErrorCode_SessionNotFound_instance = new AuthErrorCode('SessionNotFound', 9, 'session_not_found');
    AuthErrorCode_SessionExpired_instance = new AuthErrorCode('SessionExpired', 10, 'session_expired');
    AuthErrorCode_RefreshTokenNotFound_instance = new AuthErrorCode('RefreshTokenNotFound', 11, 'refresh_token_not_found');
    AuthErrorCode_RefreshTokenAlreadyUsed_instance = new AuthErrorCode('RefreshTokenAlreadyUsed', 12, 'refresh_token_already_used');
    AuthErrorCode_FlowStateNotFound_instance = new AuthErrorCode('FlowStateNotFound', 13, 'flow_state_not_found');
    AuthErrorCode_FlowStateExpired_instance = new AuthErrorCode('FlowStateExpired', 14, 'flow_state_expired');
    AuthErrorCode_SignupDisabled_instance = new AuthErrorCode('SignupDisabled', 15, 'signup_disabled');
    AuthErrorCode_UserBanned_instance = new AuthErrorCode('UserBanned', 16, 'user_banned');
    AuthErrorCode_ProviderEmailNeedsVerification_instance = new AuthErrorCode('ProviderEmailNeedsVerification', 17, 'provider_email_needs_verification');
    AuthErrorCode_InviteNotFound_instance = new AuthErrorCode('InviteNotFound', 18, 'invite_not_found');
    AuthErrorCode_BadOauthState_instance = new AuthErrorCode('BadOauthState', 19, 'bad_oauth_state');
    AuthErrorCode_BadOauthCallback_instance = new AuthErrorCode('BadOauthCallback', 20, 'bad_oauth_callback');
    AuthErrorCode_OauthProviderNotSupported_instance = new AuthErrorCode('OauthProviderNotSupported', 21, 'oauth_provider_not_supported');
    AuthErrorCode_UnexpectedAudience_instance = new AuthErrorCode('UnexpectedAudience', 22, 'unexpected_audience');
    AuthErrorCode_SingleIdentityNotDeletable_instance = new AuthErrorCode('SingleIdentityNotDeletable', 23, 'single_identity_not_deletable');
    AuthErrorCode_EmailConflictIdentityNotDeletable_instance = new AuthErrorCode('EmailConflictIdentityNotDeletable', 24, 'email_conflict_identity_not_deletable');
    AuthErrorCode_IdentityAlreadyExists_instance = new AuthErrorCode('IdentityAlreadyExists', 25, 'identity_already_exists');
    AuthErrorCode_EmailProviderDisabled_instance = new AuthErrorCode('EmailProviderDisabled', 26, 'email_provider_disabled');
    AuthErrorCode_PhoneProviderDisabled_instance = new AuthErrorCode('PhoneProviderDisabled', 27, 'phone_provider_disabled');
    AuthErrorCode_TooManyEnrolledMfaFactors_instance = new AuthErrorCode('TooManyEnrolledMfaFactors', 28, 'too_many_enrolled_mfa_factors');
    AuthErrorCode_MfaFactorNameConflict_instance = new AuthErrorCode('MfaFactorNameConflict', 29, 'mfa_factor_name_conflict');
    AuthErrorCode_MfaFactorNotFound_instance = new AuthErrorCode('MfaFactorNotFound', 30, 'mfa_factor_not_found');
    AuthErrorCode_MfaIpAddressMismatch_instance = new AuthErrorCode('MfaIpAddressMismatch', 31, 'mfa_ip_address_mismatch');
    AuthErrorCode_MfaChallengeExpired_instance = new AuthErrorCode('MfaChallengeExpired', 32, 'mfa_challenge_expired');
    AuthErrorCode_MfaVerificationFailed_instance = new AuthErrorCode('MfaVerificationFailed', 33, 'mfa_verification_failed');
    AuthErrorCode_MfaVerificationRejected_instance = new AuthErrorCode('MfaVerificationRejected', 34, 'mfa_verification_rejected');
    AuthErrorCode_InsufficientAal_instance = new AuthErrorCode('InsufficientAal', 35, 'insufficient_aal');
    AuthErrorCode_CaptchaFailed_instance = new AuthErrorCode('CaptchaFailed', 36, 'captcha_failed');
    AuthErrorCode_SamlProviderDisabled_instance = new AuthErrorCode('SamlProviderDisabled', 37, 'saml_provider_disabled');
    AuthErrorCode_ManualLinkingDisabled_instance = new AuthErrorCode('ManualLinkingDisabled', 38, 'manual_linking_disabled');
    AuthErrorCode_SmsSendFailed_instance = new AuthErrorCode('SmsSendFailed', 39, 'sms_send_failed');
    AuthErrorCode_EmailNotConfirmed_instance = new AuthErrorCode('EmailNotConfirmed', 40, 'email_not_confirmed');
    AuthErrorCode_PhoneNotConfirmed_instance = new AuthErrorCode('PhoneNotConfirmed', 41, 'phone_not_confirmed');
    AuthErrorCode_ReauthNonceMissing_instance = new AuthErrorCode('ReauthNonceMissing', 42, 'reauth_nonce_missing');
    AuthErrorCode_SamlRelayStateNotFound_instance = new AuthErrorCode('SamlRelayStateNotFound', 43, 'saml_relay_state_not_found');
    AuthErrorCode_SamlRelayStateExpired_instance = new AuthErrorCode('SamlRelayStateExpired', 44, 'saml_relay_state_expired');
    AuthErrorCode_SamlIdpNotFound_instance = new AuthErrorCode('SamlIdpNotFound', 45, 'saml_idp_not_found');
    AuthErrorCode_SamlAssertionNoUserId_instance = new AuthErrorCode('SamlAssertionNoUserId', 46, 'saml_assertion_no_user_id');
    AuthErrorCode_SamlAssertionNoEmail_instance = new AuthErrorCode('SamlAssertionNoEmail', 47, 'saml_assertion_no_email');
    AuthErrorCode_UserAlreadyExists_instance = new AuthErrorCode('UserAlreadyExists', 48, 'user_already_exists');
    AuthErrorCode_SsoProviderNotFound_instance = new AuthErrorCode('SsoProviderNotFound', 49, 'sso_provider_not_found');
    AuthErrorCode_SamlMetadataFetchFailed_instance = new AuthErrorCode('SamlMetadataFetchFailed', 50, 'saml_metadata_fetch_failed');
    AuthErrorCode_SamlIdpAlreadyExists_instance = new AuthErrorCode('SamlIdpAlreadyExists', 51, 'saml_idp_already_exists');
    AuthErrorCode_SsoDomainAlreadyExists_instance = new AuthErrorCode('SsoDomainAlreadyExists', 52, 'sso_domain_already_exists');
    AuthErrorCode_SamlEntityIdMismatch_instance = new AuthErrorCode('SamlEntityIdMismatch', 53, 'saml_entity_id_mismatch');
    AuthErrorCode_Conflict_instance = new AuthErrorCode('Conflict', 54, 'conflict');
    AuthErrorCode_ProviderDisabled_instance = new AuthErrorCode('ProviderDisabled', 55, 'provider_disabled');
    AuthErrorCode_UserSsoManaged_instance = new AuthErrorCode('UserSsoManaged', 56, 'user_sso_managed');
    AuthErrorCode_ReauthenticationNeeded_instance = new AuthErrorCode('ReauthenticationNeeded', 57, 'reauthentication_needed');
    AuthErrorCode_SamePassword_instance = new AuthErrorCode('SamePassword', 58, 'same_password');
    AuthErrorCode_ReauthenticationNotValid_instance = new AuthErrorCode('ReauthenticationNotValid', 59, 'reauthentication_not_valid');
    AuthErrorCode_OtpExpired_instance = new AuthErrorCode('OtpExpired', 60, 'otp_expired');
    AuthErrorCode_OtpDisabled_instance = new AuthErrorCode('OtpDisabled', 61, 'otp_disabled');
    AuthErrorCode_IdentityNotFound_instance = new AuthErrorCode('IdentityNotFound', 62, 'identity_not_found');
    AuthErrorCode_WeakPassword_instance = new AuthErrorCode('WeakPassword', 63, 'weak_password');
    AuthErrorCode_OverRequestRateLimit_instance = new AuthErrorCode('OverRequestRateLimit', 64, 'over_request_rate_limit');
    AuthErrorCode_OverEmailSendRateLimit_instance = new AuthErrorCode('OverEmailSendRateLimit', 65, 'over_email_send_rate_limit');
    AuthErrorCode_OverSmsSendRateLimit_instance = new AuthErrorCode('OverSmsSendRateLimit', 66, 'over_sms_send_rate_limit');
    AuthErrorCode_BadCodeVerifier_instance = new AuthErrorCode('BadCodeVerifier', 67, 'bad_code_verifier');
    AuthErrorCode_InvalidCredentials_instance = new AuthErrorCode('InvalidCredentials', 68, 'invalid_credentials');
    AuthErrorCode_EmailAddressNotAuthorized_instance = new AuthErrorCode('EmailAddressNotAuthorized', 69, 'email_address_not_authorized');
    AuthErrorCode_AnonymousProviderDisabled_instance = new AuthErrorCode('AnonymousProviderDisabled', 70, 'anonymous_provider_disabled');
    AuthErrorCode_HookTimeout_instance = new AuthErrorCode('HookTimeout', 71, 'hook_timeout');
    AuthErrorCode_HookTimeoutAfterRetry_instance = new AuthErrorCode('HookTimeoutAfterRetry', 72, 'hook_timeout_after_retry');
    AuthErrorCode_HookPayloadOverSizeLimit_instance = new AuthErrorCode('HookPayloadOverSizeLimit', 73, 'hook_payload_over_size_limit');
    AuthErrorCode_HookPayloadInvalidContentType_instance = new AuthErrorCode('HookPayloadInvalidContentType', 74, 'hook_payload_invalid_content_type');
    AuthErrorCode_RequestTimeout_instance = new AuthErrorCode('RequestTimeout', 75, 'request_timeout');
    AuthErrorCode_MfaPhoneEnrollDisabled_instance = new AuthErrorCode('MfaPhoneEnrollDisabled', 76, 'mfa_phone_enroll_not_enabled');
    AuthErrorCode_MfaPhoneVerifyDisabled_instance = new AuthErrorCode('MfaPhoneVerifyDisabled', 77, 'mfa_phone_verify_not_enabled');
    AuthErrorCode_MfaTotpEnrollDisabled_instance = new AuthErrorCode('MfaTotpEnrollDisabled', 78, 'mfa_totp_enroll_not_enabled');
    AuthErrorCode_MfaTotpVerifyDisabled_instance = new AuthErrorCode('MfaTotpVerifyDisabled', 79, 'mfa_totp_verify_not_enabled');
    AuthErrorCode_MfaWebAuthnEnrollDisabled_instance = new AuthErrorCode('MfaWebAuthnEnrollDisabled', 80, 'mfa_webauthn_enroll_not_enabled');
    AuthErrorCode_MfaWebAuthnVerifyDisabled_instance = new AuthErrorCode('MfaWebAuthnVerifyDisabled', 81, 'mfa_webauthn_verify_not_enabled');
    AuthErrorCode_MfaVerifiedFactorExists_instance = new AuthErrorCode('MfaVerifiedFactorExists', 82, 'mfa_verified_factor_exists');
    AuthErrorCode_EmailAddressInvalid_instance = new AuthErrorCode('EmailAddressInvalid', 83, 'email_address_invalid');
    AuthErrorCode_Web3ProviderDisabled_instance = new AuthErrorCode('Web3ProviderDisabled', 84, 'web3_provider_disabled');
    AuthErrorCode_Web3UnsupportedChain_instance = new AuthErrorCode('Web3UnsupportedChain', 85, 'web3_unsupported_chain');
  }
  var $ENTRIES;
  function AuthErrorCode(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.kwg_1 = value;
  }
  function AuthErrorCode_UnexpectedFailure_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_UnexpectedFailure_instance;
  }
  function AuthErrorCode_ValidationFailed_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_ValidationFailed_instance;
  }
  function AuthErrorCode_BadJson_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_BadJson_instance;
  }
  function AuthErrorCode_EmailExists_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_EmailExists_instance;
  }
  function AuthErrorCode_PhoneExists_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_PhoneExists_instance;
  }
  function AuthErrorCode_BadJwt_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_BadJwt_instance;
  }
  function AuthErrorCode_NotAdmin_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_NotAdmin_instance;
  }
  function AuthErrorCode_NoAuthorization_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_NoAuthorization_instance;
  }
  function AuthErrorCode_UserNotFound_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_UserNotFound_instance;
  }
  function AuthErrorCode_SessionNotFound_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_SessionNotFound_instance;
  }
  function AuthErrorCode_SessionExpired_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_SessionExpired_instance;
  }
  function AuthErrorCode_RefreshTokenNotFound_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_RefreshTokenNotFound_instance;
  }
  function AuthErrorCode_RefreshTokenAlreadyUsed_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_RefreshTokenAlreadyUsed_instance;
  }
  function AuthErrorCode_FlowStateNotFound_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_FlowStateNotFound_instance;
  }
  function AuthErrorCode_FlowStateExpired_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_FlowStateExpired_instance;
  }
  function AuthErrorCode_SignupDisabled_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_SignupDisabled_instance;
  }
  function AuthErrorCode_UserBanned_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_UserBanned_instance;
  }
  function AuthErrorCode_ProviderEmailNeedsVerification_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_ProviderEmailNeedsVerification_instance;
  }
  function AuthErrorCode_InviteNotFound_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_InviteNotFound_instance;
  }
  function AuthErrorCode_BadOauthState_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_BadOauthState_instance;
  }
  function AuthErrorCode_BadOauthCallback_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_BadOauthCallback_instance;
  }
  function AuthErrorCode_OauthProviderNotSupported_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_OauthProviderNotSupported_instance;
  }
  function AuthErrorCode_UnexpectedAudience_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_UnexpectedAudience_instance;
  }
  function AuthErrorCode_SingleIdentityNotDeletable_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_SingleIdentityNotDeletable_instance;
  }
  function AuthErrorCode_EmailConflictIdentityNotDeletable_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_EmailConflictIdentityNotDeletable_instance;
  }
  function AuthErrorCode_IdentityAlreadyExists_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_IdentityAlreadyExists_instance;
  }
  function AuthErrorCode_EmailProviderDisabled_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_EmailProviderDisabled_instance;
  }
  function AuthErrorCode_PhoneProviderDisabled_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_PhoneProviderDisabled_instance;
  }
  function AuthErrorCode_TooManyEnrolledMfaFactors_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_TooManyEnrolledMfaFactors_instance;
  }
  function AuthErrorCode_MfaFactorNameConflict_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_MfaFactorNameConflict_instance;
  }
  function AuthErrorCode_MfaFactorNotFound_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_MfaFactorNotFound_instance;
  }
  function AuthErrorCode_MfaIpAddressMismatch_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_MfaIpAddressMismatch_instance;
  }
  function AuthErrorCode_MfaChallengeExpired_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_MfaChallengeExpired_instance;
  }
  function AuthErrorCode_MfaVerificationFailed_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_MfaVerificationFailed_instance;
  }
  function AuthErrorCode_MfaVerificationRejected_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_MfaVerificationRejected_instance;
  }
  function AuthErrorCode_InsufficientAal_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_InsufficientAal_instance;
  }
  function AuthErrorCode_CaptchaFailed_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_CaptchaFailed_instance;
  }
  function AuthErrorCode_SamlProviderDisabled_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_SamlProviderDisabled_instance;
  }
  function AuthErrorCode_ManualLinkingDisabled_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_ManualLinkingDisabled_instance;
  }
  function AuthErrorCode_SmsSendFailed_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_SmsSendFailed_instance;
  }
  function AuthErrorCode_EmailNotConfirmed_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_EmailNotConfirmed_instance;
  }
  function AuthErrorCode_PhoneNotConfirmed_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_PhoneNotConfirmed_instance;
  }
  function AuthErrorCode_ReauthNonceMissing_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_ReauthNonceMissing_instance;
  }
  function AuthErrorCode_SamlRelayStateNotFound_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_SamlRelayStateNotFound_instance;
  }
  function AuthErrorCode_SamlRelayStateExpired_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_SamlRelayStateExpired_instance;
  }
  function AuthErrorCode_SamlIdpNotFound_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_SamlIdpNotFound_instance;
  }
  function AuthErrorCode_SamlAssertionNoUserId_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_SamlAssertionNoUserId_instance;
  }
  function AuthErrorCode_SamlAssertionNoEmail_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_SamlAssertionNoEmail_instance;
  }
  function AuthErrorCode_UserAlreadyExists_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_UserAlreadyExists_instance;
  }
  function AuthErrorCode_SsoProviderNotFound_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_SsoProviderNotFound_instance;
  }
  function AuthErrorCode_SamlMetadataFetchFailed_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_SamlMetadataFetchFailed_instance;
  }
  function AuthErrorCode_SamlIdpAlreadyExists_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_SamlIdpAlreadyExists_instance;
  }
  function AuthErrorCode_SsoDomainAlreadyExists_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_SsoDomainAlreadyExists_instance;
  }
  function AuthErrorCode_SamlEntityIdMismatch_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_SamlEntityIdMismatch_instance;
  }
  function AuthErrorCode_Conflict_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_Conflict_instance;
  }
  function AuthErrorCode_ProviderDisabled_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_ProviderDisabled_instance;
  }
  function AuthErrorCode_UserSsoManaged_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_UserSsoManaged_instance;
  }
  function AuthErrorCode_ReauthenticationNeeded_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_ReauthenticationNeeded_instance;
  }
  function AuthErrorCode_SamePassword_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_SamePassword_instance;
  }
  function AuthErrorCode_ReauthenticationNotValid_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_ReauthenticationNotValid_instance;
  }
  function AuthErrorCode_OtpExpired_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_OtpExpired_instance;
  }
  function AuthErrorCode_OtpDisabled_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_OtpDisabled_instance;
  }
  function AuthErrorCode_IdentityNotFound_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_IdentityNotFound_instance;
  }
  function AuthErrorCode_WeakPassword_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_WeakPassword_instance;
  }
  function AuthErrorCode_OverRequestRateLimit_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_OverRequestRateLimit_instance;
  }
  function AuthErrorCode_OverEmailSendRateLimit_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_OverEmailSendRateLimit_instance;
  }
  function AuthErrorCode_OverSmsSendRateLimit_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_OverSmsSendRateLimit_instance;
  }
  function AuthErrorCode_BadCodeVerifier_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_BadCodeVerifier_instance;
  }
  function AuthErrorCode_InvalidCredentials_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_InvalidCredentials_instance;
  }
  function AuthErrorCode_EmailAddressNotAuthorized_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_EmailAddressNotAuthorized_instance;
  }
  function AuthErrorCode_AnonymousProviderDisabled_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_AnonymousProviderDisabled_instance;
  }
  function AuthErrorCode_HookTimeout_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_HookTimeout_instance;
  }
  function AuthErrorCode_HookTimeoutAfterRetry_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_HookTimeoutAfterRetry_instance;
  }
  function AuthErrorCode_HookPayloadOverSizeLimit_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_HookPayloadOverSizeLimit_instance;
  }
  function AuthErrorCode_HookPayloadInvalidContentType_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_HookPayloadInvalidContentType_instance;
  }
  function AuthErrorCode_RequestTimeout_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_RequestTimeout_instance;
  }
  function AuthErrorCode_MfaPhoneEnrollDisabled_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_MfaPhoneEnrollDisabled_instance;
  }
  function AuthErrorCode_MfaPhoneVerifyDisabled_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_MfaPhoneVerifyDisabled_instance;
  }
  function AuthErrorCode_MfaTotpEnrollDisabled_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_MfaTotpEnrollDisabled_instance;
  }
  function AuthErrorCode_MfaTotpVerifyDisabled_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_MfaTotpVerifyDisabled_instance;
  }
  function AuthErrorCode_MfaWebAuthnEnrollDisabled_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_MfaWebAuthnEnrollDisabled_instance;
  }
  function AuthErrorCode_MfaWebAuthnVerifyDisabled_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_MfaWebAuthnVerifyDisabled_instance;
  }
  function AuthErrorCode_MfaVerifiedFactorExists_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_MfaVerifiedFactorExists_instance;
  }
  function AuthErrorCode_EmailAddressInvalid_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_EmailAddressInvalid_instance;
  }
  function AuthErrorCode_Web3ProviderDisabled_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_Web3ProviderDisabled_instance;
  }
  function AuthErrorCode_Web3UnsupportedChain_getInstance() {
    AuthErrorCode_initEntries();
    return AuthErrorCode_Web3UnsupportedChain_instance;
  }
  function AuthRestException(errorCode, errorDescription, response) {
    RestException.call(this, errorCode, errorDescription + ': ' + errorCode, response);
    captureStack(this, AuthRestException);
    this.pwg_1 = errorDescription;
    this.qwg_1 = Companion_instance_5.gwg(errorCode);
  }
  function Companion_5() {
    this.rwg_1 = 'session_not_found';
  }
  var Companion_instance_6;
  function Companion_getInstance_12() {
    return Companion_instance_6;
  }
  function AuthSessionMissingException(response) {
    captureStack(this, AuthSessionMissingException);
    var tmp0_errorCode = 'session_not_found';
    AuthRestException.call(this, tmp0_errorCode, 'Session not found. This can happen if the user was logged out or deleted.', response);
  }
  function Companion_6() {
    this.swg_1 = 'weak_password';
  }
  var Companion_instance_7;
  function Companion_getInstance_13() {
    return Companion_instance_7;
  }
  function AuthWeakPasswordException(description, response, reasons) {
    AuthRestException.call(this, 'weak_password', description, response);
    captureStack(this, AuthWeakPasswordException);
    this.zwg_1 = reasons;
  }
  function SessionRequiredException(url) {
    Exception_init_$Init$('You need to be logged in to perform this request\nURL: ' + StringMasking_getInstance().mvj(Url(url)), this);
    captureStack(this, SessionRequiredException);
  }
  function TokenExpiredException() {
    Exception_init_$Init$('The token has expired and a force-refresh was unsuccessful', this);
    captureStack(this, TokenExpiredException);
  }
  function AMREntry$Companion$$childSerializers$_anonymous__aqmjoi() {
    return Companion_getInstance_15().amj();
  }
  function Companion_7() {
    Companion_instance_8 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.bwh_1 = [lazy(tmp_0, AMREntry$Companion$$childSerializers$_anonymous__aqmjoi), null];
  }
  var Companion_instance_8;
  function Companion_getInstance_14() {
    if (Companion_instance_8 == null)
      new Companion_7();
    return Companion_instance_8;
  }
  function $serializer_0() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.github.jan.supabase.auth.jwt.AMREntry', this, 2);
    tmp0_serialDesc.a7c('method', false);
    tmp0_serialDesc.a7c('timestamp', false);
    this.cwh_1 = tmp0_serialDesc;
  }
  protoOf($serializer_0).dwh = function (encoder, value) {
    var tmp0_desc = this.cwh_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    var tmp2_cached = Companion_getInstance_14().bwh_1;
    tmp1_output.e76(tmp0_desc, 0, tmp2_cached[0].u1(), value.ewh_1);
    tmp1_output.y75(tmp0_desc, 1, value.fwh_1);
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_0).z70 = function (encoder, value) {
    return this.dwh(encoder, value instanceof AMREntry ? value : THROW_CCE());
  };
  protoOf($serializer_0).a71 = function (decoder) {
    var tmp0_desc = this.cwh_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = new Long(0, 0);
    var tmp7_input = decoder.n74(tmp0_desc);
    var tmp8_cached = Companion_getInstance_14().bwh_1;
    if (tmp7_input.d75()) {
      tmp4_local0 = tmp7_input.z74(tmp0_desc, 0, tmp8_cached[0].u1(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.t74(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.z74(tmp0_desc, 0, tmp8_cached[0].u1(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.t74(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.o74(tmp0_desc);
    return AMREntry_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_0).y70 = function () {
    return this.cwh_1;
  };
  protoOf($serializer_0).t7c = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_14().bwh_1[0].u1(), LongSerializer_getInstance()];
  };
  var $serializer_instance_0;
  function $serializer_getInstance_0() {
    if ($serializer_instance_0 == null)
      new $serializer_0();
    return $serializer_instance_0;
  }
  function AMREntry_init_$Init$(seen0, method, timestampInt, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_0().cwh_1);
    }
    $this.ewh_1 = method;
    $this.fwh_1 = timestampInt;
    var tmp = $this;
    tmp.gwh_1 = lazy_0(AMREntry$_init_$lambda_1neyo1($this));
    return $this;
  }
  function AMREntry_init_$Create$(seen0, method, timestampInt, serializationConstructorMarker) {
    return AMREntry_init_$Init$(seen0, method, timestampInt, serializationConstructorMarker, objectCreate(protoOf(AMREntry)));
  }
  function AMREntry$timestamp$delegate$lambda(this$0) {
    return function () {
      return Companion_getInstance_5().rp(this$0.fwh_1);
    };
  }
  function AMREntry$_init_$lambda_1neyo1(this$0) {
    return function () {
      return Companion_getInstance_5().rp(this$0.fwh_1);
    };
  }
  function AMREntry(method, timestampInt) {
    Companion_getInstance_14();
    this.ewh_1 = method;
    this.fwh_1 = timestampInt;
    var tmp = this;
    tmp.gwh_1 = lazy_0(AMREntry$timestamp$delegate$lambda(this));
  }
  protoOf(AMREntry).toString = function () {
    return 'AMREntry(method=' + this.ewh_1.toString() + ', timestampInt=' + this.fwh_1.toString() + ')';
  };
  protoOf(AMREntry).hashCode = function () {
    var result = this.ewh_1.hashCode();
    result = imul(result, 31) + this.fwh_1.hashCode() | 0;
    return result;
  };
  protoOf(AMREntry).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AMREntry))
      return false;
    if (!this.ewh_1.equals(other.ewh_1))
      return false;
    if (!equalsLong(this.fwh_1, other.fwh_1))
      return false;
    return true;
  };
  function _get_$cachedSerializer__te6jhj($this) {
    return $this.awh_1.u1();
  }
  function AMRMethod$Companion$_anonymous__tajho8() {
    var tmp = values_0();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = ['password', 'otp', 'oauth', 'totp', 'mfa/totp', 'mfa/phone', 'mfa/webauthn', 'anonymous', 'sso/saml', 'magiclink', 'web3'];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [null, null, null, null, null, null, null, null, null, null, null];
    return createAnnotatedEnumSerializer('io.github.jan.supabase.auth.jwt.AMRMethod', tmp, tmp_0, tmp$ret$3, null);
  }
  var AMRMethod_Password_instance;
  var AMRMethod_OTP_instance;
  var AMRMethod_OAuth_instance;
  var AMRMethod_TOTP_instance;
  var AMRMethod_MFA_TOTP_instance;
  var AMRMethod_MFA_PHONE_instance;
  var AMRMethod_MFA_WEBAUTHN_instance;
  var AMRMethod_ANONYMOUS_instance;
  var AMRMethod_SSO_SAML_instance;
  var AMRMethod_MAGIC_LINK_instance;
  var AMRMethod_WEB3_instance;
  function values_0() {
    return [AMRMethod_Password_getInstance(), AMRMethod_OTP_getInstance(), AMRMethod_OAuth_getInstance(), AMRMethod_TOTP_getInstance(), AMRMethod_MFA_TOTP_getInstance(), AMRMethod_MFA_PHONE_getInstance(), AMRMethod_MFA_WEBAUTHN_getInstance(), AMRMethod_ANONYMOUS_getInstance(), AMRMethod_SSO_SAML_getInstance(), AMRMethod_MAGIC_LINK_getInstance(), AMRMethod_WEB3_getInstance()];
  }
  function Companion_8() {
    Companion_instance_9 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.awh_1 = lazy(tmp_0, AMRMethod$Companion$_anonymous__tajho8);
  }
  protoOf(Companion_8).amj = function () {
    return _get_$cachedSerializer__te6jhj(this);
  };
  protoOf(Companion_8).e7d = function (typeParamsSerializers) {
    return this.amj();
  };
  var Companion_instance_9;
  function Companion_getInstance_15() {
    AMRMethod_initEntries();
    if (Companion_instance_9 == null)
      new Companion_8();
    return Companion_instance_9;
  }
  var AMRMethod_entriesInitialized;
  function AMRMethod_initEntries() {
    if (AMRMethod_entriesInitialized)
      return Unit_instance;
    AMRMethod_entriesInitialized = true;
    AMRMethod_Password_instance = new AMRMethod('Password', 0, 'password');
    AMRMethod_OTP_instance = new AMRMethod('OTP', 1, 'otp');
    AMRMethod_OAuth_instance = new AMRMethod('OAuth', 2, 'oauth');
    AMRMethod_TOTP_instance = new AMRMethod('TOTP', 3, 'totp');
    AMRMethod_MFA_TOTP_instance = new AMRMethod('MFA_TOTP', 4, 'mfa/totp');
    AMRMethod_MFA_PHONE_instance = new AMRMethod('MFA_PHONE', 5, 'mfa/phone');
    AMRMethod_MFA_WEBAUTHN_instance = new AMRMethod('MFA_WEBAUTHN', 6, 'mfa/webauthn');
    AMRMethod_ANONYMOUS_instance = new AMRMethod('ANONYMOUS', 7, 'anonymous');
    AMRMethod_SSO_SAML_instance = new AMRMethod('SSO_SAML', 8, 'sso/saml');
    AMRMethod_MAGIC_LINK_instance = new AMRMethod('MAGIC_LINK', 9, 'magiclink');
    AMRMethod_WEB3_instance = new AMRMethod('WEB3', 10, 'web3');
    Companion_getInstance_15();
  }
  function AMRMethod(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.jwh_1 = value;
  }
  function AMRMethod_Password_getInstance() {
    AMRMethod_initEntries();
    return AMRMethod_Password_instance;
  }
  function AMRMethod_OTP_getInstance() {
    AMRMethod_initEntries();
    return AMRMethod_OTP_instance;
  }
  function AMRMethod_OAuth_getInstance() {
    AMRMethod_initEntries();
    return AMRMethod_OAuth_instance;
  }
  function AMRMethod_TOTP_getInstance() {
    AMRMethod_initEntries();
    return AMRMethod_TOTP_instance;
  }
  function AMRMethod_MFA_TOTP_getInstance() {
    AMRMethod_initEntries();
    return AMRMethod_MFA_TOTP_instance;
  }
  function AMRMethod_MFA_PHONE_getInstance() {
    AMRMethod_initEntries();
    return AMRMethod_MFA_PHONE_instance;
  }
  function AMRMethod_MFA_WEBAUTHN_getInstance() {
    AMRMethod_initEntries();
    return AMRMethod_MFA_WEBAUTHN_instance;
  }
  function AMRMethod_ANONYMOUS_getInstance() {
    AMRMethod_initEntries();
    return AMRMethod_ANONYMOUS_instance;
  }
  function AMRMethod_SSO_SAML_getInstance() {
    AMRMethod_initEntries();
    return AMRMethod_SSO_SAML_instance;
  }
  function AMRMethod_MAGIC_LINK_getInstance() {
    AMRMethod_initEntries();
    return AMRMethod_MAGIC_LINK_instance;
  }
  function AMRMethod_WEB3_getInstance() {
    AMRMethod_initEntries();
    return AMRMethod_WEB3_instance;
  }
  function ClaimsResponse(claims, header, signature) {
    this.kwh_1 = claims;
    this.lwh_1 = header;
    this.mwh_1 = signature;
  }
  protoOf(ClaimsResponse).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof ClaimsResponse))
      THROW_CCE();
    if (!equals(this.kwh_1, other.kwh_1))
      return false;
    if (!this.lwh_1.equals(other.lwh_1))
      return false;
    if (!contentEquals(this.mwh_1, other.mwh_1))
      return false;
    return true;
  };
  protoOf(ClaimsResponse).hashCode = function () {
    var result = hashCode(this.kwh_1);
    result = imul(31, result) + this.lwh_1.hashCode() | 0;
    result = imul(31, result) + contentHashCode(this.mwh_1) | 0;
    return result;
  };
  protoOf(ClaimsResponse).toString = function () {
    return 'ClaimsResponse(claims=' + toString_0(this.kwh_1) + ', header=' + this.lwh_1.toString() + ', signature=' + toString_0(this.mwh_1) + ')';
  };
  function JwtPayload$exp$delegate$lambda(this$0) {
    return function () {
      // Inline function 'io.github.jan.supabase.auth.decodeValue' call
      var this_0 = this$0.nwh_1;
      var json = Default_getInstance();
      var tmp0_safe_receiver = this_0.je('exp');
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlinx.serialization.json.decodeFromJsonElement' call
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = json.c75();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer(this_1, createKType(getKClass(Long), arrayOf([]), true));
        var tmp$ret$4 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
        tmp = json.mmg(tmp$ret$4, tmp0_safe_receiver);
      }
      var tmp0_safe_receiver_0 = tmp;
      var tmp_0;
      if (tmp0_safe_receiver_0 == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_0 = Companion_getInstance_5().rp(tmp0_safe_receiver_0);
      }
      return tmp_0;
    };
  }
  function JwtPayload$_get_exp_$ref_xmo7pi() {
    return constructCallableReference(function (p0) {
      return p0.fwi();
    }, 1, 0, 518);
  }
  function JwtPayload$iat$delegate$lambda(this$0) {
    return function () {
      // Inline function 'io.github.jan.supabase.auth.decodeValue' call
      var this_0 = this$0.nwh_1;
      var json = Default_getInstance();
      var tmp0_safe_receiver = this_0.je('iat');
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlinx.serialization.json.decodeFromJsonElement' call
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = json.c75();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer(this_1, createKType(getKClass(Long), arrayOf([]), true));
        var tmp$ret$4 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
        tmp = json.mmg(tmp$ret$4, tmp0_safe_receiver);
      }
      var tmp0_safe_receiver_0 = tmp;
      var tmp_0;
      if (tmp0_safe_receiver_0 == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_0 = Companion_getInstance_5().rp(tmp0_safe_receiver_0);
      }
      return tmp_0;
    };
  }
  function JwtPayload$_get_aal_$ref_51jmlz() {
    return constructCallableReference(function (p0) {
      return p0.gwi();
    }, 1, 0, 519);
  }
  function JwtPayload$nbf$delegate$lambda(this$0) {
    return function () {
      // Inline function 'io.github.jan.supabase.auth.decodeValue' call
      var this_0 = this$0.nwh_1;
      var json = Default_getInstance();
      var tmp0_safe_receiver = this_0.je('nbf');
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlinx.serialization.json.decodeFromJsonElement' call
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = json.c75();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer(this_1, createKType(getKClass(Long), arrayOf([]), true));
        var tmp$ret$4 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
        tmp = json.mmg(tmp$ret$4, tmp0_safe_receiver);
      }
      var tmp0_safe_receiver_0 = tmp;
      var tmp_0;
      if (tmp0_safe_receiver_0 == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_0 = Companion_getInstance_5().rp(tmp0_safe_receiver_0);
      }
      return tmp_0;
    };
  }
  function JwtPayload$_get_amr_$ref_t2re9v() {
    return constructCallableReference(function (p0) {
      return p0.hwi();
    }, 1, 0, 520);
  }
  function JwtPayload(claims) {
    this.nwh_1 = claims;
    this.owh_1 = get_optional(this.nwh_1);
    this.pwh_1 = get_optional(this.nwh_1);
    var tmp = this;
    var value = this.nwh_1.je('aud');
    var tmp_0;
    if (value instanceof JsonArray) {
      // Inline function 'kotlinx.serialization.json.decodeFromJsonElement' call
      var this_0 = Default_getInstance();
      // Inline function 'kotlinx.serialization.serializer' call
      var this_1 = this_0.c75();
      // Inline function 'kotlinx.serialization.internal.cast' call
      var this_2 = serializer(this_1, createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().rc(), arrayOf([]), false))]), true));
      var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
      tmp_0 = this_0.mmg(tmp$ret$1, value);
    } else {
      if (value instanceof JsonPrimitive) {
        // Inline function 'kotlinx.serialization.json.decodeFromJsonElement' call
        var this_3 = Default_getInstance();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_4 = this_3.c75();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_5 = serializer(this_4, createKType(PrimitiveClasses_getInstance().rc(), arrayOf([]), false));
        var tmp$ret$4 = isInterface(this_5, KSerializer) ? this_5 : THROW_CCE();
        var tmp$ret$3 = this_3.mmg(tmp$ret$4, value);
        tmp_0 = listOf_0(tmp$ret$3);
      } else {
        tmp_0 = null;
      }
    }
    tmp.qwh_1 = tmp_0;
    var tmp_1 = this;
    tmp_1.rwh_1 = lazy_0(JwtPayload$exp$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.swh_1 = lazy_0(JwtPayload$iat$delegate$lambda(this));
    this.twh_1 = get_optional(this.nwh_1);
    this.uwh_1 = get_optional(this.nwh_1);
    this.vwh_1 = get_optional(this.nwh_1).bwd('session_id');
    this.wwh_1 = get_optional(this.nwh_1);
    this.xwh_1 = get_optional(this.nwh_1);
    this.ywh_1 = get_optional(this.nwh_1).bwd('is_anonymous');
    this.zwh_1 = get_optional(this.nwh_1);
    var tmp_3 = this;
    tmp_3.awi_1 = lazy_0(JwtPayload$nbf$delegate$lambda(this));
    this.bwi_1 = get_optional(this.nwh_1).bwd('app_metadata');
    this.cwi_1 = get_optional(this.nwh_1).bwd('user_metadata');
    this.dwi_1 = get_optional(this.nwh_1);
    this.ewi_1 = get_optional(this.nwh_1);
  }
  protoOf(JwtPayload).fwi = function () {
    var tmp0 = this.rwh_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('exp', 1, tmp, JwtPayload$_get_exp_$ref_xmo7pi(), null);
    return tmp0.u1();
  };
  protoOf(JwtPayload).gwi = function () {
    var tmp0 = this.uwh_1;
    var tmp = KProperty1;
    var tmp4 = getPropertyCallableRef('aal', 1, tmp, JwtPayload$_get_aal_$ref_51jmlz(), null);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'io.github.jan.supabase.auth.OptionalJsonObjectModifier.getValue' call
      var tmp0_elvis_lhs = tmp0.awd_1;
      var tmp1_safe_receiver = tmp0.zwc_1.je(tmp0_elvis_lhs == null ? tmp4.callableName : tmp0_elvis_lhs);
      var tmp_0;
      if (tmp1_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        if (tmp1_safe_receiver instanceof JsonNull) {
          tmp$ret$0 = null;
          break $l$block;
        }
        // Inline function 'kotlinx.serialization.json.decodeFromJsonElement' call
        var this_0 = Default_getInstance();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.c75();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer(this_1, createKType(getKClass(AuthenticatorAssuranceLevel), arrayOf([]), true));
        var tmp$ret$4 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
        tmp_0 = this_0.mmg(tmp$ret$4, tmp1_safe_receiver);
      }
      tmp$ret$0 = tmp_0;
    }
    return tmp$ret$0;
  };
  protoOf(JwtPayload).hwi = function () {
    var tmp0 = this.dwi_1;
    var tmp = KProperty1;
    var tmp4 = getPropertyCallableRef('amr', 1, tmp, JwtPayload$_get_amr_$ref_t2re9v(), null);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'io.github.jan.supabase.auth.OptionalJsonObjectModifier.getValue' call
      var tmp0_elvis_lhs = tmp0.awd_1;
      var tmp1_safe_receiver = tmp0.zwc_1.je(tmp0_elvis_lhs == null ? tmp4.callableName : tmp0_elvis_lhs);
      var tmp_0;
      if (tmp1_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        if (tmp1_safe_receiver instanceof JsonNull) {
          tmp$ret$0 = null;
          break $l$block;
        }
        // Inline function 'kotlinx.serialization.json.decodeFromJsonElement' call
        var this_0 = Default_getInstance();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.c75();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer(this_1, createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(AMREntry), arrayOf([]), false))]), true));
        var tmp$ret$4 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
        tmp_0 = this_0.mmg(tmp$ret$4, tmp1_safe_receiver);
      }
      tmp$ret$0 = tmp_0;
    }
    return tmp$ret$0;
  };
  var Algorithm_RS256_instance;
  var Algorithm_ES256_instance;
  var Algorithm_HS256_instance;
  function values_1() {
    return [Algorithm_RS256_getInstance(), Algorithm_ES256_getInstance(), Algorithm_HS256_getInstance()];
  }
  var Algorithm_entriesInitialized;
  function Algorithm_initEntries() {
    if (Algorithm_entriesInitialized)
      return Unit_instance;
    Algorithm_entriesInitialized = true;
    Algorithm_RS256_instance = new Algorithm('RS256', 0);
    Algorithm_ES256_instance = new Algorithm('ES256', 1);
    Algorithm_HS256_instance = new Algorithm('HS256', 2);
  }
  function JwtHeader$Companion$$childSerializers$_anonymous__iet4c6() {
    return createSimpleEnumSerializer('io.github.jan.supabase.auth.jwt.JwtHeader.Algorithm', values_1());
  }
  function Algorithm(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Companion_9() {
    Companion_instance_10 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.iwi_1 = [lazy(tmp_0, JwtHeader$Companion$$childSerializers$_anonymous__iet4c6), null, null];
  }
  var Companion_instance_10;
  function Companion_getInstance_16() {
    if (Companion_instance_10 == null)
      new Companion_9();
    return Companion_instance_10;
  }
  function $serializer_1() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.github.jan.supabase.auth.jwt.JwtHeader', this, 3);
    tmp0_serialDesc.a7c('alg', false);
    tmp0_serialDesc.a7c('kid', true);
    tmp0_serialDesc.a7c('typ', true);
    this.jwi_1 = tmp0_serialDesc;
  }
  protoOf($serializer_1).kwi = function (encoder, value) {
    var tmp0_desc = this.jwi_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    var tmp2_cached = Companion_getInstance_16().iwi_1;
    tmp1_output.e76(tmp0_desc, 0, tmp2_cached[0].u1(), value.lwi_1);
    if (tmp1_output.k76(tmp0_desc, 1) ? true : !(value.mwi_1 == null)) {
      tmp1_output.g76(tmp0_desc, 1, StringSerializer_getInstance(), value.mwi_1);
    }
    if (tmp1_output.k76(tmp0_desc, 2) ? true : !(value.nwi_1 == null)) {
      tmp1_output.g76(tmp0_desc, 2, StringSerializer_getInstance(), value.nwi_1);
    }
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_1).z70 = function (encoder, value) {
    return this.kwi(encoder, value instanceof JwtHeader ? value : THROW_CCE());
  };
  protoOf($serializer_1).a71 = function (decoder) {
    var tmp0_desc = this.jwi_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.n74(tmp0_desc);
    var tmp8_cached = Companion_getInstance_16().iwi_1;
    if (tmp7_input.d75()) {
      tmp4_local0 = tmp7_input.z74(tmp0_desc, 0, tmp8_cached[0].u1(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.b75(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.b75(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.z74(tmp0_desc, 0, tmp8_cached[0].u1(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.b75(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.b75(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.o74(tmp0_desc);
    return JwtHeader_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_1).y70 = function () {
    return this.jwi_1;
  };
  protoOf($serializer_1).t7c = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_16().iwi_1[0].u1(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_1;
  function $serializer_getInstance_1() {
    if ($serializer_instance_1 == null)
      new $serializer_1();
    return $serializer_instance_1;
  }
  function JwtHeader_init_$Init$(seen0, alg, kid, typ, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_1().jwi_1);
    }
    $this.lwi_1 = alg;
    if (0 === (seen0 & 2))
      $this.mwi_1 = null;
    else
      $this.mwi_1 = kid;
    if (0 === (seen0 & 4))
      $this.nwi_1 = null;
    else
      $this.nwi_1 = typ;
    return $this;
  }
  function JwtHeader_init_$Create$(seen0, alg, kid, typ, serializationConstructorMarker) {
    return JwtHeader_init_$Init$(seen0, alg, kid, typ, serializationConstructorMarker, objectCreate(protoOf(JwtHeader)));
  }
  function Algorithm_RS256_getInstance() {
    Algorithm_initEntries();
    return Algorithm_RS256_instance;
  }
  function Algorithm_ES256_getInstance() {
    Algorithm_initEntries();
    return Algorithm_ES256_instance;
  }
  function Algorithm_HS256_getInstance() {
    Algorithm_initEntries();
    return Algorithm_HS256_instance;
  }
  function JwtHeader(alg, kid, typ) {
    Companion_getInstance_16();
    kid = kid === VOID ? null : kid;
    typ = typ === VOID ? null : typ;
    this.lwi_1 = alg;
    this.mwi_1 = kid;
    this.nwi_1 = typ;
  }
  protoOf(JwtHeader).toString = function () {
    return 'JwtHeader(alg=' + this.lwi_1.toString() + ', kid=' + this.mwi_1 + ', typ=' + this.nwi_1 + ')';
  };
  protoOf(JwtHeader).hashCode = function () {
    var result = this.lwi_1.hashCode();
    result = imul(result, 31) + (this.mwi_1 == null ? 0 : getStringHashCode(this.mwi_1)) | 0;
    result = imul(result, 31) + (this.nwi_1 == null ? 0 : getStringHashCode(this.nwi_1)) | 0;
    return result;
  };
  protoOf(JwtHeader).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JwtHeader))
      return false;
    if (!this.lwi_1.equals(other.lwi_1))
      return false;
    if (!(this.mwi_1 == other.mwi_1))
      return false;
    if (!(this.nwi_1 == other.nwi_1))
      return false;
    return true;
  };
  function JWTData(claimsResponse, rawHeader, rawPayload) {
    this.owi_1 = claimsResponse;
    this.pwi_1 = rawHeader;
    this.qwi_1 = rawPayload;
  }
  protoOf(JWTData).toString = function () {
    return 'JWTData(claimsResponse=' + this.owi_1.toString() + ', rawHeader=' + this.pwi_1 + ', rawPayload=' + this.qwi_1 + ')';
  };
  protoOf(JWTData).hashCode = function () {
    var result = this.owi_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.pwi_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.qwi_1) | 0;
    return result;
  };
  protoOf(JWTData).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JWTData))
      return false;
    if (!this.owi_1.equals(other.owi_1))
      return false;
    if (!(this.pwi_1 === other.pwi_1))
      return false;
    if (!(this.qwi_1 === other.qwi_1))
      return false;
    return true;
  };
  function JWTUtils$JWT_JSON_INSTANCE$lambda($this$Json) {
    $this$Json.gmh_1 = true;
    return Unit_instance;
  }
  function JWTUtils() {
    JWTUtils_instance = this;
    var tmp = this;
    tmp.rwi_1 = Json(VOID, JWTUtils$JWT_JSON_INSTANCE$lambda);
    this.swi_1 = Default_getInstance_1().xk_1.al(PaddingOption_ABSENT_getInstance());
  }
  protoOf(JWTUtils).twi = function (jwt) {
    var parts = split(jwt, ['.']);
    // Inline function 'kotlin.require' call
    if (!(parts.n1() === 3)) {
      var message = 'Invalid JWT structure';
      throw IllegalArgumentException_init_$Create$(toString_0(message));
    }
    var tmp0 = this.rwi_1;
    // Inline function 'kotlinx.serialization.json.Json.decodeFromString' call
    var string = this.uwi(parts.l1(0));
    // Inline function 'kotlinx.serialization.serializer' call
    var this_0 = tmp0.c75();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_1 = serializer(this_0, createKType(getKClass(JwtHeader), arrayOf([]), false));
    var tmp$ret$3 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
    var header = tmp0.c72(tmp$ret$3, string);
    var tmp0_0 = this.rwi_1;
    // Inline function 'kotlinx.serialization.json.Json.decodeFromString' call
    var string_0 = this.uwi(parts.l1(1));
    // Inline function 'kotlinx.serialization.serializer' call
    var this_2 = tmp0_0.c75();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_3 = serializer(this_2, createKType(getKClass(JsonObject), arrayOf([]), false));
    var tmp$ret$6 = isInterface(this_3, KSerializer) ? this_3 : THROW_CCE();
    var tmp$ret$5 = tmp0_0.c72(tmp$ret$6, string_0);
    var payload = new JwtPayload(tmp$ret$5);
    var signature = this.vwi(parts.l1(2));
    return new JWTData(new ClaimsResponse(payload, header, signature), parts.l1(0), parts.l1(1));
  };
  protoOf(JWTUtils).uwi = function (value) {
    return decodeToString(this.swi_1.gl(value));
  };
  protoOf(JWTUtils).vwi = function (value) {
    return this.swi_1.gl(value);
  };
  var JWTUtils_instance;
  function JWTUtils_getInstance() {
    if (JWTUtils_instance == null)
      new JWTUtils();
    return JWTUtils_instance;
  }
  function SharedJwkCache() {
    SharedJwkCache_instance = this;
    this.wwi_1 = new AtomicReference(null);
  }
  var SharedJwkCache_instance;
  function SharedJwkCache_getInstance() {
    if (SharedJwkCache_instance == null)
      new SharedJwkCache();
    return SharedJwkCache_instance;
  }
  function MfaLevel(current, next, currentAuthenticationMethods) {
    this.xwi_1 = current;
    this.ywi_1 = next;
    this.zwi_1 = currentAuthenticationMethods;
  }
  protoOf(MfaLevel).zh = function () {
    return this.xwi_1;
  };
  protoOf(MfaLevel).ai = function () {
    return this.ywi_1;
  };
  protoOf(MfaLevel).toString = function () {
    return 'MfaLevel(current=' + this.xwi_1.toString() + ', next=' + this.ywi_1.toString() + ', currentAuthenticationMethods=' + toString_0(this.zwi_1) + ')';
  };
  protoOf(MfaLevel).hashCode = function () {
    var result = this.xwi_1.hashCode();
    result = imul(result, 31) + this.ywi_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.zwi_1) | 0;
    return result;
  };
  protoOf(MfaLevel).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MfaLevel))
      return false;
    if (!this.xwi_1.equals(other.xwi_1))
      return false;
    if (!this.ywi_1.equals(other.ywi_1))
      return false;
    if (!equals(this.zwi_1, other.zwi_1))
      return false;
    return true;
  };
  function _get_$cachedSerializer__te6jhj_0($this) {
    return $this.awj_1.u1();
  }
  function AuthenticatorAssuranceLevel$Companion$_anonymous__ilat9h() {
    var tmp = values_2();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = ['aal1', 'aal2'];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [null, null];
    return createAnnotatedEnumSerializer('io.github.jan.supabase.auth.mfa.AuthenticatorAssuranceLevel', tmp, tmp_0, tmp$ret$3, null);
  }
  var AuthenticatorAssuranceLevel_AAL1_instance;
  var AuthenticatorAssuranceLevel_AAL2_instance;
  function Companion_10() {
    Companion_instance_11 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.awj_1 = lazy(tmp_0, AuthenticatorAssuranceLevel$Companion$_anonymous__ilat9h);
  }
  protoOf(Companion_10).amj = function () {
    return _get_$cachedSerializer__te6jhj_0(this);
  };
  protoOf(Companion_10).e7d = function (typeParamsSerializers) {
    return this.amj();
  };
  var Companion_instance_11;
  function Companion_getInstance_17() {
    AuthenticatorAssuranceLevel_initEntries();
    if (Companion_instance_11 == null)
      new Companion_10();
    return Companion_instance_11;
  }
  function values_2() {
    return [AuthenticatorAssuranceLevel_AAL1_getInstance(), AuthenticatorAssuranceLevel_AAL2_getInstance()];
  }
  var AuthenticatorAssuranceLevel_entriesInitialized;
  function AuthenticatorAssuranceLevel_initEntries() {
    if (AuthenticatorAssuranceLevel_entriesInitialized)
      return Unit_instance;
    AuthenticatorAssuranceLevel_entriesInitialized = true;
    AuthenticatorAssuranceLevel_AAL1_instance = new AuthenticatorAssuranceLevel('AAL1', 0);
    AuthenticatorAssuranceLevel_AAL2_instance = new AuthenticatorAssuranceLevel('AAL2', 1);
    Companion_getInstance_17();
  }
  function AuthenticatorAssuranceLevel(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function AuthenticatorAssuranceLevel_AAL1_getInstance() {
    AuthenticatorAssuranceLevel_initEntries();
    return AuthenticatorAssuranceLevel_AAL1_instance;
  }
  function AuthenticatorAssuranceLevel_AAL2_getInstance() {
    AuthenticatorAssuranceLevel_initEntries();
    return AuthenticatorAssuranceLevel_AAL2_instance;
  }
  function MfaApi() {
  }
  function MfaApiImpl$statusFlow$o$collect$slambda($$this$unsafeFlow, this$0, resultContinuation) {
    this.lwj_1 = $$this$unsafeFlow;
    this.mwj_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(MfaApiImpl$statusFlow$o$collect$slambda).o2k = function (value, $completion) {
    var tmp = this.p2k(value, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(MfaApiImpl$statusFlow$o$collect$slambda).ja = function (p1, $completion) {
    return this.o2k(p1, $completion);
  };
  protoOf(MfaApiImpl$statusFlow$o$collect$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var tmp0 = this.lwj_1;
            var value = this.nwj_1;
            this.n9_1 = 1;
            var tmp_0;
            if (value instanceof Authenticated) {
              var _destruct__k2r9zo = this.mwj_1.cwj();
              var current = _destruct__k2r9zo.zh();
              var next = _destruct__k2r9zo.ai();
              tmp_0 = new MfaStatus(next.equals(AuthenticatorAssuranceLevel_AAL2_getInstance()), current.equals(AuthenticatorAssuranceLevel_AAL2_getInstance()));
            } else {
              tmp_0 = new MfaStatus(false, false);
            }

            suspendResult = tmp0.a1v(tmp_0, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(MfaApiImpl$statusFlow$o$collect$slambda).p2k = function (value, completion) {
    var i = new MfaApiImpl$statusFlow$o$collect$slambda(this.lwj_1, this.mwj_1, completion);
    i.nwj_1 = value;
    return i;
  };
  function MfaApiImpl$statusFlow$o$collect$slambda_0($$this$unsafeFlow, this$0, resultContinuation) {
    var i = new MfaApiImpl$statusFlow$o$collect$slambda($$this$unsafeFlow, this$0, resultContinuation);
    return constructCallableReference(function (value, $completion) {
      return i.o2k(value, $completion);
    }, 1);
  }
  function $collectCOROUTINE$(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.wwj_1 = _this__u8e3s4;
    this.xwj_1 = collector;
  }
  protoOf($collectCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var $this$unsafeFlow = this.xwj_1;
            this.n9_1 = 1;
            var tmp_0 = MfaApiImpl$statusFlow$o$collect$slambda_0($this$unsafeFlow, this.wwj_1.zwj_1, null);
            suspendResult = this.wwj_1.ywj_1.l1u(new sam$kotlinx_coroutines_flow_FlowCollector$0(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function sam$kotlinx_coroutines_flow_FlowCollector$0(function_0) {
    this.awk_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).a1v = function (value, $completion) {
    return this.awk_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).q3 = function () {
    return this.awk_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function MfaApiImpl$statusFlow$$inlined$map$1($this, this$0) {
    this.ywj_1 = $this;
    this.zwj_1 = this$0;
  }
  protoOf(MfaApiImpl$statusFlow$$inlined$map$1).b1v = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$(this, collector, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(MfaApiImpl$statusFlow$$inlined$map$1).l1u = function (collector, $completion) {
    return this.b1v(collector, $completion);
  };
  function MfaApiImpl(api, auth) {
    this.bwk_1 = api;
    this.cwk_1 = auth;
    var tmp = this;
    // Inline function 'kotlinx.coroutines.flow.map' call
    // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
    var this_0 = this.cwk_1.svy();
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    tmp.dwk_1 = new MfaApiImpl$statusFlow$$inlined$map$1(this_0, this);
  }
  protoOf(MfaApiImpl).ewk = function () {
    var tmp0_safe_receiver = this.cwk_1.qvz();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.mwk_1;
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList_init_$Create$();
      var _iterator__ex2g4s = tmp1_safe_receiver.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        if (element.nwl()) {
          destination.j1(element);
        }
      }
      tmp = destination;
    }
    var tmp2_elvis_lhs = tmp;
    return tmp2_elvis_lhs == null ? emptyList() : tmp2_elvis_lhs;
  };
  protoOf(MfaApiImpl).bwj = function (jwt) {
    var tmp1_elvis_lhs = jwt == null ? this.cwk_1.nvw() : jwt;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message = 'Current session is null';
      throw IllegalStateException_init_$Create$(toString_0(message));
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var jwt_0 = tmp;
    var decodedJwt = JWTUtils_getInstance().twi(jwt_0);
    var tmp2_elvis_lhs = decodedJwt.owi_1.kwh_1.gwi();
    var tmp_0;
    if (tmp2_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message_0 = "No 'aal' claim found in JWT";
      throw IllegalStateException_init_$Create$(toString_0(message_0));
    } else {
      tmp_0 = tmp2_elvis_lhs;
    }
    var aal = tmp_0;
    var tmp_1;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.ewk().r()) {
      tmp_1 = AuthenticatorAssuranceLevel_AAL2_getInstance();
    } else {
      tmp_1 = AuthenticatorAssuranceLevel_AAL1_getInstance();
    }
    var nextAal = tmp_1;
    var tmp3_elvis_lhs = decodedJwt.owi_1.kwh_1.hwi();
    return new MfaLevel(aal, nextAal, tmp3_elvis_lhs == null ? emptyList() : tmp3_elvis_lhs);
  };
  function MfaStatus(enabled, active) {
    this.owl_1 = enabled;
    this.pwl_1 = active;
  }
  protoOf(MfaStatus).toString = function () {
    return 'MfaStatus(enabled=' + this.owl_1 + ', active=' + this.pwl_1 + ')';
  };
  protoOf(MfaStatus).hashCode = function () {
    var result = getBooleanHashCode(this.owl_1);
    result = imul(result, 31) + getBooleanHashCode(this.pwl_1) | 0;
    return result;
  };
  protoOf(MfaStatus).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MfaStatus))
      return false;
    if (!(this.owl_1 === other.owl_1))
      return false;
    if (!(this.pwl_1 === other.pwl_1))
      return false;
    return true;
  };
  function ExternalAuthConfigDefaults() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.qwc_1 = ArrayList_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_0.rwc_1 = LinkedHashMap_init_$Create$();
    this.swc_1 = true;
  }
  function Companion_11() {
    Companion_instance_12 = this;
    this.qwl_1 = PrimitiveSerialDescriptor('IDTokenProvider', STRING_getInstance());
  }
  protoOf(Companion_11).y70 = function () {
    return this.qwl_1;
  };
  protoOf(Companion_11).a71 = function (decoder) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(Companion_11).rwl = function (encoder, value) {
    encoder.r75(value.m());
  };
  protoOf(Companion_11).z70 = function (encoder, value) {
    return this.rwl(encoder, value instanceof IDTokenProvider ? value : THROW_CCE());
  };
  var Companion_instance_12;
  function Companion_getInstance_18() {
    if (Companion_instance_12 == null)
      new Companion_11();
    return Companion_instance_12;
  }
  function IDTokenProvider() {
    Companion_getInstance_18();
    OAuthProvider.call(this);
  }
  function OAuthProvider$login$slambda$lambda($authConfig) {
    return function ($this$getOAuthUrl) {
      $this$getOAuthUrl.qwc_1.o1($authConfig.qwc_1);
      $this$getOAuthUrl.rwc_1.b3($authConfig.rwc_1);
      return Unit_instance;
    };
  }
  function Companion_12() {
  }
  var Companion_instance_13;
  function Companion_getInstance_19() {
    return Companion_instance_13;
  }
  function OAuthProvider$login$slambda($supabaseClient, this$0, $authConfig, resultContinuation) {
    this.cwm_1 = $supabaseClient;
    this.dwm_1 = this$0;
    this.ewm_1 = $authConfig;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(OAuthProvider$login$slambda).gwm = function (it, $completion) {
    var tmp = this.hwm(it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(OAuthProvider$login$slambda).ja = function (p1, $completion) {
    return this.gwm((p1 == null ? true : typeof p1 === 'string') ? p1 : THROW_CCE(), $completion);
  };
  protoOf(OAuthProvider$login$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var tmp_0 = get_auth(this.cwm_1);
          return tmp_0.mvz(this.dwm_1, this.fwm_1, VOID, OAuthProvider$login$slambda$lambda(this.ewm_1));
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(OAuthProvider$login$slambda).hwm = function (it, completion) {
    var i = new OAuthProvider$login$slambda(this.cwm_1, this.dwm_1, this.ewm_1, completion);
    i.fwm_1 = it;
    return i;
  };
  function OAuthProvider$login$slambda_0($supabaseClient, this$0, $authConfig, resultContinuation) {
    var i = new OAuthProvider$login$slambda($supabaseClient, this$0, $authConfig, resultContinuation);
    return constructCallableReference(function (it, $completion) {
      return i.gwm(it, $completion);
    }, 1);
  }
  function OAuthProvider() {
  }
  protoOf(OAuthProvider).swl = function (supabaseClient, onSuccess, redirectUrl, config, $completion) {
    var authConfig = new ExternalAuthConfig();
    if (!(config == null)) {
      config(authConfig);
    }
    var tmp = get_auth(supabaseClient);
    return startExternalAuth(tmp, redirectUrl, OAuthProvider$login$slambda_0(supabaseClient, this, authConfig, null), onSuccess, $completion);
  };
  protoOf(OAuthProvider).nwc = function (supabaseClient, onSuccess, redirectUrl, config, $completion) {
    return this.swl(supabaseClient, onSuccess, redirectUrl, config, $completion);
  };
  protoOf(OAuthProvider).twl = function (supabaseClient, onSuccess, redirectUrl, config, $completion) {
    return this.swl(supabaseClient, onSuccess, redirectUrl, config, $completion);
  };
  protoOf(OAuthProvider).owc = function (supabaseClient, onSuccess, redirectUrl, config, $completion) {
    return this.twl(supabaseClient, onSuccess, redirectUrl, config, $completion);
  };
  function Google() {
    Google_instance = this;
    IDTokenProvider.call(this);
    this.iwm_1 = 'google';
  }
  protoOf(Google).m = function () {
    return this.iwm_1;
  };
  protoOf(Google).toString = function () {
    return 'Google';
  };
  protoOf(Google).hashCode = function () {
    return -1338307269;
  };
  protoOf(Google).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Google))
      return false;
    return true;
  };
  var Google_instance;
  function Google_getInstance() {
    if (Google_instance == null)
      new Google();
    return Google_instance;
  }
  function CaptchaTokenSerializer$descriptor$lambda($this$buildClassSerialDescriptor) {
    // Inline function 'kotlinx.serialization.descriptors.element' call
    var elementName = 'gotrue_meta_security';
    var annotations = emptyList();
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_0 = serializer_1(createKType(getKClass(JsonObject), arrayOf([]), false));
    var descriptor = (isInterface(this_0, KSerializer) ? this_0 : THROW_CCE()).y70();
    $this$buildClassSerialDescriptor.j73(elementName, descriptor, annotations, false);
    return Unit_instance;
  }
  function CaptchaTokenSerializer() {
    CaptchaTokenSerializer_instance = this;
    var tmp = this;
    tmp.jwm_1 = buildClassSerialDescriptor('CaptchaTokenSerializer', [], CaptchaTokenSerializer$descriptor$lambda);
  }
  protoOf(CaptchaTokenSerializer).y70 = function () {
    return this.jwm_1;
  };
  protoOf(CaptchaTokenSerializer).a71 = function (decoder) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(CaptchaTokenSerializer).s7h = function (encoder, value) {
    if (!isInterface(encoder, JsonEncoder))
      THROW_CCE();
    // Inline function 'kotlinx.serialization.json.buildJsonObject' call
    var builder = new JsonObjectBuilder();
    put(builder, 'captcha_token', value);
    var tmp$ret$0 = builder.wmh();
    encoder.amk(tmp$ret$0);
  };
  protoOf(CaptchaTokenSerializer).z70 = function (encoder, value) {
    return this.s7h(encoder, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
  };
  var CaptchaTokenSerializer_instance;
  function CaptchaTokenSerializer_getInstance() {
    if (CaptchaTokenSerializer_instance == null)
      new CaptchaTokenSerializer();
    return CaptchaTokenSerializer_instance;
  }
  function _get_$cachedSerializer__te6jhj_1($this) {
    return $this.kwm_1.u1();
  }
  function DefaultAuthProvider$Config$Companion$_anonymous__k9jmqr() {
    var tmp = getKClass(Config);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(Config_0), getKClass(Config_1), getKClass(Config_2)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = [$serializer_getInstance_2(), $serializer_getInstance_3(), $serializer_getInstance_4()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [];
    return SealedClassSerializer_init_$Create$('io.github.jan.supabase.auth.providers.builtin.DefaultAuthProvider.Config', tmp, tmp_0, tmp_1, tmp$ret$6);
  }
  function Companion_13() {
    Companion_instance_14 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.kwm_1 = lazy(tmp_0, DefaultAuthProvider$Config$Companion$_anonymous__k9jmqr);
  }
  protoOf(Companion_13).amj = function () {
    return _get_$cachedSerializer__te6jhj_1(this);
  };
  protoOf(Companion_13).e7d = function (typeParamsSerializers) {
    return this.amj();
  };
  var Companion_instance_14;
  function Companion_getInstance_20() {
    if (Companion_instance_14 == null)
      new Companion_13();
    return Companion_instance_14;
  }
  function Config_init_$Init$(seen0, captchaToken, data, serializationConstructorMarker, $this) {
    if (0 === (seen0 & 1))
      $this.lwm_1 = null;
    else
      $this.lwm_1 = captchaToken;
    if (0 === (seen0 & 2))
      $this.mwm_1 = null;
    else
      $this.mwm_1 = data;
    return $this;
  }
  function Config(captchaToken, data) {
    Companion_getInstance_20();
    captchaToken = captchaToken === VOID ? null : captchaToken;
    data = data === VOID ? null : data;
    this.lwm_1 = captchaToken;
    this.mwm_1 = data;
  }
  function DefaultAuthProvider$login$lambda($redirectUrl, $contentType, $body) {
    return function ($this$request) {
      $this$request.ztr_1 = Companion_getInstance_2().ft2_1;
      var tmp0_safe_receiver = $redirectUrl;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        redirectTo($this$request, tmp0_safe_receiver);
      }
      contentType($this$request, $contentType);
      // Inline function 'io.ktor.client.request.setBody' call
      var body = $body;
      if (body == null) {
        $this$request.bts_1 = NullBody_instance;
        // Inline function 'io.ktor.util.reflect.typeInfo' call
        var tmp = getKClass(JsonObject);
        // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
        var tmp_0;
        try {
          tmp_0 = createKType(getKClass(JsonObject), arrayOf([]), false);
        } catch ($p) {
          var tmp_1;
          if ($p instanceof Error) {
            var _unused_var__etf5q3 = $p;
            tmp_1 = null;
          } else {
            throw $p;
          }
          tmp_0 = tmp_1;
        }
        var tmp$ret$5 = tmp_0;
        var tmp$ret$4 = new TypeInfo(tmp, tmp$ret$5);
        $this$request.qtx(tmp$ret$4);
      } else {
        if (body instanceof OutgoingContent) {
          $this$request.bts_1 = body;
          $this$request.qtx(null);
        } else {
          $this$request.bts_1 = body;
          // Inline function 'io.ktor.util.reflect.typeInfo' call
          var tmp_2 = getKClass(JsonObject);
          // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
          var tmp_3;
          try {
            tmp_3 = createKType(getKClass(JsonObject), arrayOf([]), false);
          } catch ($p_0) {
            var tmp_4;
            if ($p_0 instanceof Error) {
              var _unused_var__etf5q3_0 = $p_0;
              tmp_4 = null;
            } else {
              throw $p_0;
            }
            tmp_3 = tmp_4;
          }
          var tmp$ret$7 = tmp_3;
          var tmp$ret$6 = new TypeInfo(tmp_2, tmp$ret$7);
          $this$request.qtx(tmp$ret$6);
        }
      }
      return Unit_instance;
    };
  }
  function DefaultAuthProvider$signUp$lambda($redirectUrl, $contentType, $body) {
    return function ($this$request) {
      $this$request.ztr_1 = Companion_getInstance_2().ft2_1;
      var tmp0_safe_receiver = $redirectUrl;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        redirectTo($this$request, tmp0_safe_receiver);
      }
      contentType($this$request, $contentType);
      // Inline function 'io.ktor.client.request.setBody' call
      var body = $body;
      if (body == null) {
        $this$request.bts_1 = NullBody_instance;
        // Inline function 'io.ktor.util.reflect.typeInfo' call
        var tmp = getKClass(JsonObject);
        // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
        var tmp_0;
        try {
          tmp_0 = createKType(getKClass(JsonObject), arrayOf([]), false);
        } catch ($p) {
          var tmp_1;
          if ($p instanceof Error) {
            var _unused_var__etf5q3 = $p;
            tmp_1 = null;
          } else {
            throw $p;
          }
          tmp_0 = tmp_1;
        }
        var tmp$ret$5 = tmp_0;
        var tmp$ret$4 = new TypeInfo(tmp, tmp$ret$5);
        $this$request.qtx(tmp$ret$4);
      } else {
        if (body instanceof OutgoingContent) {
          $this$request.bts_1 = body;
          $this$request.qtx(null);
        } else {
          $this$request.bts_1 = body;
          // Inline function 'io.ktor.util.reflect.typeInfo' call
          var tmp_2 = getKClass(JsonObject);
          // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
          var tmp_3;
          try {
            tmp_3 = createKType(getKClass(JsonObject), arrayOf([]), false);
          } catch ($p_0) {
            var tmp_4;
            if ($p_0 instanceof Error) {
              var _unused_var__etf5q3_0 = $p_0;
              tmp_4 = null;
            } else {
              throw $p_0;
            }
            tmp_3 = tmp_4;
          }
          var tmp$ret$7 = tmp_3;
          var tmp$ret$6 = new TypeInfo(tmp_2, tmp$ret$7);
          $this$request.qtx(tmp$ret$6);
        }
      }
      return Unit_instance;
    };
  }
  function $loginCOROUTINE$(_this__u8e3s4, supabaseClient, onSuccess, redirectUrl, config, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.vwm_1 = _this__u8e3s4;
    this.wwm_1 = supabaseClient;
    this.xwm_1 = onSuccess;
    this.ywm_1 = redirectUrl;
    this.zwm_1 = config;
  }
  protoOf($loginCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            if (!!(this.zwm_1 == null)) {
              var message = 'Credentials are required';
              throw IllegalArgumentException_init_$Create$(toString_0(message));
            }

            var encodedCredentials = this.vwm_1.fwn(this.zwm_1);
            var tmp_0 = get_auth(this.wwm_1);
            var gotrue = tmp_0 instanceof AuthImpl ? tmp_0 : THROW_CCE();
            var url = 'token?grant_type=' + this.vwm_1.gwn();
            var tmp0 = gotrue.nw0_1;
            var contentType = Application_getInstance().ksv_1;
            this.n9_1 = 1;
            suspendResult = tmp0.wvm(url, DefaultAuthProvider$login$lambda(this.ywm_1, contentType, encodedCredentials), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var response = suspendResult;
            this.ewn_1 = null;
            this.n9_1 = 2;
            suspendResult = bodyAsText(response, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.cwn_1 = suspendResult;
            this.dwn_1 = !(this.ewn_1 == null) ? ' in ' + this.ewn_1 : '';
            this.o9_1 = 3;
            var tmp_1 = this;
            var tmp0_0 = get_supabaseJson();
            var string = this.cwn_1;
            var this_0 = tmp0_0.c75();
            var this_1 = serializer(this_0, createKType(getKClass(UserSession), arrayOf([]), false));
            tmp_1.bwn_1 = tmp0_0.c72(isInterface(this_1, KSerializer) ? this_1 : THROW_CCE(), string);
            this.o9_1 = 6;
            this.n9_1 = 4;
            continue $sm;
          case 3:
            this.o9_1 = 6;
            var tmp_2 = this.q9_1;
            if (tmp_2 instanceof MissingFieldException) {
              var e = this.q9_1;
              var tmp_3 = this;
              throw new SupabaseEncodingException("Couldn't decode payload" + this.dwn_1 + ' as ' + getKClass(UserSession).o() + '. Input: ' + replace(this.cwn_1, '\n', ''));
            } else {
              throw this.q9_1;
            }

          case 4:
            this.o9_1 = 6;
            this.awn_1 = this.bwn_1;
            var it = this.awn_1;
            this.n9_1 = 5;
            suspendResult = this.xwm_1(it, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            return Unit_instance;
          case 6:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 6) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function $signUpCOROUTINE$(_this__u8e3s4, supabaseClient, onSuccess, redirectUrl, config, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.pwn_1 = _this__u8e3s4;
    this.qwn_1 = supabaseClient;
    this.rwn_1 = onSuccess;
    this.swn_1 = redirectUrl;
    this.twn_1 = config;
  }
  protoOf($signUpCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 11;
            if (!!(this.twn_1 == null)) {
              var message = 'Credentials are required';
              throw IllegalArgumentException_init_$Create$(toString_0(message));
            }

            this.cwo_1 = this.pwn_1.fwn(this.twn_1);
            var tmp_0 = this;
            var tmp_1 = get_auth(this.qwn_1);
            tmp_0.dwo_1 = tmp_1 instanceof AuthImpl ? tmp_1 : THROW_CCE();
            this.bwo_1 = null;
            if (this.dwo_1.fw0_1.hvx_1.equals(FlowType_PKCE_getInstance())) {
              this.ewo_1 = generateCodeVerifier();
              this.n9_1 = 1;
              suspendResult = this.dwo_1.mw0_1.ow6(this.ewo_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 1:
            this.bwo_1 = generateCodeChallenge(this.ewo_1);
            this.n9_1 = 2;
            continue $sm;
          case 2:
            var tmp0_subject = this.pwn_1;
            var tmp_2;
            if (equals(tmp0_subject, Email_instance)) {
              tmp_2 = 'signup';
            } else if (equals(tmp0_subject, Phone_instance)) {
              tmp_2 = 'signup';
            } else if (equals(tmp0_subject, IDToken_instance)) {
              tmp_2 = 'token?grant_type=id_token';
            } else {
              noWhenBranchMatchedException();
            }

            var url = tmp_2;
            var tmp0 = this.dwo_1.nw0_1;
            var builder = new JsonObjectBuilder();
            putJsonObject(builder, this.cwo_1);
            if (!(this.bwo_1 == null)) {
              putCodeChallenge(builder, this.bwo_1);
            }

            var tmp4 = builder.wmh();
            var contentType = Application_getInstance().ksv_1;
            this.n9_1 = 3;
            suspendResult = tmp0.wvm(url, DefaultAuthProvider$signUp$lambda(this.swn_1, contentType, tmp4), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var response = suspendResult;
            this.awo_1 = null;
            this.n9_1 = 4;
            suspendResult = bodyAsText(response, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.ywn_1 = suspendResult;
            this.zwn_1 = !(this.awo_1 == null) ? ' in ' + this.awo_1 : '';
            this.o9_1 = 5;
            var tmp_3 = this;
            var tmp0_0 = get_supabaseJson();
            var string = this.ywn_1;
            var this_0 = tmp0_0.c75();
            var this_1 = serializer(this_0, createKType(getKClass(JsonObject), arrayOf([]), false));
            tmp_3.xwn_1 = tmp0_0.c72(isInterface(this_1, KSerializer) ? this_1 : THROW_CCE(), string);
            this.o9_1 = 11;
            this.n9_1 = 6;
            continue $sm;
          case 5:
            this.o9_1 = 11;
            var tmp_4 = this.q9_1;
            if (tmp_4 instanceof MissingFieldException) {
              var e = this.q9_1;
              var tmp_5 = this;
              throw new SupabaseEncodingException("Couldn't decode payload" + this.zwn_1 + ' as ' + getKClass(JsonObject).o() + '. Input: ' + replace(this.ywn_1, '\n', ''));
            } else {
              throw this.q9_1;
            }

          case 6:
            this.o9_1 = 11;
            this.uwn_1 = this.xwn_1;
            if (this.uwn_1.xmi('access_token')) {
              var this_2 = this.pwn_1;
              this.o9_1 = 8;
              this.wwn_1 = this_2;
              var tmp0_1 = get_supabaseJson();
              var json = this.uwn_1;
              var this_3 = tmp0_1.c75();
              var this_4 = serializer(this_3, createKType(getKClass(UserSession), arrayOf([]), false));
              var userSession = tmp0_1.mmg(isInterface(this_4, KSerializer) ? this_4 : THROW_CCE(), json);
              this.n9_1 = 7;
              suspendResult = this.rwn_1(userSession, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 10;
              continue $sm;
            }

          case 7:
            var tmp0_safe_receiver = this.uwn_1.je('user');
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : get_jsonObject(tmp0_safe_receiver);
            var tmp_6;
            if (tmp1_elvis_lhs == null) {
              var builder_0 = new JsonObjectBuilder();
              tmp_6 = builder_0.wmh();
            } else {
              tmp_6 = tmp1_elvis_lhs;
            }

            var userJson = tmp_6;
            return this.wwn_1.fwo(userJson);
          case 8:
            this.o9_1 = 11;
            var tmp_7 = this.q9_1;
            if (tmp_7 instanceof Error) {
              var e_0 = this.q9_1;
              var tmp_8 = this;
              tmp_8.vwn_1 = _Result___init__impl__xyqfz8(createFailure(e_0));
              this.n9_1 = 9;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 9:
            this.o9_1 = 11;
            var this_5 = this.vwn_1;
            var tmp0_safe_receiver_0 = Result__exceptionOrNull_impl_p6xea9(this_5);
            if (tmp0_safe_receiver_0 == null)
              null;
            else {
              var tmp0_2 = Companion_getInstance_6().wvx_1;
              var level = LogLevel_WARNING_getInstance();
              var tmp0_elvis_lhs = tmp0_2.fsu();
              if (level.i3(tmp0_elvis_lhs == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs) >= 0) {
                tmp0_2.fvj(level, tmp0_safe_receiver_0, 'Failed to decode user info');
              }
              return null;
            }

            this.n9_1 = 10;
            continue $sm;
          case 10:
            return this.pwn_1.fwo(this.uwn_1);
          case 11:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.o9_1 === 11) {
          throw e_1;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_1;
        }
      }
     while (true);
  };
  function DefaultAuthProvider() {
  }
  function Companion_14() {
  }
  var Companion_instance_15;
  function Companion_getInstance_21() {
    return Companion_instance_15;
  }
  function $serializer_2() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.github.jan.supabase.auth.providers.builtin.Email.Config', this, 4);
    tmp0_serialDesc.a7c('gotrue_meta_security', true);
    tmp0_serialDesc.a7c('data', true);
    tmp0_serialDesc.a7c('email', true);
    tmp0_serialDesc.a7c('password', true);
    this.gwo_1 = tmp0_serialDesc;
  }
  protoOf($serializer_2).hwo = function (encoder, value) {
    var tmp0_desc = this.gwo_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    if (tmp1_output.k76(tmp0_desc, 0) ? true : !(value.lwm_1 == null)) {
      tmp1_output.g76(tmp0_desc, 0, CaptchaTokenSerializer_getInstance(), value.lwm_1);
    }
    if (tmp1_output.k76(tmp0_desc, 1) ? true : !(value.mwm_1 == null)) {
      tmp1_output.g76(tmp0_desc, 1, JsonObjectSerializer_getInstance(), value.mwm_1);
    }
    if (tmp1_output.k76(tmp0_desc, 2) ? true : !(value.kwo_1 === '')) {
      tmp1_output.c76(tmp0_desc, 2, value.kwo_1);
    }
    if (tmp1_output.k76(tmp0_desc, 3) ? true : !(value.lwo_1 === '')) {
      tmp1_output.c76(tmp0_desc, 3, value.lwo_1);
    }
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_2).z70 = function (encoder, value) {
    return this.hwo(encoder, value instanceof Config_0 ? value : THROW_CCE());
  };
  protoOf($serializer_2).a71 = function (decoder) {
    var tmp0_desc = this.gwo_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.n74(tmp0_desc);
    if (tmp8_input.d75()) {
      tmp4_local0 = tmp8_input.b75(tmp0_desc, 0, CaptchaTokenSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.b75(tmp0_desc, 1, JsonObjectSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.x74(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.x74(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.b75(tmp0_desc, 0, CaptchaTokenSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.b75(tmp0_desc, 1, JsonObjectSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.x74(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.x74(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.o74(tmp0_desc);
    return Config_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_2).y70 = function () {
    return this.gwo_1;
  };
  protoOf($serializer_2).t7c = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(CaptchaTokenSerializer_getInstance()), get_nullable(JsonObjectSerializer_getInstance()), StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_2;
  function $serializer_getInstance_2() {
    if ($serializer_instance_2 == null)
      new $serializer_2();
    return $serializer_instance_2;
  }
  function Config_init_$Init$_0(seen0, captchaToken, data, email, password, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_2().gwo_1);
    }
    Config_init_$Init$(seen0, captchaToken, data, serializationConstructorMarker, $this);
    if (0 === (seen0 & 4))
      $this.kwo_1 = '';
    else
      $this.kwo_1 = email;
    if (0 === (seen0 & 8))
      $this.lwo_1 = '';
    else
      $this.lwo_1 = password;
    return $this;
  }
  function Config_init_$Create$(seen0, captchaToken, data, email, password, serializationConstructorMarker) {
    return Config_init_$Init$_0(seen0, captchaToken, data, email, password, serializationConstructorMarker, objectCreate(protoOf(Config_0)));
  }
  function Config_0(email, password) {
    email = email === VOID ? '' : email;
    password = password === VOID ? '' : password;
    Config.call(this);
    this.kwo_1 = email;
    this.lwo_1 = password;
  }
  protoOf(Config_0).toString = function () {
    return 'Config(email=' + this.kwo_1 + ', password=' + this.lwo_1 + ')';
  };
  protoOf(Config_0).hashCode = function () {
    var result = getStringHashCode(this.kwo_1);
    result = imul(result, 31) + getStringHashCode(this.lwo_1) | 0;
    return result;
  };
  protoOf(Config_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Config_0))
      return false;
    if (!(this.kwo_1 === other.kwo_1))
      return false;
    if (!(this.lwo_1 === other.lwo_1))
      return false;
    return true;
  };
  function Email() {
    this.mwo_1 = 'password';
  }
  protoOf(Email).gwn = function () {
    return this.mwo_1;
  };
  protoOf(Email).fwo = function (json) {
    var tmp;
    try {
      // Inline function 'kotlinx.serialization.json.decodeFromJsonElement' call
      var this_0 = get_supabaseJson();
      // Inline function 'kotlinx.serialization.serializer' call
      var this_1 = this_0.c75();
      // Inline function 'kotlinx.serialization.internal.cast' call
      var this_2 = serializer(this_1, createKType(getKClass(UserInfo), arrayOf([]), false));
      var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
      tmp = this_0.mmg(tmp$ret$1, json);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof MissingFieldException) {
        var e = $p;
        throw new SupabaseEncodingException("Couldn't decode sign up email result. Input: " + json.toString());
      } else {
        throw $p;
      }
    }
    return tmp;
  };
  protoOf(Email).nwo = function (credentials) {
    var tmp0 = get_supabaseJson();
    // Inline function 'kotlin.apply' call
    var this_0 = new Config_0();
    credentials(this_0);
    // Inline function 'kotlinx.serialization.json.encodeToJsonElement' call
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = tmp0.c75();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(Config_0), arrayOf([]), false));
    var tmp$ret$2 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
    var tmp$ret$1 = tmp0.lmg(tmp$ret$2, this_0);
    return get_jsonObject(tmp$ret$1);
  };
  protoOf(Email).fwn = function (credentials) {
    return this.nwo(credentials);
  };
  protoOf(Email).toString = function () {
    return 'Email';
  };
  protoOf(Email).hashCode = function () {
    return -189519665;
  };
  protoOf(Email).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Email))
      return false;
    return true;
  };
  var Email_instance;
  function Email_getInstance() {
    return Email_instance;
  }
  function Companion_15() {
  }
  var Companion_instance_16;
  function Companion_getInstance_22() {
    return Companion_instance_16;
  }
  function $serializer_3() {
    $serializer_instance_3 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.github.jan.supabase.auth.providers.builtin.IDToken.Config', this, 7);
    tmp0_serialDesc.a7c('gotrue_meta_security', true);
    tmp0_serialDesc.a7c('data', true);
    tmp0_serialDesc.a7c('id_token', true);
    tmp0_serialDesc.a7c('provider', true);
    tmp0_serialDesc.a7c('access_token', true);
    tmp0_serialDesc.a7c('nonce', true);
    tmp0_serialDesc.a7c('link_identity', true);
    this.owo_1 = tmp0_serialDesc;
  }
  protoOf($serializer_3).pwo = function (encoder, value) {
    var tmp0_desc = this.owo_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    if (tmp1_output.k76(tmp0_desc, 0) ? true : !(value.lwm_1 == null)) {
      tmp1_output.g76(tmp0_desc, 0, CaptchaTokenSerializer_getInstance(), value.lwm_1);
    }
    if (tmp1_output.k76(tmp0_desc, 1) ? true : !(value.mwm_1 == null)) {
      tmp1_output.g76(tmp0_desc, 1, JsonObjectSerializer_getInstance(), value.mwm_1);
    }
    if (tmp1_output.k76(tmp0_desc, 2) ? true : !(value.swo_1 === '')) {
      tmp1_output.c76(tmp0_desc, 2, value.swo_1);
    }
    if (tmp1_output.k76(tmp0_desc, 3) ? true : !(value.two_1 == null)) {
      tmp1_output.g76(tmp0_desc, 3, Companion_getInstance_18(), value.two_1);
    }
    if (tmp1_output.k76(tmp0_desc, 4) ? true : !(value.uwo_1 == null)) {
      tmp1_output.g76(tmp0_desc, 4, StringSerializer_getInstance(), value.uwo_1);
    }
    if (tmp1_output.k76(tmp0_desc, 5) ? true : !(value.vwo_1 == null)) {
      tmp1_output.g76(tmp0_desc, 5, StringSerializer_getInstance(), value.vwo_1);
    }
    if (tmp1_output.k76(tmp0_desc, 6) ? true : !(value.wwo_1 === false)) {
      tmp1_output.u75(tmp0_desc, 6, value.wwo_1);
    }
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_3).z70 = function (encoder, value) {
    return this.pwo(encoder, value instanceof Config_1 ? value : THROW_CCE());
  };
  protoOf($serializer_3).a71 = function (decoder) {
    var tmp0_desc = this.owo_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = false;
    var tmp11_input = decoder.n74(tmp0_desc);
    if (tmp11_input.d75()) {
      tmp4_local0 = tmp11_input.b75(tmp0_desc, 0, CaptchaTokenSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.b75(tmp0_desc, 1, JsonObjectSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.x74(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.b75(tmp0_desc, 3, Companion_getInstance_18(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.b75(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.b75(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.p74(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.b75(tmp0_desc, 0, CaptchaTokenSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.b75(tmp0_desc, 1, JsonObjectSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.x74(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.b75(tmp0_desc, 3, Companion_getInstance_18(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.b75(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.b75(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.p74(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp11_input.o74(tmp0_desc);
    return Config_init_$Create$_0(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  };
  protoOf($serializer_3).y70 = function () {
    return this.owo_1;
  };
  protoOf($serializer_3).t7c = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(CaptchaTokenSerializer_getInstance()), get_nullable(JsonObjectSerializer_getInstance()), StringSerializer_getInstance(), get_nullable(Companion_getInstance_18()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), BooleanSerializer_getInstance()];
  };
  var $serializer_instance_3;
  function $serializer_getInstance_3() {
    if ($serializer_instance_3 == null)
      new $serializer_3();
    return $serializer_instance_3;
  }
  function Config_init_$Init$_1(seen0, captchaToken, data, idToken, provider, accessToken, nonce, linkIdentity, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_3().owo_1);
    }
    Config_init_$Init$(seen0, captchaToken, data, serializationConstructorMarker, $this);
    if (0 === (seen0 & 4))
      $this.swo_1 = '';
    else
      $this.swo_1 = idToken;
    if (0 === (seen0 & 8))
      $this.two_1 = null;
    else
      $this.two_1 = provider;
    if (0 === (seen0 & 16))
      $this.uwo_1 = null;
    else
      $this.uwo_1 = accessToken;
    if (0 === (seen0 & 32))
      $this.vwo_1 = null;
    else
      $this.vwo_1 = nonce;
    if (0 === (seen0 & 64))
      $this.wwo_1 = false;
    else
      $this.wwo_1 = linkIdentity;
    return $this;
  }
  function Config_init_$Create$_0(seen0, captchaToken, data, idToken, provider, accessToken, nonce, linkIdentity, serializationConstructorMarker) {
    return Config_init_$Init$_1(seen0, captchaToken, data, idToken, provider, accessToken, nonce, linkIdentity, serializationConstructorMarker, objectCreate(protoOf(Config_1)));
  }
  function Config_1(idToken, provider, accessToken, nonce, linkIdentity) {
    idToken = idToken === VOID ? '' : idToken;
    provider = provider === VOID ? null : provider;
    accessToken = accessToken === VOID ? null : accessToken;
    nonce = nonce === VOID ? null : nonce;
    linkIdentity = linkIdentity === VOID ? false : linkIdentity;
    Config.call(this);
    this.swo_1 = idToken;
    this.two_1 = provider;
    this.uwo_1 = accessToken;
    this.vwo_1 = nonce;
    this.wwo_1 = linkIdentity;
  }
  protoOf(Config_1).toString = function () {
    return 'Config(idToken=' + this.swo_1 + ', provider=' + toString(this.two_1) + ', accessToken=' + this.uwo_1 + ', nonce=' + this.vwo_1 + ', linkIdentity=' + this.wwo_1 + ')';
  };
  protoOf(Config_1).hashCode = function () {
    var result = getStringHashCode(this.swo_1);
    result = imul(result, 31) + (this.two_1 == null ? 0 : hashCode(this.two_1)) | 0;
    result = imul(result, 31) + (this.uwo_1 == null ? 0 : getStringHashCode(this.uwo_1)) | 0;
    result = imul(result, 31) + (this.vwo_1 == null ? 0 : getStringHashCode(this.vwo_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.wwo_1) | 0;
    return result;
  };
  protoOf(Config_1).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Config_1))
      return false;
    if (!(this.swo_1 === other.swo_1))
      return false;
    if (!equals(this.two_1, other.two_1))
      return false;
    if (!(this.uwo_1 == other.uwo_1))
      return false;
    if (!(this.vwo_1 == other.vwo_1))
      return false;
    if (!(this.wwo_1 === other.wwo_1))
      return false;
    return true;
  };
  function IDToken() {
    this.xwo_1 = 'id_token';
  }
  protoOf(IDToken).gwn = function () {
    return this.xwo_1;
  };
  protoOf(IDToken).fwo = function (json) {
    var tmp;
    try {
      // Inline function 'kotlinx.serialization.json.decodeFromJsonElement' call
      var this_0 = get_supabaseJson();
      // Inline function 'kotlinx.serialization.serializer' call
      var this_1 = this_0.c75();
      // Inline function 'kotlinx.serialization.internal.cast' call
      var this_2 = serializer(this_1, createKType(getKClass(UserInfo), arrayOf([]), false));
      var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
      tmp = this_0.mmg(tmp$ret$1, json);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof MissingFieldException) {
        var e = $p;
        throw new SupabaseEncodingException("Couldn't decode sign up id token result. Input: " + json.toString());
      } else {
        throw $p;
      }
    }
    return tmp;
  };
  protoOf(IDToken).ywo = function (credentials) {
    var tmp0 = get_supabaseJson();
    // Inline function 'kotlin.apply' call
    var this_0 = new Config_1();
    credentials(this_0);
    // Inline function 'kotlinx.serialization.json.encodeToJsonElement' call
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = tmp0.c75();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(Config_1), arrayOf([]), false));
    var tmp$ret$2 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
    var tmp$ret$1 = tmp0.lmg(tmp$ret$2, this_0);
    return get_jsonObject(tmp$ret$1);
  };
  protoOf(IDToken).fwn = function (credentials) {
    return this.ywo(credentials);
  };
  protoOf(IDToken).toString = function () {
    return 'IDToken';
  };
  protoOf(IDToken).hashCode = function () {
    return 624623153;
  };
  protoOf(IDToken).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof IDToken))
      return false;
    return true;
  };
  var IDToken_instance;
  function IDToken_getInstance() {
    return IDToken_instance;
  }
  function Companion_16() {
  }
  var Companion_instance_17;
  function Companion_getInstance_23() {
    return Companion_instance_17;
  }
  function $serializer_4() {
    $serializer_instance_4 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.github.jan.supabase.auth.providers.builtin.Phone.Config', this, 5);
    tmp0_serialDesc.a7c('gotrue_meta_security', true);
    tmp0_serialDesc.a7c('data', true);
    tmp0_serialDesc.a7c('phone', true);
    tmp0_serialDesc.a7c('password', true);
    tmp0_serialDesc.a7c('channel', true);
    this.zwo_1 = tmp0_serialDesc;
  }
  protoOf($serializer_4).awp = function (encoder, value) {
    var tmp0_desc = this.zwo_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    if (tmp1_output.k76(tmp0_desc, 0) ? true : !(value.lwm_1 == null)) {
      tmp1_output.g76(tmp0_desc, 0, CaptchaTokenSerializer_getInstance(), value.lwm_1);
    }
    if (tmp1_output.k76(tmp0_desc, 1) ? true : !(value.mwm_1 == null)) {
      tmp1_output.g76(tmp0_desc, 1, JsonObjectSerializer_getInstance(), value.mwm_1);
    }
    if (tmp1_output.k76(tmp0_desc, 2) ? true : !(value.dwp_1 === '')) {
      tmp1_output.c76(tmp0_desc, 2, value.dwp_1);
    }
    if (tmp1_output.k76(tmp0_desc, 3) ? true : !(value.ewp_1 === '')) {
      tmp1_output.c76(tmp0_desc, 3, value.ewp_1);
    }
    if (tmp1_output.k76(tmp0_desc, 4) ? true : !value.fwp_1.equals(Channel_SMS_getInstance())) {
      tmp1_output.e76(tmp0_desc, 4, Companion_getInstance_24(), value.fwp_1);
    }
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_4).z70 = function (encoder, value) {
    return this.awp(encoder, value instanceof Config_2 ? value : THROW_CCE());
  };
  protoOf($serializer_4).a71 = function (decoder) {
    var tmp0_desc = this.zwo_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.n74(tmp0_desc);
    if (tmp9_input.d75()) {
      tmp4_local0 = tmp9_input.b75(tmp0_desc, 0, CaptchaTokenSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.b75(tmp0_desc, 1, JsonObjectSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.x74(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.x74(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.z74(tmp0_desc, 4, Companion_getInstance_24(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.b75(tmp0_desc, 0, CaptchaTokenSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.b75(tmp0_desc, 1, JsonObjectSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.x74(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.x74(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.z74(tmp0_desc, 4, Companion_getInstance_24(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.o74(tmp0_desc);
    return Config_init_$Create$_1(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_4).y70 = function () {
    return this.zwo_1;
  };
  protoOf($serializer_4).t7c = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(CaptchaTokenSerializer_getInstance()), get_nullable(JsonObjectSerializer_getInstance()), StringSerializer_getInstance(), StringSerializer_getInstance(), Companion_getInstance_24()];
  };
  var $serializer_instance_4;
  function $serializer_getInstance_4() {
    if ($serializer_instance_4 == null)
      new $serializer_4();
    return $serializer_instance_4;
  }
  function Config_init_$Init$_2(seen0, captchaToken, data, phone, password, channel, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_4().zwo_1);
    }
    Config_init_$Init$(seen0, captchaToken, data, serializationConstructorMarker, $this);
    if (0 === (seen0 & 4))
      $this.dwp_1 = '';
    else
      $this.dwp_1 = phone;
    if (0 === (seen0 & 8))
      $this.ewp_1 = '';
    else
      $this.ewp_1 = password;
    if (0 === (seen0 & 16))
      $this.fwp_1 = Channel_SMS_getInstance();
    else
      $this.fwp_1 = channel;
    return $this;
  }
  function Config_init_$Create$_1(seen0, captchaToken, data, phone, password, channel, serializationConstructorMarker) {
    return Config_init_$Init$_2(seen0, captchaToken, data, phone, password, channel, serializationConstructorMarker, objectCreate(protoOf(Config_2)));
  }
  var Channel_SMS_instance;
  var Channel_WHATSAPP_instance;
  function Companion_17() {
    Companion_instance_18 = this;
    this.gwp_1 = PrimitiveSerialDescriptor('Channel', STRING_getInstance());
  }
  protoOf(Companion_17).y70 = function () {
    return this.gwp_1;
  };
  protoOf(Companion_17).a71 = function (decoder) {
    var tmp0 = get_entries_0();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.first' call
      var _iterator__ex2g4s = tmp0.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        if (element.jwp_1 === decoder.i74()) {
          tmp$ret$0 = element;
          break $l$block;
        }
      }
      throw NoSuchElementException_init_$Create$('Collection contains no element matching the predicate.');
    }
    return tmp$ret$0;
  };
  protoOf(Companion_17).kwp = function (encoder, value) {
    encoder.r75(value.jwp_1);
  };
  protoOf(Companion_17).z70 = function (encoder, value) {
    return this.kwp(encoder, value instanceof Channel ? value : THROW_CCE());
  };
  protoOf(Companion_17).amj = function () {
    return Companion_getInstance_24();
  };
  protoOf(Companion_17).e7d = function (typeParamsSerializers) {
    return this.amj();
  };
  var Companion_instance_18;
  function Companion_getInstance_24() {
    Channel_initEntries();
    if (Companion_instance_18 == null)
      new Companion_17();
    return Companion_instance_18;
  }
  function values_3() {
    return [Channel_SMS_getInstance(), Channel_WHATSAPP_getInstance()];
  }
  function get_entries_0() {
    if ($ENTRIES_0 == null)
      $ENTRIES_0 = enumEntries(values_3());
    return $ENTRIES_0;
  }
  var Channel_entriesInitialized;
  function Channel_initEntries() {
    if (Channel_entriesInitialized)
      return Unit_instance;
    Channel_entriesInitialized = true;
    Channel_SMS_instance = new Channel('SMS', 0, 'sms');
    Channel_WHATSAPP_instance = new Channel('WHATSAPP', 1, 'whatsapp');
    Companion_getInstance_24();
  }
  var $ENTRIES_0;
  function Config_2(phone, password, channel) {
    phone = phone === VOID ? '' : phone;
    password = password === VOID ? '' : password;
    channel = channel === VOID ? Channel_SMS_getInstance() : channel;
    Config.call(this);
    this.dwp_1 = phone;
    this.ewp_1 = password;
    this.fwp_1 = channel;
  }
  protoOf(Config_2).toString = function () {
    return 'Config(phone=' + this.dwp_1 + ', password=' + this.ewp_1 + ', channel=' + this.fwp_1.toString() + ')';
  };
  protoOf(Config_2).hashCode = function () {
    var result = getStringHashCode(this.dwp_1);
    result = imul(result, 31) + getStringHashCode(this.ewp_1) | 0;
    result = imul(result, 31) + this.fwp_1.hashCode() | 0;
    return result;
  };
  protoOf(Config_2).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Config_2))
      return false;
    if (!(this.dwp_1 === other.dwp_1))
      return false;
    if (!(this.ewp_1 === other.ewp_1))
      return false;
    if (!this.fwp_1.equals(other.fwp_1))
      return false;
    return true;
  };
  function Channel(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.jwp_1 = value;
  }
  function Channel_SMS_getInstance() {
    Channel_initEntries();
    return Channel_SMS_instance;
  }
  function Channel_WHATSAPP_getInstance() {
    Channel_initEntries();
    return Channel_WHATSAPP_instance;
  }
  function Phone() {
    this.lwp_1 = 'password';
  }
  protoOf(Phone).gwn = function () {
    return this.lwp_1;
  };
  protoOf(Phone).fwo = function (json) {
    var tmp;
    try {
      // Inline function 'kotlinx.serialization.json.decodeFromJsonElement' call
      var this_0 = get_supabaseJson();
      // Inline function 'kotlinx.serialization.serializer' call
      var this_1 = this_0.c75();
      // Inline function 'kotlinx.serialization.internal.cast' call
      var this_2 = serializer(this_1, createKType(getKClass(UserInfo), arrayOf([]), false));
      var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
      tmp = this_0.mmg(tmp$ret$1, json);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof MissingFieldException) {
        var e = $p;
        throw new SupabaseEncodingException("Couldn't decode sign up phone result. Input: " + json.toString());
      } else {
        throw $p;
      }
    }
    return tmp;
  };
  protoOf(Phone).mwp = function (credentials) {
    var tmp0 = get_supabaseJson();
    // Inline function 'kotlin.apply' call
    var this_0 = new Config_2();
    credentials(this_0);
    // Inline function 'kotlinx.serialization.json.encodeToJsonElement' call
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = tmp0.c75();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(Config_2), arrayOf([]), false));
    var tmp$ret$2 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
    var tmp$ret$1 = tmp0.lmg(tmp$ret$2, this_0);
    return get_jsonObject(tmp$ret$1);
  };
  protoOf(Phone).fwn = function (credentials) {
    return this.mwp(credentials);
  };
  protoOf(Phone).toString = function () {
    return 'Phone';
  };
  protoOf(Phone).hashCode = function () {
    return -179496287;
  };
  protoOf(Phone).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Phone))
      return false;
    return true;
  };
  var Phone_instance;
  function Phone_getInstance() {
    return Phone_instance;
  }
  function NetworkError(exception) {
    this.nwp_1 = exception;
  }
  protoOf(NetworkError).toString = function () {
    return 'NetworkError(exception=' + this.nwp_1.toString() + ')';
  };
  protoOf(NetworkError).hashCode = function () {
    return hashCode(this.nwp_1);
  };
  protoOf(NetworkError).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NetworkError))
      return false;
    if (!equals(this.nwp_1, other.nwp_1))
      return false;
    return true;
  };
  function InternalServerError(exception) {
    this.owp_1 = exception;
  }
  protoOf(InternalServerError).toString = function () {
    return 'InternalServerError(exception=' + this.owp_1.toString() + ')';
  };
  protoOf(InternalServerError).hashCode = function () {
    return hashCode(this.owp_1);
  };
  protoOf(InternalServerError).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof InternalServerError))
      return false;
    if (!equals(this.owp_1, other.owp_1))
      return false;
    return true;
  };
  function RefreshFailureCause() {
  }
  function Storage() {
  }
  protoOf(Storage).toString = function () {
    return 'Storage';
  };
  protoOf(Storage).hashCode = function () {
    return 1966824888;
  };
  protoOf(Storage).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Storage))
      return false;
    return true;
  };
  var Storage_instance;
  function Storage_getInstance() {
    return Storage_instance;
  }
  function SignIn(provider) {
    this.pwp_1 = provider;
  }
  protoOf(SignIn).toString = function () {
    return 'SignIn(provider=' + toString_0(this.pwp_1) + ')';
  };
  protoOf(SignIn).hashCode = function () {
    return hashCode(this.pwp_1);
  };
  protoOf(SignIn).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SignIn))
      return false;
    if (!equals(this.pwp_1, other.pwp_1))
      return false;
    return true;
  };
  function SignUp(provider) {
    this.qwp_1 = provider;
  }
  protoOf(SignUp).toString = function () {
    return 'SignUp(provider=' + toString_0(this.qwp_1) + ')';
  };
  protoOf(SignUp).hashCode = function () {
    return hashCode(this.qwp_1);
  };
  protoOf(SignUp).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SignUp))
      return false;
    if (!equals(this.qwp_1, other.qwp_1))
      return false;
    return true;
  };
  function External() {
  }
  protoOf(External).toString = function () {
    return 'External';
  };
  protoOf(External).hashCode = function () {
    return 1599189038;
  };
  protoOf(External).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof External))
      return false;
    return true;
  };
  var External_instance;
  function External_getInstance() {
    return External_instance;
  }
  function Unknown() {
  }
  protoOf(Unknown).toString = function () {
    return 'Unknown';
  };
  protoOf(Unknown).hashCode = function () {
    return -728709241;
  };
  protoOf(Unknown).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Unknown))
      return false;
    return true;
  };
  var Unknown_instance;
  function Unknown_getInstance() {
    return Unknown_instance;
  }
  function Refresh(oldSession) {
    this.rwp_1 = oldSession;
  }
  protoOf(Refresh).toString = function () {
    return 'Refresh(oldSession=' + this.rwp_1.toString() + ')';
  };
  protoOf(Refresh).hashCode = function () {
    return this.rwp_1.hashCode();
  };
  protoOf(Refresh).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Refresh))
      return false;
    if (!this.rwp_1.equals(other.rwp_1))
      return false;
    return true;
  };
  function UserChanged(oldSession) {
    this.swp_1 = oldSession;
  }
  protoOf(UserChanged).toString = function () {
    return 'UserChanged(oldSession=' + this.swp_1.toString() + ')';
  };
  protoOf(UserChanged).hashCode = function () {
    return this.swp_1.hashCode();
  };
  protoOf(UserChanged).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UserChanged))
      return false;
    if (!this.swp_1.equals(other.swp_1))
      return false;
    return true;
  };
  function NotAuthenticated(isSignOut) {
    isSignOut = isSignOut === VOID ? false : isSignOut;
    this.twp_1 = isSignOut;
  }
  protoOf(NotAuthenticated).toString = function () {
    return 'NotAuthenticated(isSignOut=' + this.twp_1 + ')';
  };
  protoOf(NotAuthenticated).hashCode = function () {
    return getBooleanHashCode(this.twp_1);
  };
  protoOf(NotAuthenticated).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NotAuthenticated))
      return false;
    if (!(this.twp_1 === other.twp_1))
      return false;
    return true;
  };
  function Initializing() {
  }
  protoOf(Initializing).toString = function () {
    return 'Initializing';
  };
  protoOf(Initializing).hashCode = function () {
    return 884143289;
  };
  protoOf(Initializing).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Initializing))
      return false;
    return true;
  };
  var Initializing_instance;
  function Initializing_getInstance() {
    return Initializing_instance;
  }
  function RefreshFailure_0(cause) {
    this.uwp_1 = cause;
  }
  protoOf(RefreshFailure_0).toString = function () {
    return 'RefreshFailure(cause=' + toString_0(this.uwp_1) + ')';
  };
  protoOf(RefreshFailure_0).hashCode = function () {
    return hashCode(this.uwp_1);
  };
  protoOf(RefreshFailure_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RefreshFailure_0))
      return false;
    if (!equals(this.uwp_1, other.uwp_1))
      return false;
    return true;
  };
  function Authenticated(session, source) {
    source = source === VOID ? Unknown_instance : source;
    this.nvz_1 = session;
    this.ovz_1 = source;
    var tmp = this;
    var tmp_0;
    var tmp_1;
    var tmp_2 = this.ovz_1;
    if (tmp_2 instanceof SignIn) {
      tmp_1 = true;
    } else {
      var tmp_3 = this.ovz_1;
      tmp_1 = tmp_3 instanceof SignUp;
    }
    if (tmp_1) {
      tmp_0 = true;
    } else {
      var tmp_4 = this.ovz_1;
      tmp_0 = tmp_4 instanceof External;
    }
    tmp.pvz_1 = tmp_0;
  }
  protoOf(Authenticated).toString = function () {
    return 'Authenticated(session=' + this.nvz_1.toString() + ', source=' + toString_0(this.ovz_1) + ')';
  };
  protoOf(Authenticated).hashCode = function () {
    var result = this.nvz_1.hashCode();
    result = imul(result, 31) + hashCode(this.ovz_1) | 0;
    return result;
  };
  protoOf(Authenticated).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Authenticated))
      return false;
    if (!this.nvz_1.equals(other.nvz_1))
      return false;
    if (!equals(this.ovz_1, other.ovz_1))
      return false;
    return true;
  };
  function SessionStatus() {
  }
  function handledUrlParameterError(_this__u8e3s4, parameters) {
    var error = checkForUrlParameterError(parameters);
    var tmp;
    if (!(error == null)) {
      var tmp_0 = _this__u8e3s4.svy().u1();
      if (!(tmp_0 instanceof Authenticated)) {
        // Inline function 'io.github.jan.supabase.logging.d' call
        var tmp0 = Companion_getInstance_6().wvx_1;
        // Inline function 'io.github.jan.supabase.logging.SupabaseLogger.log' call
        var level = LogLevel_DEBUG_getInstance();
        var tmp0_elvis_lhs = tmp0.fsu();
        if (level.i3(tmp0_elvis_lhs == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs) >= 0) {
          var tmp$ret$2 = 'Found error code in the URL Parameters: ' + error.toString() + '. Emitting event...';
          tmp0.fvj(level, null, tmp$ret$2);
        }
        _this__u8e3s4.ivz(error);
      }
      tmp = true;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function checkForUrlParameterError(parameters) {
    var error = parameters('error');
    var errorCode = parameters('error_code');
    var errorDescription = parameters('error_description');
    var tmp;
    if (!(errorCode == null)) {
      tmp = new OtpError(errorCode, '' + errorDescription + ' (' + error + ')');
    } else {
      tmp = null;
    }
    return tmp;
  }
  function getFragmentParts(fragment) {
    var pairs = split(fragment, ['&']);
    if (pairs.r())
      return emptyMap();
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = pairs.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      var keyAndValue = split(element, ['=']);
      var tmp0_safe_receiver = getOrNull(keyAndValue, 0);
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        var tmp0_safe_receiver_0 = getOrNull(keyAndValue, 1);
        var tmp_0;
        if (tmp0_safe_receiver_0 == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_0 = to(tmp0_safe_receiver, tmp0_safe_receiver_0);
        }
        tmp = tmp_0;
      }
      var tmp0_safe_receiver_1 = tmp;
      if (tmp0_safe_receiver_1 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination.j1(tmp0_safe_receiver_1);
      }
    }
    return toMap(destination);
  }
  function validateHash(_this__u8e3s4, hash) {
    // Inline function 'io.github.jan.supabase.logging.d' call
    var tmp0 = Companion_getInstance_6().wvx_1;
    // Inline function 'io.github.jan.supabase.logging.SupabaseLogger.log' call
    var level = LogLevel_DEBUG_getInstance();
    var tmp0_elvis_lhs = tmp0.fsu();
    if (level.i3(tmp0_elvis_lhs == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs) >= 0) {
      var tmp$ret$2 = 'Parsing fragment/hash ' + hash;
      tmp0.fvj(level, null, tmp$ret$2);
    }
    var parameters = getFragmentParts(hash);
    if (handledUrlParameterError(_this__u8e3s4, validateHash$lambda(parameters))) {
      return ErrorFound_instance;
    }
    var tmp;
    try {
      tmp = parseSessionFromFragment(_this__u8e3s4, hash);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        // Inline function 'io.github.jan.supabase.logging.d' call
        var tmp0_0 = Companion_getInstance_6().wvx_1;
        // Inline function 'io.github.jan.supabase.logging.SupabaseLogger.log' call
        var level_0 = LogLevel_DEBUG_getInstance();
        var tmp0_elvis_lhs_0 = tmp0_0.fsu();
        if (level_0.i3(tmp0_elvis_lhs_0 == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs_0) >= 0) {
          var tmp$ret$5 = 'Received invalid session fragment. Ignoring.';
          tmp0_0.fvj(level_0, e, tmp$ret$5);
        }
        return Skipped_instance;
      } else {
        throw $p;
      }
    }
    var session = tmp;
    return new SessionFound(session);
  }
  function consumeHashParameters(parameters, url) {
    // Inline function 'io.github.jan.supabase.buildUrl' call
    var builder = URLBuilder(url);
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = split(builder.bt7(), ['&']);
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      if (!parameters.m1(first(split(element, ['='])))) {
        destination.j1(element);
      }
    }
    builder.at7(joinToString(destination, '&'));
    return builder.ft7();
  }
  function validateHash$lambda($parameters) {
    return function (it) {
      return $parameters.w2(it);
    };
  }
  function consumeUrlParameter(parameters, url) {
    // Inline function 'io.github.jan.supabase.buildUrl' call
    var builder = URLBuilder(url);
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = parameters.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      builder.qt5_1.jsq(element);
    }
    return builder.ft7();
  }
  function ErrorFound() {
  }
  protoOf(ErrorFound).toString = function () {
    return 'ErrorFound';
  };
  protoOf(ErrorFound).hashCode = function () {
    return -568229480;
  };
  protoOf(ErrorFound).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ErrorFound))
      return false;
    return true;
  };
  var ErrorFound_instance;
  function ErrorFound_getInstance() {
    return ErrorFound_instance;
  }
  function SessionFound(session) {
    this.vwp_1 = session;
  }
  protoOf(SessionFound).toString = function () {
    return 'SessionFound(session=' + this.vwp_1.toString() + ')';
  };
  protoOf(SessionFound).hashCode = function () {
    return this.vwp_1.hashCode();
  };
  protoOf(SessionFound).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SessionFound))
      return false;
    if (!this.vwp_1.equals(other.vwp_1))
      return false;
    return true;
  };
  function Skipped() {
  }
  protoOf(Skipped).toString = function () {
    return 'Skipped';
  };
  protoOf(Skipped).hashCode = function () {
    return -1059112782;
  };
  protoOf(Skipped).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Skipped))
      return false;
    return true;
  };
  var Skipped_instance;
  function Skipped_getInstance() {
    return Skipped_instance;
  }
  function $serializer_5() {
    $serializer_instance_5 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.github.jan.supabase.auth.user.Identity', this, 8);
    tmp0_serialDesc.a7c('id', false);
    tmp0_serialDesc.a7c('identity_data', false);
    tmp0_serialDesc.a7c('identity_id', true);
    tmp0_serialDesc.a7c('last_sign_in_at', true);
    tmp0_serialDesc.a7c('updated_at', true);
    tmp0_serialDesc.a7c('created_at', true);
    tmp0_serialDesc.a7c('provider', false);
    tmp0_serialDesc.a7c('user_id', false);
    this.wwp_1 = tmp0_serialDesc;
  }
  protoOf($serializer_5).xwp = function (encoder, value) {
    var tmp0_desc = this.wwp_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    tmp1_output.c76(tmp0_desc, 0, value.ywp_1);
    tmp1_output.e76(tmp0_desc, 1, JsonObjectSerializer_getInstance(), value.zwp_1);
    if (tmp1_output.k76(tmp0_desc, 2) ? true : !(value.awq_1 == null)) {
      tmp1_output.g76(tmp0_desc, 2, StringSerializer_getInstance(), value.awq_1);
    }
    if (tmp1_output.k76(tmp0_desc, 3) ? true : !(value.bwq_1 == null)) {
      tmp1_output.g76(tmp0_desc, 3, StringSerializer_getInstance(), value.bwq_1);
    }
    if (tmp1_output.k76(tmp0_desc, 4) ? true : !(value.cwq_1 == null)) {
      tmp1_output.g76(tmp0_desc, 4, StringSerializer_getInstance(), value.cwq_1);
    }
    if (tmp1_output.k76(tmp0_desc, 5) ? true : !(value.dwq_1 == null)) {
      tmp1_output.g76(tmp0_desc, 5, StringSerializer_getInstance(), value.dwq_1);
    }
    tmp1_output.c76(tmp0_desc, 6, value.ewq_1);
    tmp1_output.c76(tmp0_desc, 7, value.fwq_1);
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_5).z70 = function (encoder, value) {
    return this.xwp(encoder, value instanceof Identity ? value : THROW_CCE());
  };
  protoOf($serializer_5).a71 = function (decoder) {
    var tmp0_desc = this.wwp_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_input = decoder.n74(tmp0_desc);
    if (tmp12_input.d75()) {
      tmp4_local0 = tmp12_input.x74(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp12_input.z74(tmp0_desc, 1, JsonObjectSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp12_input.b75(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp12_input.b75(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp12_input.b75(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp12_input.b75(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp12_input.x74(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp12_input.x74(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp12_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp12_input.x74(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp12_input.z74(tmp0_desc, 1, JsonObjectSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp12_input.b75(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp12_input.b75(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp12_input.b75(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp12_input.b75(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp12_input.x74(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp12_input.x74(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp12_input.o74(tmp0_desc);
    return Identity_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
  };
  protoOf($serializer_5).y70 = function () {
    return this.wwp_1;
  };
  protoOf($serializer_5).t7c = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), JsonObjectSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_5;
  function $serializer_getInstance_5() {
    if ($serializer_instance_5 == null)
      new $serializer_5();
    return $serializer_instance_5;
  }
  function Identity_init_$Init$(seen0, id, identityData, identityId, lastSignInAt, updatedAt, createdAt, provider, userId, serializationConstructorMarker, $this) {
    if (!(195 === (195 & seen0))) {
      throwMissingFieldException(seen0, 195, $serializer_getInstance_5().wwp_1);
    }
    $this.ywp_1 = id;
    $this.zwp_1 = identityData;
    if (0 === (seen0 & 4))
      $this.awq_1 = null;
    else
      $this.awq_1 = identityId;
    if (0 === (seen0 & 8))
      $this.bwq_1 = null;
    else
      $this.bwq_1 = lastSignInAt;
    if (0 === (seen0 & 16))
      $this.cwq_1 = null;
    else
      $this.cwq_1 = updatedAt;
    if (0 === (seen0 & 32))
      $this.dwq_1 = null;
    else
      $this.dwq_1 = createdAt;
    $this.ewq_1 = provider;
    $this.fwq_1 = userId;
    return $this;
  }
  function Identity_init_$Create$(seen0, id, identityData, identityId, lastSignInAt, updatedAt, createdAt, provider, userId, serializationConstructorMarker) {
    return Identity_init_$Init$(seen0, id, identityData, identityId, lastSignInAt, updatedAt, createdAt, provider, userId, serializationConstructorMarker, objectCreate(protoOf(Identity)));
  }
  function Identity() {
  }
  protoOf(Identity).toString = function () {
    return 'Identity(id=' + this.ywp_1 + ', identityData=' + this.zwp_1.toString() + ', identityId=' + this.awq_1 + ', lastSignInAt=' + this.bwq_1 + ', updatedAt=' + this.cwq_1 + ', createdAt=' + this.dwq_1 + ', provider=' + this.ewq_1 + ', userId=' + this.fwq_1 + ')';
  };
  protoOf(Identity).hashCode = function () {
    var result = getStringHashCode(this.ywp_1);
    result = imul(result, 31) + this.zwp_1.hashCode() | 0;
    result = imul(result, 31) + (this.awq_1 == null ? 0 : getStringHashCode(this.awq_1)) | 0;
    result = imul(result, 31) + (this.bwq_1 == null ? 0 : getStringHashCode(this.bwq_1)) | 0;
    result = imul(result, 31) + (this.cwq_1 == null ? 0 : getStringHashCode(this.cwq_1)) | 0;
    result = imul(result, 31) + (this.dwq_1 == null ? 0 : getStringHashCode(this.dwq_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.ewq_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.fwq_1) | 0;
    return result;
  };
  protoOf(Identity).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Identity))
      return false;
    if (!(this.ywp_1 === other.ywp_1))
      return false;
    if (!this.zwp_1.equals(other.zwp_1))
      return false;
    if (!(this.awq_1 == other.awq_1))
      return false;
    if (!(this.bwq_1 == other.bwq_1))
      return false;
    if (!(this.cwq_1 == other.cwq_1))
      return false;
    if (!(this.dwq_1 == other.dwq_1))
      return false;
    if (!(this.ewq_1 === other.ewq_1))
      return false;
    if (!(this.fwq_1 === other.fwq_1))
      return false;
    return true;
  };
  function UserInfo$Companion$$childSerializers$_anonymous__nu26tt() {
    return new ArrayListSerializer($serializer_getInstance_7());
  }
  function UserInfo$Companion$$childSerializers$_anonymous__nu26tt_0() {
    return new ArrayListSerializer($serializer_getInstance_5());
  }
  function Companion_18() {
    Companion_instance_19 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    var tmp_1 = lazy(tmp_0, UserInfo$Companion$$childSerializers$_anonymous__nu26tt);
    var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.gwq_1 = [null, null, null, null, null, null, null, tmp_1, null, lazy(tmp_2, UserInfo$Companion$$childSerializers$_anonymous__nu26tt_0), null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null];
  }
  var Companion_instance_19;
  function Companion_getInstance_25() {
    if (Companion_instance_19 == null)
      new Companion_18();
    return Companion_instance_19;
  }
  function $serializer_6() {
    $serializer_instance_6 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.github.jan.supabase.auth.user.UserInfo', this, 27);
    tmp0_serialDesc.a7c('app_metadata', true);
    tmp0_serialDesc.a7c('aud', false);
    tmp0_serialDesc.a7c('confirmation_sent_at', true);
    tmp0_serialDesc.a7c('confirmed_at', true);
    tmp0_serialDesc.a7c('created_at', true);
    tmp0_serialDesc.a7c('email', true);
    tmp0_serialDesc.a7c('email_confirmed_at', true);
    tmp0_serialDesc.a7c('factors', true);
    tmp0_serialDesc.a7c('id', false);
    tmp0_serialDesc.a7c('identities', true);
    tmp0_serialDesc.a7c('last_sign_in_at', true);
    tmp0_serialDesc.a7c('phone', true);
    tmp0_serialDesc.a7c('role', true);
    tmp0_serialDesc.a7c('updated_at', true);
    tmp0_serialDesc.a7c('user_metadata', true);
    tmp0_serialDesc.a7c('phone_change_sent_at', true);
    tmp0_serialDesc.a7c('new_phone', true);
    tmp0_serialDesc.a7c('email_change_sent_at', true);
    tmp0_serialDesc.a7c('new_email', true);
    tmp0_serialDesc.a7c('invited_at', true);
    tmp0_serialDesc.a7c('recovery_sent_at', true);
    tmp0_serialDesc.a7c('phone_confirmed_at', true);
    tmp0_serialDesc.a7c('action_link', true);
    tmp0_serialDesc.a7c('is_anonymous', true);
    tmp0_serialDesc.a7c('is_sso_user', true);
    tmp0_serialDesc.a7c('banned_until', true);
    tmp0_serialDesc.a7c('deleted_at', true);
    this.hwq_1 = tmp0_serialDesc;
  }
  protoOf($serializer_6).iwq = function (encoder, value) {
    var tmp0_desc = this.hwq_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    var tmp2_cached = Companion_getInstance_25().gwq_1;
    if (tmp1_output.k76(tmp0_desc, 0) ? true : !(value.fwk_1 == null)) {
      tmp1_output.g76(tmp0_desc, 0, JsonObjectSerializer_getInstance(), value.fwk_1);
    }
    tmp1_output.c76(tmp0_desc, 1, value.gwk_1);
    if (tmp1_output.k76(tmp0_desc, 2) ? true : !(value.hwk_1 == null)) {
      tmp1_output.g76(tmp0_desc, 2, InstantSerializer_getInstance(), value.hwk_1);
    }
    if (tmp1_output.k76(tmp0_desc, 3) ? true : !(value.iwk_1 == null)) {
      tmp1_output.g76(tmp0_desc, 3, InstantSerializer_getInstance(), value.iwk_1);
    }
    if (tmp1_output.k76(tmp0_desc, 4) ? true : !(value.jwk_1 == null)) {
      tmp1_output.g76(tmp0_desc, 4, InstantSerializer_getInstance(), value.jwk_1);
    }
    if (tmp1_output.k76(tmp0_desc, 5) ? true : !(value.kwk_1 == null)) {
      tmp1_output.g76(tmp0_desc, 5, StringSerializer_getInstance(), value.kwk_1);
    }
    if (tmp1_output.k76(tmp0_desc, 6) ? true : !(value.lwk_1 == null)) {
      tmp1_output.g76(tmp0_desc, 6, InstantSerializer_getInstance(), value.lwk_1);
    }
    var tmp;
    if (tmp1_output.k76(tmp0_desc, 7)) {
      tmp = true;
    } else {
      // Inline function 'kotlin.collections.listOf' call
      var tmp$ret$0 = emptyList();
      tmp = !equals(value.mwk_1, tmp$ret$0);
    }
    if (tmp) {
      tmp1_output.e76(tmp0_desc, 7, tmp2_cached[7].u1(), value.mwk_1);
    }
    tmp1_output.c76(tmp0_desc, 8, value.nwk_1);
    if (tmp1_output.k76(tmp0_desc, 9) ? true : !(value.owk_1 == null)) {
      tmp1_output.g76(tmp0_desc, 9, tmp2_cached[9].u1(), value.owk_1);
    }
    if (tmp1_output.k76(tmp0_desc, 10) ? true : !(value.pwk_1 == null)) {
      tmp1_output.g76(tmp0_desc, 10, InstantSerializer_getInstance(), value.pwk_1);
    }
    if (tmp1_output.k76(tmp0_desc, 11) ? true : !(value.qwk_1 == null)) {
      tmp1_output.g76(tmp0_desc, 11, StringSerializer_getInstance(), value.qwk_1);
    }
    if (tmp1_output.k76(tmp0_desc, 12) ? true : !(value.rwk_1 == null)) {
      tmp1_output.g76(tmp0_desc, 12, StringSerializer_getInstance(), value.rwk_1);
    }
    if (tmp1_output.k76(tmp0_desc, 13) ? true : !(value.swk_1 == null)) {
      tmp1_output.g76(tmp0_desc, 13, InstantSerializer_getInstance(), value.swk_1);
    }
    if (tmp1_output.k76(tmp0_desc, 14) ? true : !(value.twk_1 == null)) {
      tmp1_output.g76(tmp0_desc, 14, JsonObjectSerializer_getInstance(), value.twk_1);
    }
    if (tmp1_output.k76(tmp0_desc, 15) ? true : !(value.uwk_1 == null)) {
      tmp1_output.g76(tmp0_desc, 15, InstantSerializer_getInstance(), value.uwk_1);
    }
    if (tmp1_output.k76(tmp0_desc, 16) ? true : !(value.vwk_1 == null)) {
      tmp1_output.g76(tmp0_desc, 16, StringSerializer_getInstance(), value.vwk_1);
    }
    if (tmp1_output.k76(tmp0_desc, 17) ? true : !(value.wwk_1 == null)) {
      tmp1_output.g76(tmp0_desc, 17, InstantSerializer_getInstance(), value.wwk_1);
    }
    if (tmp1_output.k76(tmp0_desc, 18) ? true : !(value.xwk_1 == null)) {
      tmp1_output.g76(tmp0_desc, 18, StringSerializer_getInstance(), value.xwk_1);
    }
    if (tmp1_output.k76(tmp0_desc, 19) ? true : !(value.ywk_1 == null)) {
      tmp1_output.g76(tmp0_desc, 19, InstantSerializer_getInstance(), value.ywk_1);
    }
    if (tmp1_output.k76(tmp0_desc, 20) ? true : !(value.zwk_1 == null)) {
      tmp1_output.g76(tmp0_desc, 20, InstantSerializer_getInstance(), value.zwk_1);
    }
    if (tmp1_output.k76(tmp0_desc, 21) ? true : !(value.awl_1 == null)) {
      tmp1_output.g76(tmp0_desc, 21, InstantSerializer_getInstance(), value.awl_1);
    }
    if (tmp1_output.k76(tmp0_desc, 22) ? true : !(value.bwl_1 == null)) {
      tmp1_output.g76(tmp0_desc, 22, StringSerializer_getInstance(), value.bwl_1);
    }
    if (tmp1_output.k76(tmp0_desc, 23) ? true : !(value.cwl_1 == null)) {
      tmp1_output.g76(tmp0_desc, 23, BooleanSerializer_getInstance(), value.cwl_1);
    }
    if (tmp1_output.k76(tmp0_desc, 24) ? true : !(value.dwl_1 == null)) {
      tmp1_output.g76(tmp0_desc, 24, BooleanSerializer_getInstance(), value.dwl_1);
    }
    if (tmp1_output.k76(tmp0_desc, 25) ? true : !(value.ewl_1 == null)) {
      tmp1_output.g76(tmp0_desc, 25, InstantSerializer_getInstance(), value.ewl_1);
    }
    if (tmp1_output.k76(tmp0_desc, 26) ? true : !(value.fwl_1 == null)) {
      tmp1_output.g76(tmp0_desc, 26, InstantSerializer_getInstance(), value.fwl_1);
    }
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_6).z70 = function (encoder, value) {
    return this.iwq(encoder, value instanceof UserInfo ? value : THROW_CCE());
  };
  protoOf($serializer_6).a71 = function (decoder) {
    var tmp0_desc = this.hwq_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_local12 = null;
    var tmp17_local13 = null;
    var tmp18_local14 = null;
    var tmp19_local15 = null;
    var tmp20_local16 = null;
    var tmp21_local17 = null;
    var tmp22_local18 = null;
    var tmp23_local19 = null;
    var tmp24_local20 = null;
    var tmp25_local21 = null;
    var tmp26_local22 = null;
    var tmp27_local23 = null;
    var tmp28_local24 = null;
    var tmp29_local25 = null;
    var tmp30_local26 = null;
    var tmp31_input = decoder.n74(tmp0_desc);
    var tmp32_cached = Companion_getInstance_25().gwq_1;
    if (tmp31_input.d75()) {
      tmp4_local0 = tmp31_input.b75(tmp0_desc, 0, JsonObjectSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp31_input.x74(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp31_input.b75(tmp0_desc, 2, InstantSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp31_input.b75(tmp0_desc, 3, InstantSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp31_input.b75(tmp0_desc, 4, InstantSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp31_input.b75(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp31_input.b75(tmp0_desc, 6, InstantSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp31_input.z74(tmp0_desc, 7, tmp32_cached[7].u1(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp31_input.x74(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp31_input.b75(tmp0_desc, 9, tmp32_cached[9].u1(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp31_input.b75(tmp0_desc, 10, InstantSerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp31_input.b75(tmp0_desc, 11, StringSerializer_getInstance(), tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp31_input.b75(tmp0_desc, 12, StringSerializer_getInstance(), tmp16_local12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp31_input.b75(tmp0_desc, 13, InstantSerializer_getInstance(), tmp17_local13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp31_input.b75(tmp0_desc, 14, JsonObjectSerializer_getInstance(), tmp18_local14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp31_input.b75(tmp0_desc, 15, InstantSerializer_getInstance(), tmp19_local15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
      tmp20_local16 = tmp31_input.b75(tmp0_desc, 16, StringSerializer_getInstance(), tmp20_local16);
      tmp3_bitMask0 = tmp3_bitMask0 | 65536;
      tmp21_local17 = tmp31_input.b75(tmp0_desc, 17, InstantSerializer_getInstance(), tmp21_local17);
      tmp3_bitMask0 = tmp3_bitMask0 | 131072;
      tmp22_local18 = tmp31_input.b75(tmp0_desc, 18, StringSerializer_getInstance(), tmp22_local18);
      tmp3_bitMask0 = tmp3_bitMask0 | 262144;
      tmp23_local19 = tmp31_input.b75(tmp0_desc, 19, InstantSerializer_getInstance(), tmp23_local19);
      tmp3_bitMask0 = tmp3_bitMask0 | 524288;
      tmp24_local20 = tmp31_input.b75(tmp0_desc, 20, InstantSerializer_getInstance(), tmp24_local20);
      tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
      tmp25_local21 = tmp31_input.b75(tmp0_desc, 21, InstantSerializer_getInstance(), tmp25_local21);
      tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
      tmp26_local22 = tmp31_input.b75(tmp0_desc, 22, StringSerializer_getInstance(), tmp26_local22);
      tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
      tmp27_local23 = tmp31_input.b75(tmp0_desc, 23, BooleanSerializer_getInstance(), tmp27_local23);
      tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
      tmp28_local24 = tmp31_input.b75(tmp0_desc, 24, BooleanSerializer_getInstance(), tmp28_local24);
      tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
      tmp29_local25 = tmp31_input.b75(tmp0_desc, 25, InstantSerializer_getInstance(), tmp29_local25);
      tmp3_bitMask0 = tmp3_bitMask0 | 33554432;
      tmp30_local26 = tmp31_input.b75(tmp0_desc, 26, InstantSerializer_getInstance(), tmp30_local26);
      tmp3_bitMask0 = tmp3_bitMask0 | 67108864;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp31_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp31_input.b75(tmp0_desc, 0, JsonObjectSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp31_input.x74(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp31_input.b75(tmp0_desc, 2, InstantSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp31_input.b75(tmp0_desc, 3, InstantSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp31_input.b75(tmp0_desc, 4, InstantSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp31_input.b75(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp31_input.b75(tmp0_desc, 6, InstantSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp31_input.z74(tmp0_desc, 7, tmp32_cached[7].u1(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp31_input.x74(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp31_input.b75(tmp0_desc, 9, tmp32_cached[9].u1(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp31_input.b75(tmp0_desc, 10, InstantSerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp31_input.b75(tmp0_desc, 11, StringSerializer_getInstance(), tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp31_input.b75(tmp0_desc, 12, StringSerializer_getInstance(), tmp16_local12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp31_input.b75(tmp0_desc, 13, InstantSerializer_getInstance(), tmp17_local13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp31_input.b75(tmp0_desc, 14, JsonObjectSerializer_getInstance(), tmp18_local14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp31_input.b75(tmp0_desc, 15, InstantSerializer_getInstance(), tmp19_local15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          case 16:
            tmp20_local16 = tmp31_input.b75(tmp0_desc, 16, StringSerializer_getInstance(), tmp20_local16);
            tmp3_bitMask0 = tmp3_bitMask0 | 65536;
            break;
          case 17:
            tmp21_local17 = tmp31_input.b75(tmp0_desc, 17, InstantSerializer_getInstance(), tmp21_local17);
            tmp3_bitMask0 = tmp3_bitMask0 | 131072;
            break;
          case 18:
            tmp22_local18 = tmp31_input.b75(tmp0_desc, 18, StringSerializer_getInstance(), tmp22_local18);
            tmp3_bitMask0 = tmp3_bitMask0 | 262144;
            break;
          case 19:
            tmp23_local19 = tmp31_input.b75(tmp0_desc, 19, InstantSerializer_getInstance(), tmp23_local19);
            tmp3_bitMask0 = tmp3_bitMask0 | 524288;
            break;
          case 20:
            tmp24_local20 = tmp31_input.b75(tmp0_desc, 20, InstantSerializer_getInstance(), tmp24_local20);
            tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
            break;
          case 21:
            tmp25_local21 = tmp31_input.b75(tmp0_desc, 21, InstantSerializer_getInstance(), tmp25_local21);
            tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
            break;
          case 22:
            tmp26_local22 = tmp31_input.b75(tmp0_desc, 22, StringSerializer_getInstance(), tmp26_local22);
            tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
            break;
          case 23:
            tmp27_local23 = tmp31_input.b75(tmp0_desc, 23, BooleanSerializer_getInstance(), tmp27_local23);
            tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
            break;
          case 24:
            tmp28_local24 = tmp31_input.b75(tmp0_desc, 24, BooleanSerializer_getInstance(), tmp28_local24);
            tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
            break;
          case 25:
            tmp29_local25 = tmp31_input.b75(tmp0_desc, 25, InstantSerializer_getInstance(), tmp29_local25);
            tmp3_bitMask0 = tmp3_bitMask0 | 33554432;
            break;
          case 26:
            tmp30_local26 = tmp31_input.b75(tmp0_desc, 26, InstantSerializer_getInstance(), tmp30_local26);
            tmp3_bitMask0 = tmp3_bitMask0 | 67108864;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp31_input.o74(tmp0_desc);
    return UserInfo_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, tmp22_local18, tmp23_local19, tmp24_local20, tmp25_local21, tmp26_local22, tmp27_local23, tmp28_local24, tmp29_local25, tmp30_local26, null);
  };
  protoOf($serializer_6).y70 = function () {
    return this.hwq_1;
  };
  protoOf($serializer_6).t7c = function () {
    var tmp0_cached = Companion_getInstance_25().gwq_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(JsonObjectSerializer_getInstance()), StringSerializer_getInstance(), get_nullable(InstantSerializer_getInstance()), get_nullable(InstantSerializer_getInstance()), get_nullable(InstantSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(InstantSerializer_getInstance()), tmp0_cached[7].u1(), StringSerializer_getInstance(), get_nullable(tmp0_cached[9].u1()), get_nullable(InstantSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(InstantSerializer_getInstance()), get_nullable(JsonObjectSerializer_getInstance()), get_nullable(InstantSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(InstantSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(InstantSerializer_getInstance()), get_nullable(InstantSerializer_getInstance()), get_nullable(InstantSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(InstantSerializer_getInstance()), get_nullable(InstantSerializer_getInstance())];
  };
  var $serializer_instance_6;
  function $serializer_getInstance_6() {
    if ($serializer_instance_6 == null)
      new $serializer_6();
    return $serializer_instance_6;
  }
  function UserInfo_init_$Init$(seen0, appMetadata, aud, confirmationSentAt, confirmedAt, createdAt, email, emailConfirmedAt, factors, id, identities, lastSignInAt, phone, role, updatedAt, userMetadata, phoneChangeSentAt, newPhone, emailChangeSentAt, newEmail, invitedAt, recoverySentAt, phoneConfirmedAt, actionLink, isAnonymous, isSSOUser, bannedUntil, deletedAt, serializationConstructorMarker, $this) {
    if (!(258 === (258 & seen0))) {
      throwMissingFieldException(seen0, 258, $serializer_getInstance_6().hwq_1);
    }
    if (0 === (seen0 & 1))
      $this.fwk_1 = null;
    else
      $this.fwk_1 = appMetadata;
    $this.gwk_1 = aud;
    if (0 === (seen0 & 4))
      $this.hwk_1 = null;
    else
      $this.hwk_1 = confirmationSentAt;
    if (0 === (seen0 & 8))
      $this.iwk_1 = null;
    else
      $this.iwk_1 = confirmedAt;
    if (0 === (seen0 & 16))
      $this.jwk_1 = null;
    else
      $this.jwk_1 = createdAt;
    if (0 === (seen0 & 32))
      $this.kwk_1 = null;
    else
      $this.kwk_1 = email;
    if (0 === (seen0 & 64))
      $this.lwk_1 = null;
    else
      $this.lwk_1 = emailConfirmedAt;
    if (0 === (seen0 & 128)) {
      var tmp = $this;
      // Inline function 'kotlin.collections.listOf' call
      tmp.mwk_1 = emptyList();
    } else
      $this.mwk_1 = factors;
    $this.nwk_1 = id;
    if (0 === (seen0 & 512))
      $this.owk_1 = null;
    else
      $this.owk_1 = identities;
    if (0 === (seen0 & 1024))
      $this.pwk_1 = null;
    else
      $this.pwk_1 = lastSignInAt;
    if (0 === (seen0 & 2048))
      $this.qwk_1 = null;
    else
      $this.qwk_1 = phone;
    if (0 === (seen0 & 4096))
      $this.rwk_1 = null;
    else
      $this.rwk_1 = role;
    if (0 === (seen0 & 8192))
      $this.swk_1 = null;
    else
      $this.swk_1 = updatedAt;
    if (0 === (seen0 & 16384))
      $this.twk_1 = null;
    else
      $this.twk_1 = userMetadata;
    if (0 === (seen0 & 32768))
      $this.uwk_1 = null;
    else
      $this.uwk_1 = phoneChangeSentAt;
    if (0 === (seen0 & 65536))
      $this.vwk_1 = null;
    else
      $this.vwk_1 = newPhone;
    if (0 === (seen0 & 131072))
      $this.wwk_1 = null;
    else
      $this.wwk_1 = emailChangeSentAt;
    if (0 === (seen0 & 262144))
      $this.xwk_1 = null;
    else
      $this.xwk_1 = newEmail;
    if (0 === (seen0 & 524288))
      $this.ywk_1 = null;
    else
      $this.ywk_1 = invitedAt;
    if (0 === (seen0 & 1048576))
      $this.zwk_1 = null;
    else
      $this.zwk_1 = recoverySentAt;
    if (0 === (seen0 & 2097152))
      $this.awl_1 = null;
    else
      $this.awl_1 = phoneConfirmedAt;
    if (0 === (seen0 & 4194304))
      $this.bwl_1 = null;
    else
      $this.bwl_1 = actionLink;
    if (0 === (seen0 & 8388608))
      $this.cwl_1 = null;
    else
      $this.cwl_1 = isAnonymous;
    if (0 === (seen0 & 16777216))
      $this.dwl_1 = null;
    else
      $this.dwl_1 = isSSOUser;
    if (0 === (seen0 & 33554432))
      $this.ewl_1 = null;
    else
      $this.ewl_1 = bannedUntil;
    if (0 === (seen0 & 67108864))
      $this.fwl_1 = null;
    else
      $this.fwl_1 = deletedAt;
    return $this;
  }
  function UserInfo_init_$Create$(seen0, appMetadata, aud, confirmationSentAt, confirmedAt, createdAt, email, emailConfirmedAt, factors, id, identities, lastSignInAt, phone, role, updatedAt, userMetadata, phoneChangeSentAt, newPhone, emailChangeSentAt, newEmail, invitedAt, recoverySentAt, phoneConfirmedAt, actionLink, isAnonymous, isSSOUser, bannedUntil, deletedAt, serializationConstructorMarker) {
    return UserInfo_init_$Init$(seen0, appMetadata, aud, confirmationSentAt, confirmedAt, createdAt, email, emailConfirmedAt, factors, id, identities, lastSignInAt, phone, role, updatedAt, userMetadata, phoneChangeSentAt, newPhone, emailChangeSentAt, newEmail, invitedAt, recoverySentAt, phoneConfirmedAt, actionLink, isAnonymous, isSSOUser, bannedUntil, deletedAt, serializationConstructorMarker, objectCreate(protoOf(UserInfo)));
  }
  function UserInfo(appMetadata, aud, confirmationSentAt, confirmedAt, createdAt, email, emailConfirmedAt, factors, id, identities, lastSignInAt, phone, role, updatedAt, userMetadata, phoneChangeSentAt, newPhone, emailChangeSentAt, newEmail, invitedAt, recoverySentAt, phoneConfirmedAt, actionLink, isAnonymous, isSSOUser, bannedUntil, deletedAt) {
    Companion_getInstance_25();
    appMetadata = appMetadata === VOID ? null : appMetadata;
    confirmationSentAt = confirmationSentAt === VOID ? null : confirmationSentAt;
    confirmedAt = confirmedAt === VOID ? null : confirmedAt;
    createdAt = createdAt === VOID ? null : createdAt;
    email = email === VOID ? null : email;
    emailConfirmedAt = emailConfirmedAt === VOID ? null : emailConfirmedAt;
    var tmp;
    if (factors === VOID) {
      // Inline function 'kotlin.collections.listOf' call
      tmp = emptyList();
    } else {
      tmp = factors;
    }
    factors = tmp;
    identities = identities === VOID ? null : identities;
    lastSignInAt = lastSignInAt === VOID ? null : lastSignInAt;
    phone = phone === VOID ? null : phone;
    role = role === VOID ? null : role;
    updatedAt = updatedAt === VOID ? null : updatedAt;
    userMetadata = userMetadata === VOID ? null : userMetadata;
    phoneChangeSentAt = phoneChangeSentAt === VOID ? null : phoneChangeSentAt;
    newPhone = newPhone === VOID ? null : newPhone;
    emailChangeSentAt = emailChangeSentAt === VOID ? null : emailChangeSentAt;
    newEmail = newEmail === VOID ? null : newEmail;
    invitedAt = invitedAt === VOID ? null : invitedAt;
    recoverySentAt = recoverySentAt === VOID ? null : recoverySentAt;
    phoneConfirmedAt = phoneConfirmedAt === VOID ? null : phoneConfirmedAt;
    actionLink = actionLink === VOID ? null : actionLink;
    isAnonymous = isAnonymous === VOID ? null : isAnonymous;
    isSSOUser = isSSOUser === VOID ? null : isSSOUser;
    bannedUntil = bannedUntil === VOID ? null : bannedUntil;
    deletedAt = deletedAt === VOID ? null : deletedAt;
    this.fwk_1 = appMetadata;
    this.gwk_1 = aud;
    this.hwk_1 = confirmationSentAt;
    this.iwk_1 = confirmedAt;
    this.jwk_1 = createdAt;
    this.kwk_1 = email;
    this.lwk_1 = emailConfirmedAt;
    this.mwk_1 = factors;
    this.nwk_1 = id;
    this.owk_1 = identities;
    this.pwk_1 = lastSignInAt;
    this.qwk_1 = phone;
    this.rwk_1 = role;
    this.swk_1 = updatedAt;
    this.twk_1 = userMetadata;
    this.uwk_1 = phoneChangeSentAt;
    this.vwk_1 = newPhone;
    this.wwk_1 = emailChangeSentAt;
    this.xwk_1 = newEmail;
    this.ywk_1 = invitedAt;
    this.zwk_1 = recoverySentAt;
    this.awl_1 = phoneConfirmedAt;
    this.bwl_1 = actionLink;
    this.cwl_1 = isAnonymous;
    this.dwl_1 = isSSOUser;
    this.ewl_1 = bannedUntil;
    this.fwl_1 = deletedAt;
  }
  protoOf(UserInfo).toString = function () {
    return 'UserInfo(appMetadata=' + toString(this.fwk_1) + ', aud=' + this.gwk_1 + ', confirmationSentAt=' + toString(this.hwk_1) + ', confirmedAt=' + toString(this.iwk_1) + ', createdAt=' + toString(this.jwk_1) + ', email=' + this.kwk_1 + ', emailConfirmedAt=' + toString(this.lwk_1) + ', factors=' + toString_0(this.mwk_1) + ', id=' + this.nwk_1 + ', identities=' + toString(this.owk_1) + ', lastSignInAt=' + toString(this.pwk_1) + ', phone=' + this.qwk_1 + ', role=' + this.rwk_1 + ', updatedAt=' + toString(this.swk_1) + ', userMetadata=' + toString(this.twk_1) + ', phoneChangeSentAt=' + toString(this.uwk_1) + ', newPhone=' + this.vwk_1 + ', emailChangeSentAt=' + toString(this.wwk_1) + ', newEmail=' + this.xwk_1 + ', invitedAt=' + toString(this.ywk_1) + ', recoverySentAt=' + toString(this.zwk_1) + ', phoneConfirmedAt=' + toString(this.awl_1) + ', actionLink=' + this.bwl_1 + ', isAnonymous=' + this.cwl_1 + ', isSSOUser=' + this.dwl_1 + ', bannedUntil=' + toString(this.ewl_1) + ', deletedAt=' + toString(this.fwl_1) + ')';
  };
  protoOf(UserInfo).hashCode = function () {
    var result = this.fwk_1 == null ? 0 : this.fwk_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.gwk_1) | 0;
    result = imul(result, 31) + (this.hwk_1 == null ? 0 : this.hwk_1.hashCode()) | 0;
    result = imul(result, 31) + (this.iwk_1 == null ? 0 : this.iwk_1.hashCode()) | 0;
    result = imul(result, 31) + (this.jwk_1 == null ? 0 : this.jwk_1.hashCode()) | 0;
    result = imul(result, 31) + (this.kwk_1 == null ? 0 : getStringHashCode(this.kwk_1)) | 0;
    result = imul(result, 31) + (this.lwk_1 == null ? 0 : this.lwk_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.mwk_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.nwk_1) | 0;
    result = imul(result, 31) + (this.owk_1 == null ? 0 : hashCode(this.owk_1)) | 0;
    result = imul(result, 31) + (this.pwk_1 == null ? 0 : this.pwk_1.hashCode()) | 0;
    result = imul(result, 31) + (this.qwk_1 == null ? 0 : getStringHashCode(this.qwk_1)) | 0;
    result = imul(result, 31) + (this.rwk_1 == null ? 0 : getStringHashCode(this.rwk_1)) | 0;
    result = imul(result, 31) + (this.swk_1 == null ? 0 : this.swk_1.hashCode()) | 0;
    result = imul(result, 31) + (this.twk_1 == null ? 0 : this.twk_1.hashCode()) | 0;
    result = imul(result, 31) + (this.uwk_1 == null ? 0 : this.uwk_1.hashCode()) | 0;
    result = imul(result, 31) + (this.vwk_1 == null ? 0 : getStringHashCode(this.vwk_1)) | 0;
    result = imul(result, 31) + (this.wwk_1 == null ? 0 : this.wwk_1.hashCode()) | 0;
    result = imul(result, 31) + (this.xwk_1 == null ? 0 : getStringHashCode(this.xwk_1)) | 0;
    result = imul(result, 31) + (this.ywk_1 == null ? 0 : this.ywk_1.hashCode()) | 0;
    result = imul(result, 31) + (this.zwk_1 == null ? 0 : this.zwk_1.hashCode()) | 0;
    result = imul(result, 31) + (this.awl_1 == null ? 0 : this.awl_1.hashCode()) | 0;
    result = imul(result, 31) + (this.bwl_1 == null ? 0 : getStringHashCode(this.bwl_1)) | 0;
    result = imul(result, 31) + (this.cwl_1 == null ? 0 : getBooleanHashCode(this.cwl_1)) | 0;
    result = imul(result, 31) + (this.dwl_1 == null ? 0 : getBooleanHashCode(this.dwl_1)) | 0;
    result = imul(result, 31) + (this.ewl_1 == null ? 0 : this.ewl_1.hashCode()) | 0;
    result = imul(result, 31) + (this.fwl_1 == null ? 0 : this.fwl_1.hashCode()) | 0;
    return result;
  };
  protoOf(UserInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UserInfo))
      return false;
    if (!equals(this.fwk_1, other.fwk_1))
      return false;
    if (!(this.gwk_1 === other.gwk_1))
      return false;
    if (!equals(this.hwk_1, other.hwk_1))
      return false;
    if (!equals(this.iwk_1, other.iwk_1))
      return false;
    if (!equals(this.jwk_1, other.jwk_1))
      return false;
    if (!(this.kwk_1 == other.kwk_1))
      return false;
    if (!equals(this.lwk_1, other.lwk_1))
      return false;
    if (!equals(this.mwk_1, other.mwk_1))
      return false;
    if (!(this.nwk_1 === other.nwk_1))
      return false;
    if (!equals(this.owk_1, other.owk_1))
      return false;
    if (!equals(this.pwk_1, other.pwk_1))
      return false;
    if (!(this.qwk_1 == other.qwk_1))
      return false;
    if (!(this.rwk_1 == other.rwk_1))
      return false;
    if (!equals(this.swk_1, other.swk_1))
      return false;
    if (!equals(this.twk_1, other.twk_1))
      return false;
    if (!equals(this.uwk_1, other.uwk_1))
      return false;
    if (!(this.vwk_1 == other.vwk_1))
      return false;
    if (!equals(this.wwk_1, other.wwk_1))
      return false;
    if (!(this.xwk_1 == other.xwk_1))
      return false;
    if (!equals(this.ywk_1, other.ywk_1))
      return false;
    if (!equals(this.zwk_1, other.zwk_1))
      return false;
    if (!equals(this.awl_1, other.awl_1))
      return false;
    if (!(this.bwl_1 == other.bwl_1))
      return false;
    if (!(this.cwl_1 == other.cwl_1))
      return false;
    if (!(this.dwl_1 == other.dwl_1))
      return false;
    if (!equals(this.ewl_1, other.ewl_1))
      return false;
    if (!equals(this.fwl_1, other.fwl_1))
      return false;
    return true;
  };
  function $serializer_7() {
    $serializer_instance_7 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.github.jan.supabase.auth.user.UserMfaFactor', this, 7);
    tmp0_serialDesc.a7c('id', false);
    tmp0_serialDesc.a7c('created_at', false);
    tmp0_serialDesc.a7c('updated_at', false);
    tmp0_serialDesc.a7c('status', false);
    tmp0_serialDesc.a7c('friendly_name', true);
    tmp0_serialDesc.a7c('factor_type', false);
    tmp0_serialDesc.a7c('last_challenged_at', true);
    this.jwq_1 = tmp0_serialDesc;
  }
  protoOf($serializer_7).kwq = function (encoder, value) {
    var tmp0_desc = this.jwq_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    tmp1_output.c76(tmp0_desc, 0, value.gwl_1);
    tmp1_output.e76(tmp0_desc, 1, InstantSerializer_getInstance(), value.hwl_1);
    tmp1_output.e76(tmp0_desc, 2, InstantSerializer_getInstance(), value.iwl_1);
    tmp1_output.c76(tmp0_desc, 3, value.jwl_1);
    if (tmp1_output.k76(tmp0_desc, 4) ? true : !(value.kwl_1 == null)) {
      tmp1_output.g76(tmp0_desc, 4, StringSerializer_getInstance(), value.kwl_1);
    }
    tmp1_output.c76(tmp0_desc, 5, value.lwl_1);
    if (tmp1_output.k76(tmp0_desc, 6) ? true : !(value.mwl_1 == null)) {
      tmp1_output.g76(tmp0_desc, 6, InstantSerializer_getInstance(), value.mwl_1);
    }
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_7).z70 = function (encoder, value) {
    return this.kwq(encoder, value instanceof UserMfaFactor ? value : THROW_CCE());
  };
  protoOf($serializer_7).a71 = function (decoder) {
    var tmp0_desc = this.jwq_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_input = decoder.n74(tmp0_desc);
    if (tmp11_input.d75()) {
      tmp4_local0 = tmp11_input.x74(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.z74(tmp0_desc, 1, InstantSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.z74(tmp0_desc, 2, InstantSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.x74(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.b75(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.x74(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.b75(tmp0_desc, 6, InstantSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.x74(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.z74(tmp0_desc, 1, InstantSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.z74(tmp0_desc, 2, InstantSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.x74(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.b75(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.x74(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.b75(tmp0_desc, 6, InstantSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp11_input.o74(tmp0_desc);
    return UserMfaFactor_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  };
  protoOf($serializer_7).y70 = function () {
    return this.jwq_1;
  };
  protoOf($serializer_7).t7c = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), InstantSerializer_getInstance(), InstantSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), get_nullable(InstantSerializer_getInstance())];
  };
  var $serializer_instance_7;
  function $serializer_getInstance_7() {
    if ($serializer_instance_7 == null)
      new $serializer_7();
    return $serializer_instance_7;
  }
  function UserMfaFactor_init_$Init$(seen0, id, createdAt, updatedAt, status, friendlyName, factorType, lastChallengedAt, serializationConstructorMarker, $this) {
    if (!(47 === (47 & seen0))) {
      throwMissingFieldException(seen0, 47, $serializer_getInstance_7().jwq_1);
    }
    $this.gwl_1 = id;
    $this.hwl_1 = createdAt;
    $this.iwl_1 = updatedAt;
    $this.jwl_1 = status;
    if (0 === (seen0 & 16))
      $this.kwl_1 = null;
    else
      $this.kwl_1 = friendlyName;
    $this.lwl_1 = factorType;
    if (0 === (seen0 & 64))
      $this.mwl_1 = null;
    else
      $this.mwl_1 = lastChallengedAt;
    return $this;
  }
  function UserMfaFactor_init_$Create$(seen0, id, createdAt, updatedAt, status, friendlyName, factorType, lastChallengedAt, serializationConstructorMarker) {
    return UserMfaFactor_init_$Init$(seen0, id, createdAt, updatedAt, status, friendlyName, factorType, lastChallengedAt, serializationConstructorMarker, objectCreate(protoOf(UserMfaFactor)));
  }
  function UserMfaFactor() {
  }
  protoOf(UserMfaFactor).nwl = function () {
    return this.jwl_1 === 'verified';
  };
  protoOf(UserMfaFactor).toString = function () {
    return 'UserMfaFactor(id=' + this.gwl_1 + ', createdAt=' + this.hwl_1.toString() + ', updatedAt=' + this.iwl_1.toString() + ', status=' + this.jwl_1 + ', friendlyName=' + this.kwl_1 + ', factorType=' + this.lwl_1 + ', lastChallengedAt=' + toString(this.mwl_1) + ')';
  };
  protoOf(UserMfaFactor).hashCode = function () {
    var result = getStringHashCode(this.gwl_1);
    result = imul(result, 31) + this.hwl_1.hashCode() | 0;
    result = imul(result, 31) + this.iwl_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.jwl_1) | 0;
    result = imul(result, 31) + (this.kwl_1 == null ? 0 : getStringHashCode(this.kwl_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.lwl_1) | 0;
    result = imul(result, 31) + (this.mwl_1 == null ? 0 : this.mwl_1.hashCode()) | 0;
    return result;
  };
  protoOf(UserMfaFactor).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UserMfaFactor))
      return false;
    if (!(this.gwl_1 === other.gwl_1))
      return false;
    if (!this.hwl_1.equals(other.hwl_1))
      return false;
    if (!this.iwl_1.equals(other.iwl_1))
      return false;
    if (!(this.jwl_1 === other.jwl_1))
      return false;
    if (!(this.kwl_1 == other.kwl_1))
      return false;
    if (!(this.lwl_1 === other.lwl_1))
      return false;
    if (!equals(this.mwl_1, other.mwl_1))
      return false;
    return true;
  };
  function Companion_19() {
  }
  var Companion_instance_20;
  function Companion_getInstance_26() {
    return Companion_instance_20;
  }
  function $serializer_8() {
    $serializer_instance_8 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.github.jan.supabase.auth.user.UserSession', this, 9);
    tmp0_serialDesc.a7c('access_token', false);
    tmp0_serialDesc.a7c('refresh_token', false);
    tmp0_serialDesc.a7c('provider_refresh_token', true);
    tmp0_serialDesc.a7c('provider_token', true);
    tmp0_serialDesc.a7c('expires_in', false);
    tmp0_serialDesc.a7c('token_type', false);
    tmp0_serialDesc.a7c('user', true);
    tmp0_serialDesc.a7c('type', true);
    tmp0_serialDesc.a7c('expiresAt', true);
    this.lwq_1 = tmp0_serialDesc;
  }
  protoOf($serializer_8).mwq = function (encoder, value) {
    var tmp0_desc = this.lwq_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    tmp1_output.c76(tmp0_desc, 0, value.pvw_1);
    tmp1_output.c76(tmp0_desc, 1, value.qvw_1);
    if (tmp1_output.k76(tmp0_desc, 2) ? true : !(value.rvw_1 == null)) {
      tmp1_output.g76(tmp0_desc, 2, StringSerializer_getInstance(), value.rvw_1);
    }
    if (tmp1_output.k76(tmp0_desc, 3) ? true : !(value.svw_1 == null)) {
      tmp1_output.g76(tmp0_desc, 3, StringSerializer_getInstance(), value.svw_1);
    }
    tmp1_output.y75(tmp0_desc, 4, value.tvw_1);
    tmp1_output.c76(tmp0_desc, 5, value.uvw_1);
    if (tmp1_output.k76(tmp0_desc, 6) ? true : !(value.vvw_1 == null)) {
      tmp1_output.g76(tmp0_desc, 6, $serializer_getInstance_6(), value.vvw_1);
    }
    if (tmp1_output.k76(tmp0_desc, 7) ? true : !(value.wvw_1 === '')) {
      tmp1_output.c76(tmp0_desc, 7, value.wvw_1);
    }
    var tmp;
    if (tmp1_output.k76(tmp0_desc, 8)) {
      tmp = true;
    } else {
      var tmp_0 = System_instance.fp();
      Companion_getInstance_1();
      // Inline function 'kotlin.time.Companion.seconds' call
      var this_0 = value.tvw_1;
      var tmp$ret$0 = toDuration_0(this_0, DurationUnit_SECONDS_getInstance());
      tmp = !value.xvw_1.equals(tmp_0.xp(tmp$ret$0));
    }
    if (tmp) {
      tmp1_output.e76(tmp0_desc, 8, InstantSerializer_getInstance(), value.xvw_1);
    }
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_8).z70 = function (encoder, value) {
    return this.mwq(encoder, value instanceof UserSession ? value : THROW_CCE());
  };
  protoOf($serializer_8).a71 = function (decoder) {
    var tmp0_desc = this.lwq_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = new Long(0, 0);
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_input = decoder.n74(tmp0_desc);
    if (tmp13_input.d75()) {
      tmp4_local0 = tmp13_input.x74(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp13_input.x74(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp13_input.b75(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp13_input.b75(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp13_input.t74(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp13_input.x74(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp13_input.b75(tmp0_desc, 6, $serializer_getInstance_6(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp13_input.x74(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp13_input.z74(tmp0_desc, 8, InstantSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp13_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp13_input.x74(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp13_input.x74(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp13_input.b75(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp13_input.b75(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp13_input.t74(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp13_input.x74(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp13_input.b75(tmp0_desc, 6, $serializer_getInstance_6(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp13_input.x74(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp13_input.z74(tmp0_desc, 8, InstantSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp13_input.o74(tmp0_desc);
    return UserSession_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
  };
  protoOf($serializer_8).y70 = function () {
    return this.lwq_1;
  };
  protoOf($serializer_8).t7c = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), LongSerializer_getInstance(), StringSerializer_getInstance(), get_nullable($serializer_getInstance_6()), StringSerializer_getInstance(), InstantSerializer_getInstance()];
  };
  var $serializer_instance_8;
  function $serializer_getInstance_8() {
    if ($serializer_instance_8 == null)
      new $serializer_8();
    return $serializer_instance_8;
  }
  function UserSession_init_$Init$(seen0, accessToken, refreshToken, providerRefreshToken, providerToken, expiresIn, tokenType, user, type, expiresAt, serializationConstructorMarker, $this) {
    if (!(51 === (51 & seen0))) {
      throwMissingFieldException(seen0, 51, $serializer_getInstance_8().lwq_1);
    }
    $this.pvw_1 = accessToken;
    $this.qvw_1 = refreshToken;
    if (0 === (seen0 & 4))
      $this.rvw_1 = null;
    else
      $this.rvw_1 = providerRefreshToken;
    if (0 === (seen0 & 8))
      $this.svw_1 = null;
    else
      $this.svw_1 = providerToken;
    $this.tvw_1 = expiresIn;
    $this.uvw_1 = tokenType;
    if (0 === (seen0 & 64))
      $this.vvw_1 = null;
    else
      $this.vvw_1 = user;
    if (0 === (seen0 & 128))
      $this.wvw_1 = '';
    else
      $this.wvw_1 = type;
    if (0 === (seen0 & 256)) {
      var tmp = $this;
      var tmp_0 = System_instance.fp();
      Companion_getInstance_1();
      // Inline function 'kotlin.time.Companion.seconds' call
      var this_0 = $this.tvw_1;
      var tmp$ret$0 = toDuration_0(this_0, DurationUnit_SECONDS_getInstance());
      tmp.xvw_1 = tmp_0.xp(tmp$ret$0);
    } else
      $this.xvw_1 = expiresAt;
    return $this;
  }
  function UserSession_init_$Create$(seen0, accessToken, refreshToken, providerRefreshToken, providerToken, expiresIn, tokenType, user, type, expiresAt, serializationConstructorMarker) {
    return UserSession_init_$Init$(seen0, accessToken, refreshToken, providerRefreshToken, providerToken, expiresIn, tokenType, user, type, expiresAt, serializationConstructorMarker, objectCreate(protoOf(UserSession)));
  }
  function UserSession(accessToken, refreshToken, providerRefreshToken, providerToken, expiresIn, tokenType, user, type, expiresAt) {
    providerRefreshToken = providerRefreshToken === VOID ? null : providerRefreshToken;
    providerToken = providerToken === VOID ? null : providerToken;
    user = user === VOID ? null : user;
    type = type === VOID ? '' : type;
    var tmp;
    if (expiresAt === VOID) {
      var tmp_0 = System_instance.fp();
      // Inline function 'kotlin.time.Companion.seconds' call
      Companion_getInstance_1();
      var tmp$ret$0 = toDuration_0(expiresIn, DurationUnit_SECONDS_getInstance());
      tmp = tmp_0.xp(tmp$ret$0);
    } else {
      tmp = expiresAt;
    }
    expiresAt = tmp;
    this.pvw_1 = accessToken;
    this.qvw_1 = refreshToken;
    this.rvw_1 = providerRefreshToken;
    this.svw_1 = providerToken;
    this.tvw_1 = expiresIn;
    this.uvw_1 = tokenType;
    this.vvw_1 = user;
    this.wvw_1 = type;
    this.xvw_1 = expiresAt;
  }
  protoOf(UserSession).nwq = function (accessToken, refreshToken, providerRefreshToken, providerToken, expiresIn, tokenType, user, type, expiresAt) {
    return new UserSession(accessToken, refreshToken, providerRefreshToken, providerToken, expiresIn, tokenType, user, type, expiresAt);
  };
  protoOf(UserSession).hw7 = function (accessToken, refreshToken, providerRefreshToken, providerToken, expiresIn, tokenType, user, type, expiresAt, $super) {
    accessToken = accessToken === VOID ? this.pvw_1 : accessToken;
    refreshToken = refreshToken === VOID ? this.qvw_1 : refreshToken;
    providerRefreshToken = providerRefreshToken === VOID ? this.rvw_1 : providerRefreshToken;
    providerToken = providerToken === VOID ? this.svw_1 : providerToken;
    expiresIn = expiresIn === VOID ? this.tvw_1 : expiresIn;
    tokenType = tokenType === VOID ? this.uvw_1 : tokenType;
    user = user === VOID ? this.vvw_1 : user;
    type = type === VOID ? this.wvw_1 : type;
    expiresAt = expiresAt === VOID ? this.xvw_1 : expiresAt;
    return $super === VOID ? this.nwq(accessToken, refreshToken, providerRefreshToken, providerToken, expiresIn, tokenType, user, type, expiresAt) : $super.nwq.call(this, accessToken, refreshToken, providerRefreshToken, providerToken, expiresIn, tokenType, user, type, expiresAt);
  };
  protoOf(UserSession).toString = function () {
    return 'UserSession(accessToken=' + this.pvw_1 + ', refreshToken=' + this.qvw_1 + ', providerRefreshToken=' + this.rvw_1 + ', providerToken=' + this.svw_1 + ', expiresIn=' + this.tvw_1.toString() + ', tokenType=' + this.uvw_1 + ', user=' + toString(this.vvw_1) + ', type=' + this.wvw_1 + ', expiresAt=' + this.xvw_1.toString() + ')';
  };
  protoOf(UserSession).hashCode = function () {
    var result = getStringHashCode(this.pvw_1);
    result = imul(result, 31) + getStringHashCode(this.qvw_1) | 0;
    result = imul(result, 31) + (this.rvw_1 == null ? 0 : getStringHashCode(this.rvw_1)) | 0;
    result = imul(result, 31) + (this.svw_1 == null ? 0 : getStringHashCode(this.svw_1)) | 0;
    result = imul(result, 31) + this.tvw_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.uvw_1) | 0;
    result = imul(result, 31) + (this.vvw_1 == null ? 0 : this.vvw_1.hashCode()) | 0;
    result = imul(result, 31) + getStringHashCode(this.wvw_1) | 0;
    result = imul(result, 31) + this.xvw_1.hashCode() | 0;
    return result;
  };
  protoOf(UserSession).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UserSession))
      return false;
    if (!(this.pvw_1 === other.pvw_1))
      return false;
    if (!(this.qvw_1 === other.qvw_1))
      return false;
    if (!(this.rvw_1 == other.rvw_1))
      return false;
    if (!(this.svw_1 == other.svw_1))
      return false;
    if (!equalsLong(this.tvw_1, other.tvw_1))
      return false;
    if (!(this.uvw_1 === other.uvw_1))
      return false;
    if (!equals(this.vvw_1, other.vvw_1))
      return false;
    if (!(this.wvw_1 === other.wvw_1))
      return false;
    if (!this.xvw_1.equals(other.xvw_1))
      return false;
    return true;
  };
  function Companion_20() {
  }
  var Companion_instance_21;
  function Companion_getInstance_27() {
    return Companion_instance_21;
  }
  function $serializer_9() {
    $serializer_instance_9 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.github.jan.supabase.auth.user.UserUpdateBuilder', this, 6);
    tmp0_serialDesc.a7c('email', true);
    tmp0_serialDesc.a7c('password', true);
    tmp0_serialDesc.a7c('phone', true);
    tmp0_serialDesc.a7c('nonce', true);
    tmp0_serialDesc.a7c('data', true);
    tmp0_serialDesc.a7c('currentPassword', true);
    this.owq_1 = tmp0_serialDesc;
  }
  protoOf($serializer_9).pwq = function (encoder, value) {
    var tmp0_desc = this.owq_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    if (tmp1_output.k76(tmp0_desc, 0) ? true : !(value.qwq_1 == null)) {
      tmp1_output.g76(tmp0_desc, 0, StringSerializer_getInstance(), value.qwq_1);
    }
    if (tmp1_output.k76(tmp0_desc, 1) ? true : !(value.rwq_1 == null)) {
      tmp1_output.g76(tmp0_desc, 1, StringSerializer_getInstance(), value.rwq_1);
    }
    if (tmp1_output.k76(tmp0_desc, 2) ? true : !(value.swq_1 == null)) {
      tmp1_output.g76(tmp0_desc, 2, StringSerializer_getInstance(), value.swq_1);
    }
    if (tmp1_output.k76(tmp0_desc, 3) ? true : !(value.twq_1 == null)) {
      tmp1_output.g76(tmp0_desc, 3, StringSerializer_getInstance(), value.twq_1);
    }
    if (tmp1_output.k76(tmp0_desc, 4) ? true : !(value.uwq_1 == null)) {
      tmp1_output.g76(tmp0_desc, 4, JsonObjectSerializer_getInstance(), value.uwq_1);
    }
    if (tmp1_output.k76(tmp0_desc, 5) ? true : !(value.vwq_1 == null)) {
      tmp1_output.g76(tmp0_desc, 5, StringSerializer_getInstance(), value.vwq_1);
    }
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer_9).z70 = function (encoder, value) {
    return this.pwq(encoder, value instanceof UserUpdateBuilder ? value : THROW_CCE());
  };
  protoOf($serializer_9).a71 = function (decoder) {
    var tmp0_desc = this.owq_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp11_input = decoder.n74(tmp0_desc);
    if (tmp11_input.d75()) {
      tmp4_local0 = tmp11_input.b75(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.b75(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.b75(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.b75(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.b75(tmp0_desc, 4, JsonObjectSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.b75(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.b75(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.b75(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.b75(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.b75(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.b75(tmp0_desc, 4, JsonObjectSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.b75(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp11_input.o74(tmp0_desc);
    return UserUpdateBuilder_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  protoOf($serializer_9).y70 = function () {
    return this.owq_1;
  };
  protoOf($serializer_9).t7c = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(JsonObjectSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_9;
  function $serializer_getInstance_9() {
    if ($serializer_instance_9 == null)
      new $serializer_9();
    return $serializer_instance_9;
  }
  function UserUpdateBuilder_init_$Init$(seen0, email, password, phone, nonce, data, currentPassword, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_9().owq_1);
    }
    if (0 === (seen0 & 1))
      $this.qwq_1 = null;
    else
      $this.qwq_1 = email;
    if (0 === (seen0 & 2))
      $this.rwq_1 = null;
    else
      $this.rwq_1 = password;
    if (0 === (seen0 & 4))
      $this.swq_1 = null;
    else
      $this.swq_1 = phone;
    if (0 === (seen0 & 8))
      $this.twq_1 = null;
    else
      $this.twq_1 = nonce;
    if (0 === (seen0 & 16))
      $this.uwq_1 = null;
    else
      $this.uwq_1 = data;
    if (0 === (seen0 & 32))
      $this.vwq_1 = null;
    else
      $this.vwq_1 = currentPassword;
    $this.wwq_1 = new KotlinXSerializer();
    return $this;
  }
  function UserUpdateBuilder_init_$Create$(seen0, email, password, phone, nonce, data, currentPassword, serializationConstructorMarker) {
    return UserUpdateBuilder_init_$Init$(seen0, email, password, phone, nonce, data, currentPassword, serializationConstructorMarker, objectCreate(protoOf(UserUpdateBuilder)));
  }
  function UserUpdateBuilder(email, password, phone, nonce, data, currentPassword, serializer) {
    email = email === VOID ? null : email;
    password = password === VOID ? null : password;
    phone = phone === VOID ? null : phone;
    nonce = nonce === VOID ? null : nonce;
    data = data === VOID ? null : data;
    currentPassword = currentPassword === VOID ? null : currentPassword;
    serializer = serializer === VOID ? new KotlinXSerializer() : serializer;
    this.qwq_1 = email;
    this.rwq_1 = password;
    this.swq_1 = phone;
    this.twq_1 = nonce;
    this.uwq_1 = data;
    this.vwq_1 = currentPassword;
    this.wwq_1 = serializer;
  }
  protoOf(UserUpdateBuilder).toString = function () {
    return 'UserUpdateBuilder(email=' + this.qwq_1 + ', password=' + this.rwq_1 + ', phone=' + this.swq_1 + ', nonce=' + this.twq_1 + ', data=' + toString(this.uwq_1) + ', currentPassword=' + this.vwq_1 + ', serializer=' + toString_0(this.wwq_1) + ')';
  };
  protoOf(UserUpdateBuilder).hashCode = function () {
    var result = this.qwq_1 == null ? 0 : getStringHashCode(this.qwq_1);
    result = imul(result, 31) + (this.rwq_1 == null ? 0 : getStringHashCode(this.rwq_1)) | 0;
    result = imul(result, 31) + (this.swq_1 == null ? 0 : getStringHashCode(this.swq_1)) | 0;
    result = imul(result, 31) + (this.twq_1 == null ? 0 : getStringHashCode(this.twq_1)) | 0;
    result = imul(result, 31) + (this.uwq_1 == null ? 0 : this.uwq_1.hashCode()) | 0;
    result = imul(result, 31) + (this.vwq_1 == null ? 0 : getStringHashCode(this.vwq_1)) | 0;
    result = imul(result, 31) + hashCode(this.wwq_1) | 0;
    return result;
  };
  protoOf(UserUpdateBuilder).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UserUpdateBuilder))
      return false;
    if (!(this.qwq_1 == other.qwq_1))
      return false;
    if (!(this.rwq_1 == other.rwq_1))
      return false;
    if (!(this.swq_1 == other.swq_1))
      return false;
    if (!(this.twq_1 == other.twq_1))
      return false;
    if (!equals(this.uwq_1, other.uwq_1))
      return false;
    if (!(this.vwq_1 == other.vwq_1))
      return false;
    if (!equals(this.wwq_1, other.wwq_1))
      return false;
    return true;
  };
  function startExternalAuth(_this__u8e3s4, redirectUrl, getUrl, onSessionSuccess, $completion) {
    var tmp = new $startExternalAuthCOROUTINE$(_this__u8e3s4, redirectUrl, getUrl, onSessionSuccess, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function $startExternalAuthCOROUTINE$(_this__u8e3s4, redirectUrl, getUrl, onSessionSuccess, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.fwr_1 = _this__u8e3s4;
    this.gwr_1 = redirectUrl;
    this.hwr_1 = getUrl;
    this.iwr_1 = onSessionSuccess;
  }
  protoOf($startExternalAuthCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.kwr_1 = this.fwr_1.ebw().nvx_1;
            this.jwr_1 = this.fwr_1.yvn();
            this.n9_1 = 1;
            suspendResult = this.hwr_1(this.gwr_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.n9_1 = 2;
            suspendResult = this.kwr_1.fwd(this.jwr_1, ARGUMENT, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function checkForOldCodeVerifier($this) {
    if ($this.mwr_1 === 'supabase_code_verifier')
      return Unit_instance;
    var oldSession = $this.lwr_1.xvt('supabase_code_verifier');
    var newSession = $this.lwr_1.xvt($this.mwr_1);
    if (!(oldSession == null) && newSession == null) {
      $this.lwr_1.wvt($this.mwr_1, oldSession);
      $this.lwr_1.jsq('supabase_code_verifier');
    }
  }
  function Companion_21() {
    this.owr_1 = 'supabase_code_verifier';
  }
  var Companion_instance_22;
  function Companion_getInstance_28() {
    return Companion_instance_22;
  }
  function SettingsCodeVerifierCache(settings, key) {
    settings = settings === VOID ? createDefaultSettings() : settings;
    key = key === VOID ? 'supabase_code_verifier' : key;
    this.lwr_1 = settings;
    this.mwr_1 = key;
    checkForOldCodeVerifier(this);
    this.nwr_1 = toSuspendSettings(this.lwr_1);
  }
  protoOf(SettingsCodeVerifierCache).ow6 = function (codeVerifier, $completion) {
    return this.nwr_1.kvv(this.mwr_1, codeVerifier, $completion);
  };
  protoOf(SettingsCodeVerifierCache).gw9 = function ($completion) {
    return this.nwr_1.lvv(this.mwr_1, $completion);
  };
  protoOf(SettingsCodeVerifierCache).hw9 = function ($completion) {
    return this.nwr_1.jvv(this.mwr_1, $completion);
  };
  function get_settingsJson() {
    _init_properties_SettingsSessionManager_kt__lkngre();
    return settingsJson;
  }
  var settingsJson;
  function checkForOldSession($this) {
    if ($this.qwr_1 === 'session')
      return Unit_instance;
    var oldSession = $this.pwr_1.xvt('session');
    var newSession = $this.pwr_1.xvt($this.qwr_1);
    if (!(oldSession == null) && newSession == null) {
      $this.pwr_1.wvt($this.qwr_1, oldSession);
      $this.pwr_1.jsq('session');
    }
  }
  function Companion_22() {
    this.twr_1 = 'session';
  }
  var Companion_instance_23;
  function Companion_getInstance_29() {
    return Companion_instance_23;
  }
  function $loadSessionCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.cws_1 = _this__u8e3s4;
  }
  protoOf($loadSessionCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.n9_1 = 1;
            suspendResult = this.cws_1.swr_1.lvv(this.cws_1.qwr_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_elvis_lhs = suspendResult;
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return null;
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var session = tmp_0;
            this.o9_1 = 2;
            var tmp_1 = this;
            var this_0 = this.cws_1.rwr_1;
            var this_1 = this_0.c75();
            var this_2 = serializer(this_1, createKType(getKClass(UserSession), arrayOf([]), true));
            tmp_1.dws_1 = this_0.c72(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), session);
            this.o9_1 = 4;
            this.n9_1 = 3;
            continue $sm;
          case 2:
            this.o9_1 = 4;
            var tmp_2 = this.q9_1;
            if (tmp_2 instanceof Exception) {
              var e = this.q9_1;
              var tmp_3 = this;
              ensureActive(this.t9());
              var tmp0 = Companion_getInstance_6().wvx_1;
              var level = LogLevel_ERROR_getInstance();
              var tmp0_elvis_lhs_0 = tmp0.fsu();
              if (level.i3(tmp0_elvis_lhs_0 == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs_0) >= 0) {
                tmp0.fvj(level, e, 'Failed to load session');
              }
              tmp_3.dws_1 = null;
              this.n9_1 = 3;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 3:
            this.o9_1 = 4;
            return this.dws_1;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 4) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function SettingsSessionManager(settings, key, json) {
    settings = settings === VOID ? createDefaultSettings() : settings;
    key = key === VOID ? 'session' : key;
    json = json === VOID ? get_settingsJson() : json;
    this.pwr_1 = settings;
    this.qwr_1 = key;
    this.rwr_1 = json;
    checkForOldSession(this);
    this.swr_1 = toSuspendSettings(this.pwr_1);
  }
  protoOf(SettingsSessionManager).iw7 = function (session, $completion) {
    // Inline function 'kotlinx.serialization.json.Json.encodeToString' call
    var this_0 = this.rwr_1;
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.c75();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(UserSession), arrayOf([]), false));
    var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
    var tmp$ret$0 = this_0.b72(tmp$ret$1, session);
    return this.swr_1.kvv(this.qwr_1, tmp$ret$0, $completion);
  };
  protoOf(SettingsSessionManager).gwb = function ($completion) {
    var tmp = new $loadSessionCOROUTINE$(this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(SettingsSessionManager).dwc = function ($completion) {
    return this.swr_1.jvv(this.qwr_1, $completion);
  };
  function settingsJson$lambda($this$Json) {
    _init_properties_SettingsSessionManager_kt__lkngre();
    $this$Json.dmh_1 = true;
    return Unit_instance;
  }
  var properties_initialized_SettingsSessionManager_kt_diah30;
  function _init_properties_SettingsSessionManager_kt__lkngre() {
    if (!properties_initialized_SettingsSessionManager_kt_diah30) {
      properties_initialized_SettingsSessionManager_kt_diah30 = true;
      settingsJson = Json(VOID, settingsJson$lambda);
    }
  }
  function createDefaultSessionManager(_this__u8e3s4) {
    return !PlatformUtils_getInstance().osp_1 ? new SettingsSessionManager(VOID, createDefaultSettingsKey(_this__u8e3s4.yvn().rvj()) + '-session') : new MemorySessionManager();
  }
  function createDefaultCodeVerifierCache(_this__u8e3s4) {
    return !PlatformUtils_getInstance().osp_1 ? new SettingsCodeVerifierCache(VOID, createDefaultSettingsKey(_this__u8e3s4.yvn().rvj()) + '-supabase_code_verifier') : new MemoryCodeVerifierCache();
  }
  function createDefaultSettingsKey(supabaseUrl) {
    return 'sb-' + replace_0(replace_0(removeSuffix(supabaseUrl, '/'), _Char___init__impl__6a9atx(47), _Char___init__impl__6a9atx(45)), _Char___init__impl__6a9atx(46), _Char___init__impl__6a9atx(45));
  }
  function createDefaultSettings() {
    var tmp;
    try {
      tmp = Settings();
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Exception) {
        var e = $p;
        // Inline function 'kotlin.error' call
        var message = 'Failed to create default settings for SettingsSessionManager. You might have to provide a custom settings instance or a custom session manager. Learn more at https://github.com/supabase-community/supabase-kt/wiki/Session-Saving';
        throw IllegalStateException_init_$Create$(toString_0(message));
      } else {
        throw $p;
      }
    }
    return tmp;
  }
  function AuthConfig() {
    AuthConfigDefaults.call(this);
    this.yws_1 = false;
    this.zws_1 = PlatformUtils_getInstance().nsp_1 ? new BrowserBridgeImpl() : null;
  }
  function BrowserBridgeImpl(window_0) {
    window_0 = window_0 === VOID ? window : window_0;
    this.awt_1 = window_0;
  }
  protoOf(BrowserBridgeImpl).bwt = function () {
    return this.awt_1.location.hash;
  };
  protoOf(BrowserBridgeImpl).cwt = function () {
    return this.awt_1.location.href;
  };
  protoOf(BrowserBridgeImpl).dwt = function (newUrl) {
    this.awt_1.history.replaceState(null, this.awt_1.document.title, newUrl);
  };
  function defaultPlatformRedirectUrl(_this__u8e3s4) {
    return PlatformUtils_getInstance().nsp_1 ? window.location.origin : null;
  }
  function openExternalUrl(_this__u8e3s4, url, $completion) {
    if (PlatformUtils_getInstance().nsp_1) {
      window.location.href = url;
    }
    return Unit_instance;
  }
  function ExternalAuthConfig() {
    ExternalAuthConfigDefaults.call(this);
  }
  function setupPlatform(_this__u8e3s4, $completion) {
    var tmp = new $setupPlatformCOROUTINE$(_this__u8e3s4, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function checkForPKCECode(_this__u8e3s4, bridge) {
    var url = new URL(bridge.cwt());
    if (handledUrlParameterError(_this__u8e3s4, checkForPKCECode$lambda(url))) {
      cleanQueryParams(bridge);
      return null;
    }
    var tmp0_elvis_lhs = url.searchParams.get('code');
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var code = tmp;
    cleanQueryParams(bridge);
    return code;
  }
  function handlePKCECode(_this__u8e3s4, code, $completion) {
    var tmp = new $handlePKCECodeCOROUTINE$(_this__u8e3s4, code, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function checkForHash(_this__u8e3s4, bridge) {
    if (isBlank(bridge.bwt()))
      return null;
    var afterHash = substring(bridge.bwt(), 1);
    if (!contains(afterHash, _Char___init__impl__6a9atx(61)))
      return null;
    // Inline function 'io.github.jan.supabase.logging.d' call
    var tmp0 = Companion_getInstance_6().wvx_1;
    // Inline function 'io.github.jan.supabase.logging.SupabaseLogger.log' call
    var level = LogLevel_DEBUG_getInstance();
    var tmp0_elvis_lhs = tmp0.fsu();
    if (level.i3(tmp0_elvis_lhs == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs) >= 0) {
      var tmp$ret$2 = 'Found hash: ' + afterHash;
      tmp0.fvj(level, null, tmp$ret$2);
    }
    var result = validateHash(_this__u8e3s4, afterHash);
    var tmp;
    var tmp_0;
    if (result instanceof SessionFound) {
      tmp_0 = true;
    } else {
      tmp_0 = equals(result, ErrorFound_instance);
    }
    if (tmp_0) {
      cleanHash(bridge);
      var tmp0_safe_receiver = result instanceof SessionFound ? result : null;
      tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.vwp_1;
    } else {
      if (equals(result, Skipped_instance)) {
        tmp = null;
      } else {
        noWhenBranchMatchedException();
      }
    }
    return tmp;
  }
  function handleHashSession(_this__u8e3s4, session, $completion) {
    var tmp = new $handleHashSessionCOROUTINE$(_this__u8e3s4, session, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function cleanQueryParams(bridge) {
    var newURL = consumeUrlParameter(Companion_getInstance_6().uvx_1, bridge.cwt());
    bridge.dwt(newURL);
  }
  function cleanHash(bridge) {
    var newURL = consumeHashParameters(Companion_getInstance_6().tvx_1, bridge.cwt());
    bridge.dwt(newURL);
  }
  function checkForPKCECode$lambda($url) {
    return function (it) {
      return $url.searchParams.get(it);
    };
  }
  function $setupPlatformCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.mwt_1 = _this__u8e3s4;
  }
  protoOf($setupPlatformCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            if (PlatformUtils_getInstance().nsp_1 && !this.mwt_1.ebw().yws_1 && !(this.mwt_1.ebw().zws_1 == null)) {
              var tmp0 = this.mwt_1.ebw().hvx_1.a1_1;
              if (tmp0 === 1) {
                var tmp0_0 = Companion_getInstance_6().wvx_1;
                var level = LogLevel_DEBUG_getInstance();
                var tmp0_elvis_lhs = tmp0_0.fsu();
                if (level.i3(tmp0_elvis_lhs == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs) >= 0) {
                  tmp0_0.fvj(level, null, 'Using PCKE flow type, checking for PCKE code...');
                }
                var tmp1_elvis_lhs = checkForPKCECode(this.mwt_1, ensureNotNull(this.mwt_1.ebw().zws_1));
                var tmp_0;
                if (tmp1_elvis_lhs == null) {
                  initDone(this.mwt_1);
                  return Unit_instance;
                } else {
                  tmp_0 = tmp1_elvis_lhs;
                }
                var code = tmp_0;
                this.n9_1 = 2;
                suspendResult = handlePKCECode(this.mwt_1, code, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (tmp0 === 0) {
                  var tmp0_1 = Companion_getInstance_6().wvx_1;
                  var level_0 = LogLevel_DEBUG_getInstance();
                  var tmp0_elvis_lhs_0 = tmp0_1.fsu();
                  if (level_0.i3(tmp0_elvis_lhs_0 == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs_0) >= 0) {
                    tmp0_1.fvj(level_0, null, 'Using IMPLICIT flow type, checking for hash...');
                  }
                  var tmp2_elvis_lhs = checkForHash(this.mwt_1, ensureNotNull(this.mwt_1.ebw().zws_1));
                  var tmp_1;
                  if (tmp2_elvis_lhs == null) {
                    initDone(this.mwt_1);
                    return Unit_instance;
                  } else {
                    tmp_1 = tmp2_elvis_lhs;
                  }
                  var sessionInHash = tmp_1;
                  this.n9_1 = 1;
                  suspendResult = handleHashSession(this.mwt_1, sessionInHash, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  noWhenBranchMatchedException();
                }
              }
            } else {
              initDone(this.mwt_1);
              this.n9_1 = 4;
              continue $sm;
            }

            break;
          case 1:
            this.n9_1 = 3;
            continue $sm;
          case 2:
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.n9_1 = 4;
            continue $sm;
          case 4:
            return Unit_instance;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $handlePKCECodeCOROUTINE$(_this__u8e3s4, code, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.vwt_1 = _this__u8e3s4;
    this.wwt_1 = code;
  }
  protoOf($handlePKCECodeCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            var tmp0 = Companion_getInstance_6().wvx_1;
            var level = LogLevel_DEBUG_getInstance();
            var tmp0_elvis_lhs = tmp0.fsu();
            if (level.i3(tmp0_elvis_lhs == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs) >= 0) {
              tmp0.fvj(level, null, 'Found PCKE code: ' + this.wwt_1);
            }

            this.o9_1 = 3;
            this.n9_1 = 1;
            suspendResult = this.vwt_1.kvz(this.wwt_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var session = suspendResult;
            this.n9_1 = 2;
            suspendResult = this.vwt_1.gvz(session, VOID, External_instance, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.o9_1 = 5;
            this.n9_1 = 4;
            continue $sm;
          case 3:
            this.o9_1 = 5;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Exception) {
              var e = this.q9_1;
              var tmp0_0 = Companion_getInstance_6().wvx_1;
              var level_0 = LogLevel_WARNING_getInstance();
              var tmp0_elvis_lhs_0 = tmp0_0.fsu();
              if (level_0.i3(tmp0_elvis_lhs_0 == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs_0) >= 0) {
                tmp0_0.fvj(level_0, e, 'Failed to exchange PCKE code for session');
              }
              this.n9_1 = 4;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 4:
            this.o9_1 = 5;
            initDone(this.vwt_1);
            return Unit_instance;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 5) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function $handleHashSessionCOROUTINE$(_this__u8e3s4, session, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.fwu_1 = _this__u8e3s4;
    this.gwu_1 = session;
  }
  protoOf($handleHashSessionCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.n9_1 = 1;
            suspendResult = tryToGetUser(this.fwu_1, this.gwu_1.pvw_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var user = suspendResult;
            var newSession = this.gwu_1.hw7(VOID, VOID, VOID, VOID, VOID, VOID, user);
            this.n9_1 = 2;
            suspendResult = this.fwu_1.gvz(newSession, VOID, External_instance, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  //region block: post-declaration
  protoOf(Companion).pvl = setup;
  protoOf(AuthImpl).xvy = signInWith$default;
  protoOf(AuthImpl).vvy = signUpWith$default;
  protoOf(AuthImpl).zvy = updateUser$default;
  protoOf(AuthImpl).bvz = resetPasswordForEmail$default;
  protoOf(AuthImpl).evz = signOut$default;
  protoOf(AuthImpl).kvz = exchangeCodeForSession$default;
  protoOf(AuthImpl).gvz = importSession$default;
  protoOf(AuthImpl).mvz = getOAuthUrl$default;
  protoOf(AuthImpl).nvw = currentAccessTokenOrNull;
  protoOf(AuthImpl).ovw = currentSessionOrNull;
  protoOf(AuthImpl).qvz = currentUserOrNull;
  protoOf(AuthImpl).vvn = resolveUrl;
  protoOf($serializer).u7c = typeParametersSerializers;
  protoOf($serializer_0).u7c = typeParametersSerializers;
  protoOf($serializer_1).u7c = typeParametersSerializers;
  protoOf(MfaApiImpl).cwj = getAuthenticatorAssuranceLevel$default;
  protoOf($serializer_2).u7c = typeParametersSerializers;
  protoOf(Email).nwc = login;
  protoOf(Email).owc = signUp;
  protoOf($serializer_3).u7c = typeParametersSerializers;
  protoOf(IDToken).nwc = login;
  protoOf(IDToken).owc = signUp;
  protoOf($serializer_4).u7c = typeParametersSerializers;
  protoOf(Phone).nwc = login;
  protoOf(Phone).owc = signUp;
  protoOf($serializer_5).u7c = typeParametersSerializers;
  protoOf($serializer_6).u7c = typeParametersSerializers;
  protoOf($serializer_7).u7c = typeParametersSerializers;
  protoOf($serializer_8).u7c = typeParametersSerializers;
  protoOf($serializer_9).u7c = typeParametersSerializers;
  //endregion
  //region block: init
  Companion_instance_4 = new Companion_3();
  Companion_instance_5 = new Companion_4();
  Companion_instance_6 = new Companion_5();
  Companion_instance_7 = new Companion_6();
  Companion_instance_13 = new Companion_12();
  Companion_instance_15 = new Companion_14();
  Email_instance = new Email();
  Companion_instance_16 = new Companion_15();
  IDToken_instance = new IDToken();
  Companion_instance_17 = new Companion_16();
  Phone_instance = new Phone();
  Storage_instance = new Storage();
  External_instance = new External();
  Unknown_instance = new Unknown();
  Initializing_instance = new Initializing();
  ErrorFound_instance = new ErrorFound();
  Skipped_instance = new Skipped();
  Companion_instance_20 = new Companion_19();
  Companion_instance_21 = new Companion_20();
  Companion_instance_22 = new Companion_21();
  Companion_instance_23 = new Companion_22();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = JWTUtils_getInstance;
  _.$_$.b = Email_instance;
  _.$_$.c = IDToken_instance;
  _.$_$.d = Google_getInstance;
  _.$_$.e = Companion_getInstance_6;
  _.$_$.f = resolveAccessToken_0;
  _.$_$.g = authenticatedSupabaseApi;
  _.$_$.h = Authenticated;
  _.$_$.i = NotAuthenticated;
  _.$_$.j = SessionStatus;
  _.$_$.k = UserSession;
  _.$_$.l = Auth;
  _.$_$.m = get_auth;
  _.$_$.n = parseSessionFromUrl;
  //endregion
  return _;
}));

//# sourceMappingURL=supabase-kt-auth-kt.js.map
